
/* ---- theme.js ---- */
(function(){
function toggleTheme(){var d=document.documentElement;if(d.hasAttribute('data-theme-fest'))return;var t=d.getAttribute('data-theme')==='dark'?'light':'dark';d.setAttribute('data-theme',t);try{localStorage.setItem('wtheme',t)}catch(e){}icon(t)}
function icon(t){var b=document.getElementById('themeBtn');if(!b)return;b.innerHTML=t==='dark'
?'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4"/></svg>'
:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>'}
// SEO-Radar-Anpassung (Entscheid E4, 26.08.2026): traegt das <html> die Marke
// data-theme-fest hat Vorrang und fasst localStorage nicht an. Andernfalls
// liefert data-theme-quelle="konto" das Theme aus users.ui_prefs; localStorage
// ist dann nur Flacker-Cache. Ohne diese Marken gilt localStorage wie gehabt;
// 'medium' (Theme Grau) ist als dritter Wert zugelassen.
(function(){var d=document.documentElement;if(d.hasAttribute('data-theme-fest')){var f=d.getAttribute('data-theme-fest');d.setAttribute('data-theme',f);icon(f);return}if(d.hasAttribute('data-theme-quelle')){var s=d.getAttribute('data-theme')||'light';try{localStorage.setItem('wtheme',s)}catch(e){}icon(s);return}var t='light';try{t=localStorage.getItem('wtheme')||'light'}catch(e){}if(t!=='dark'&&t!=='medium')t='light';d.setAttribute('data-theme',t);icon(t)})();
// SEO-Radar-Anpassung (27.08.2026): Inhaltsbreite aus users.ui_prefs. Frueher
// als style="--inhalt-breite:…" am <html> gerendert — das blockierte die CSP
// (style-src 'nonce' laesst keine Style-ATTRIBUTE zu), die Einstellung kam nie
// an. Jetzt traegt <html> data-breite und die Variable wird hier per CSSOM
// gesetzt (element.style ist unter CSP erlaubt).
// ZWEI VARIABLEN AUS EINER ZAHL (05.09.2026). --inhalt-breite ist der
// Prozent-Deckel der Buehne und darf NIE ueber 100 gehen: .content.sr-body
// setzt damit width UND max-width, 140 % waeren eine Seite breiter als das
// Fenster samt waagerechter Leiste. Der Wert ueber 100 wirkt allein ueber
// --inhalt-faktor in die Buehnen-Stufe (sr.css) hinein — dort hebt er den
// festen Pixeldeckel an, bis das min() bei 100 % der Buehne uebernimmt.
// ZWEI EINHEITEN (06.09.2026): data-breite-einheit="px" setzt eine feste
// Obergrenze in Pixeln (600–4000) statt des Prozent-Faktors. Der Faktor wird
// dann aus der Pixelzahl gegen die Arbeitsbuehne (1136 px, sr.css) gerechnet,
// damit die Lese- und Uebersichtsstufen im selben Verhaeltnis mitwachsen —
// und --inhalt-breite deckelt zusaetzlich Seiten ohne Stufe auf genau diese
// Pixelzahl. Dieselbe Rechnung steht in app.js (Schieber); hier laeuft sie
// VOR dem ersten Bild, damit nichts springt.
(function(){var d=document.documentElement,b=parseInt(d.getAttribute('data-breite'),10),px=parseInt(d.getAttribute('data-breite-px'),10),e=d.getAttribute('data-breite-einheit');
if(e==='px'&&px>=600&&px<=4000){d.style.setProperty('--inhalt-breite','min(100%,'+px+'px)');d.style.setProperty('--sr-kopf-breite','min(100%,calc('+px+'px - 2 * var(--sr-kopf-seitenrand)))');d.style.setProperty('--inhalt-faktor',String(px/1136*0.9));return}
if(b>=50&&b<=200){d.style.setProperty('--inhalt-breite',Math.min(b,100)+'%');d.style.removeProperty('--sr-kopf-breite');d.style.setProperty('--inhalt-faktor',String(b/100));}})();

// RADAR-SIGNET NACH FUENF SEKUNDEN ANHALTEN (Veto 6 des Designsystems,
// WCAG 2.2.2: eine Bewegung ueber fuenf Sekunden muss anhaltbar sein). Die
// CSS-Regeln in sr.css/app.css lassen die Schleife nur noch EINMAL laufen —
// die laengste Kette (Punkt 3, 2,55 s Verzoegerung + 4,2 s) endete damit
// aber erst nach 6,75 s. Diese Klasse schneidet den Rest bei 5 s ab.
// Bei reduzierter Bewegung laeuft von Anfang an nichts (eigener Block in
// sr.css) — der Timer schadet dort nicht, er schaltet nur Stillstand fest.
(function(){var d=document.documentElement;setTimeout(function(){d.classList.add('sr-signet-still');},5000);})();

// SEO-Radar-Anpassung: Listener statt onclick-Attribut — die App laeuft unter
// strikter CSP (Nonce), Inline-Event-Handler waeren dort blockiert.
(function(){var b=document.getElementById('themeBtn');if(b)b.addEventListener('click',toggleTheme);})();

// Mobile-Menü: Drawer öffnen/schließen (drawer-usage, modal-escape, reduced-motion)
var _burger=document.getElementById('navBurger'),_backdrop=document.getElementById('navBackdrop'),_side=document.getElementById('sidebar');
var _mq=window.matchMedia('(max-width:900px)');
// Runde 5 (30.08.2026): WIEDER NUR EIN STREIFEN. R3 hatte die Schublade am
// Rahmen .sr-app geoeffnet, weil Icon-Leiste UND Navigationsspalte gemeinsam
// hereinfahren mussten. Die Leiste ist ersatzlos entfallen — die Klasse
// wandert damit zurueck an die Spalte selbst (.sr-nav.open in sr.css); der
// Rahmen traegt keinen Zustand mehr.
function setMenu(open){if(!_side)return;_side.classList.toggle('open',open);if(_backdrop)_backdrop.classList.toggle('show',open);if(_burger){_burger.setAttribute('aria-expanded',open?'true':'false');_burger.setAttribute('aria-label',open?'Menü schließen':'Menü öffnen');}}
if(_burger)_burger.addEventListener('click',function(){setMenu(!(_side&&_side.classList.contains('open')));});
if(_backdrop)_backdrop.addEventListener('click',function(){setMenu(false);});
document.addEventListener('keydown',function(e){if(e.key==='Escape')setMenu(false);});
// SEO-Radar-Anpassung: die Sidebar traegt seit dem Navigations-Umbau
// (30.07.2026) nur noch echte Seitenwechsel (/, /projekt/x, …) — Sprungmarken
// samt Akkordeon/Scroll-Spy sind mit der neuen Kapitel-Leiste entfallen (app.js).
// Hier bleibt nur: Schublade bei Klick auf einen Navigationspunkt schliessen.
[].slice.call(document.querySelectorAll('.sidebar a.nav-item, .sr-nav a.nav-item')).forEach(function(a){
  a.addEventListener('click',function(){ if(_mq.matches)setMenu(false); });
});

})();

/* ---- app.js ---- */
(function(){
/* SEO-Radar — App-eigenes JavaScript (Ergaenzung zu theme.js aus der Vorlage).
 *
 * Bewusst getrennt: theme.js ist Haus-Vorlage und soll so unveraendert wie
 * moeglich bleiben. Alles, was es nur in dieser App gibt, steht hier.
 *
 * Laeuft unter strikter CSP mit Nonce — deshalb ausschliesslich addEventListener,
 * keine Inline-Attribute, und kein einziger externer Aufruf.
 *
 * Inhalt (Power-Workbench, 30.07.2026 — 7-9 ergaenzt im Navigations-Umbau):
 *   1. Dropdown-Koordinator fuer Glocke, Mega-Menue und Darstellung.
 *   3. Seitenleisten-Akkordeon fuer Projekte und Verwaltung (exklusiver Zustand,
 *      Escape und Pfeiltasten, gemeinsame Auf-/Zu-Animation).
 *   4. Stufenlose Inhaltsbreite (Range-Regler im Zahnrad; ui_prefs am Konto,
 *      localStorage nur Flacker-Cache — Stufe 2, Entscheid E4).
 *   5. Theme/Tabellendichte im Zahnrad (drei Themes, zwei Dichten; wie 4
 *      sofort wirksam und per POST /konto/einstellungen gespeichert).
 *   6. XL-Tabellen: Scroll-Schatten, sticky erste Spalte bei Bedarf,
 *      klick-sortierbare Spalten (deutsche Zahlen-/Datumsformate).
 *   7. Kapitel-Tabs — reichert die von layout.js gebaute Kapitel-Leiste zu
 *      einer echten role=tablist-Tableiste an: genau ein Panel sichtbar,
 *      Slide-Indikator, Pfeiltasten, Hash-Sync (Direktaufruf + Zurueck-Taste),
 *      gerichteter Panel-Wechsel. Ohne diese Funktion bleiben alle Kapitel
 *      sichtbar (progressive enhancement) — sie baut darauf auf, nicht dagegen.
 *   8. Kennzahl-Karten: Zahlen zaehlen beim ersten Sichtbarwerden hoch.
 *   9. Diagramme: Linien/Sparklines zeichnen sich beim ersten Sichtbarwerden ein.
 *  10. DashboardMaster-Fassade (Feature 3, Stufe A, 01.08.2026): Click-to-Load
 *      fuer eingebettete DBM-Dashboards, siehe Kopfkommentar dort.
 *  13. Anbindungen-Sofortlauf (Runde 5, 27.08.2026): startet definierte
 *      Sync-Laeufe und streamt deren Live-Protokoll (SSE) in die Konsole.
 *  14. Kommandopalette (AP2 „App-Gefühl", 28.08.2026): Strg/Cmd+K oeffnet ein
 *      zentriertes Such-Modal ueber Kapitel/Seiten/Projekte, rein clientseitig
 *      aus der schon gerenderten Navigation eingesammelt — kein eigener
 *      Server-Endpunkt. Einen zeigbaren Knopf gibt es seit dem 08.09.2026
 *      nicht mehr (Begruendung am Baustein selbst).
 *  15. Keyword-Drawer (K3/AP2): Die native Drawer-Implementierung liegt in
 *      app/views/keyword-drawer.js; sie wird als eigenes Asset geladen und
 *      ist an die data-row-url-Links der Keyword-Tabelle gebunden.
 */

/* ---------------------------------------------------- 1) Dropdown-Koordinator */
var seoDropdowns = [];

/**
 * Registriert ein auf-/zuklappbares Kopfzeilen-Menue nach einheitlichem Muster.
 * @param {{btn:HTMLElement, panel:HTMLElement, wrap:HTMLElement, onOeffnen?:Function}} o
 */
function seoDropdown(o) {
  var btn = o.btn, panel = o.panel, wrap = o.wrap;

  function offen() { return !panel.hasAttribute('hidden'); }

  function setzen(auf) {
    if (auf) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
    btn.setAttribute('aria-expanded', auf ? 'true' : 'false');
    wrap.classList.toggle('open', auf);
    if (auf && typeof o.onOeffnen === 'function') o.onOeffnen();
  }

  var api = { offen: offen, setzen: setzen, btn: btn, panel: panel, wrap: wrap };
  seoDropdowns.push(api);

  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    var will = !offen();
    // Andere offene Menues schliessen, bevor dieses sich oeffnet — sonst
    // stehen mehrere Kopf- und Seitenleisten-Menues gleichzeitig offen, weil jedes
    // seinen eigenen Klick per stopPropagation() vor dem anderen abschirmt.
    seoDropdowns.forEach(function (d) { if (d !== api && d.offen()) d.setzen(false); });
    setzen(will);
  });

  document.addEventListener('click', function (e) {
    if (!offen()) return;
    if (wrap.contains(e.target) || panel.contains(e.target)) return;
    setzen(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && offen()) { setzen(false); btn.focus(); }
  });

  // Tab aus dem Menue heraus schliesst es ebenfalls (sonst bleibt ein offenes
  // Menue hinter dem Fokus zurueck und verdeckt den Inhalt).
  panel.addEventListener('focusout', function () {
    window.setTimeout(function () {
      if (offen() && !wrap.contains(document.activeElement) && !panel.contains(document.activeElement)) setzen(false);
    }, 0);
  });

  return api;
}

/* ------------------------------------------------------ 2b) Glocken-Flyout */
(function () {
  var btn = document.getElementById('glockeBtn');
  var drop = document.getElementById('glockeDrop');
  var wrap = document.getElementById('glockeMenu');
  if (!btn || !drop || !wrap) return;
  seoDropdown({ btn: btn, panel: drop, wrap: wrap });
})();

/* Projektwahl des Kommunikators: Modell und Denkstufe aus den bereits
   freigegebenen Abo-Optionen des Formulars nachfuehren. Gilt fuer die
   Projektwahl und fuer jedes Formular der Wahl je Bereich. */
(function () {
  var block = document.querySelector('[data-kmz-block]');
  if (!block) return;
  function option(select, wert, label) {
    var eintrag = document.createElement('option');
    eintrag.value = wert;
    eintrag.textContent = label;
    select.appendChild(eintrag);
  }
  function verdrahten(formular) {
    var profil = formular.querySelector('[data-kmz-profil]');
    var modell = formular.querySelector('[data-kmz-modell]');
    var stufe = formular.querySelector('[data-kmz-stufe]');
    var bestaetigt = formular.querySelector('[data-kmz-bestaetigt]');
    if (!profil || !modell || !stufe) return;
    function geaendert() { if (bestaetigt) bestaetigt.value = '1'; }
    function daten(feld, standard) {
      var gewaehlt = profil.options[profil.selectedIndex];
      try { return JSON.parse(gewaehlt && gewaehlt.getAttribute(feld) || ''); } catch (_) { return standard; }
    }
    function stufenAktualisieren() {
      var vorher = stufe.value;
      var alle = daten('data-stufen', {});
      var liste = Array.isArray(alle[modell.value]) ? alle[modell.value] : [];
      stufe.replaceChildren();
      option(stufe, '', 'Standard');
      liste.forEach(function (wert) { option(stufe, wert, wert); });
      stufe.value = liste.includes(vorher) ? vorher : '';
      stufe.disabled = !profil.value;
    }
    profil.addEventListener('change', function () {
      geaendert();
      var modelle = daten('data-modelle', []);
      modell.replaceChildren();
      modelle.forEach(function (m) { option(modell, m.id, m.label || m.id); });
      modell.disabled = !profil.value || !modelle.length;
      stufenAktualisieren();
    });
    modell.addEventListener('change', function () { geaendert(); stufenAktualisieren(); });
    stufe.addEventListener('change', geaendert);
  }
  [].slice.call(block.querySelectorAll('[data-kmz-wahl-form],[data-kmz-bereich-form]')).forEach(verdrahten);
})();

/* ----------------------------------------- 3) Seitenleisten-Akkordeon */
(function () {
  var reduziert = window.matchMedia('(prefers-reduced-motion: reduce)');
  var eintraege = [];
  var aktiver = null;

  function registrieren(wrap, btn, panel) {
    if (!wrap || !btn || !panel) return;
    var eintrag = { wrap: wrap, btn: btn, panel: panel, animation: null, lauf: 0 };
    var anfangsOffen = btn.getAttribute('aria-expanded') === 'true' && !panel.hidden;
    eintraege.push(eintrag);

    function animationStoppen() {
      eintrag.lauf++;
      if (eintrag.animation) eintrag.animation.cancel();
      eintrag.animation = null;
      panel.style.height = '';
      panel.style.opacity = '';
      panel.style.overflow = '';
    }

    function sofort(auf) {
      animationStoppen();
      btn.setAttribute('aria-expanded', auf ? 'true' : 'false');
      wrap.classList.toggle('open', auf);
      panel.inert = !auf;
      panel.hidden = !auf;
      if (!auf && aktiver === eintrag) aktiver = null;
      if (auf) aktiver = eintrag;
    }

    function setzen(auf, ohneAnimation) {
      if (auf && aktiver && aktiver !== eintrag) aktiver.sofort(false);
      var startHoehe = panel.hidden ? 0 : panel.getBoundingClientRect().height;
      animationStoppen();
      var lauf = eintrag.lauf;
      btn.setAttribute('aria-expanded', auf ? 'true' : 'false');
      wrap.classList.toggle('open', auf);
      panel.inert = !auf;
      if (!auf && panel.contains(document.activeElement)) btn.focus();

      if (auf) {
        panel.hidden = false;
        aktiver = eintrag;
      } else if (aktiver === eintrag) {
        aktiver = null;
      }
      if (ohneAnimation || reduziert.matches || !panel.animate) {
        panel.hidden = !auf;
        return;
      }

      /* Erst im offenen Layout messen: So respektiert die Zielhoehe auch die
         Begrenzung des Projektbereichs durch max-height und den Viewport. */
      var zielHoehe = auf ? panel.getBoundingClientRect().height : 0;
      if (auf && zielHoehe === 0) zielHoehe = panel.scrollHeight;
      panel.style.height = startHoehe + 'px';
      panel.style.overflow = 'hidden';
      eintrag.animation = panel.animate([
        { height: startHoehe + 'px', opacity: auf ? Math.min(1, startHoehe / Math.max(1, zielHoehe)) : 1 },
        { height: zielHoehe + 'px', opacity: auf ? 1 : 0 }
      ], {
        duration: auf ? 220 : 160,
        easing: 'cubic-bezier(.2,.8,.2,1)',
        fill: 'both'
      });
      eintrag.animation.finished.then(function () {
        if (lauf !== eintrag.lauf) return;
        panel.hidden = !auf;
        animationStoppen();
      }, function () {});
    }

    eintrag.sofort = sofort;
    eintrag.setzen = setzen;
    sofort(anfangsOffen);
    btn.addEventListener('click', function () {
      setzen(btn.getAttribute('aria-expanded') !== 'true');
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
      e.preventDefault(); e.stopPropagation();
      setzen(true);
      var links = panel.querySelectorAll('a');
      var link = e.key === 'ArrowUp' ? links[links.length - 1] : links[0];
      if (link) link.focus();
    });
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        e.preventDefault(); e.stopPropagation(); setzen(false); btn.focus(); return;
      }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = [].slice.call(panel.querySelectorAll('a'));
      var idx = links.indexOf(document.activeElement);
      if (idx < 0 || !links.length) return;
      e.preventDefault();
      links[(idx + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
    });
  }

  registrieren(document.getElementById('megaWrap'), document.getElementById('megaBtn'), document.getElementById('megaPanel'));
  var verwaltung = document.getElementById('navVerwaltung');
  registrieren(verwaltung, verwaltung && verwaltung.querySelector('.nav-verwaltung-kopf'), document.getElementById('navVerwaltungListe'));
  if (reduziert.addEventListener) reduziert.addEventListener('change', function () {
    eintraege.forEach(function (eintrag) {
      eintrag.sofort(eintrag.btn.getAttribute('aria-expanded') === 'true');
    });
  });
})();

/* --------------------------------------- 3b) Zahnrad-Dropdown (Stufe 2, E6) */
(function () {
  var btn = document.getElementById('zahnradBtn');
  var drop = document.getElementById('zahnradDrop');
  var wrap = document.getElementById('zahnrad');
  if (btn && drop && wrap) seoDropdown({ btn: btn, panel: drop, wrap: wrap });
})();

/* Kontopanel im Seitenleistenfuss: dieselbe Mechanik wie das Darstellungs-Panel
   (Klick oeffnet, Klick ausserhalb / Escape / Fokus heraus schliesst). */
(function () {
  var btn = document.getElementById('kontoBtn');
  var drop = document.getElementById('kontoDrop');
  var wrap = document.getElementById('kontoMenue');
  if (btn && drop && wrap) seoDropdown({ btn: btn, panel: drop, wrap: wrap });
})();

/**
 * Einstellungen am Konto speichern (E4): die DB ist die Wahrheit, localStorage
 * nur Flacker-Cache. Liest IMMER alle drei Werte vom <html>-Element (dort hat
 * der Server sie gerendert, dort schreibt jede Aenderung sie fort) — ein
 * Teil-Update kann so nie die uebrigen Einstellungen ueberschreiben.
 * CSRF wie bei jedem POST der App: Token aus dem Abmelde-Formular, hier als
 * Kopfzeile x-csrf-token (auth.csrfOk() akzeptiert beide Wege).
 */
function seoPrefsSpeichern() {
  var d = document.documentElement;
  if (!d.hasAttribute('data-theme-quelle')) return; // ohne Anmeldung traegt nur localStorage
  var feld = document.querySelector('.usermenu-form input[name="_csrf"]');
  /* Der Rohwert steht am <html> als data-breite und NICHT in
     --inhalt-breite: die Variable ist seit dem 05.09.2026 bei 100 % gedeckelt
     (alles darueber wirkt ueber --inhalt-faktor). Wer sie hier auslaese,
     schriebe jede Einstellung ueber 100 beim naechsten Speichern auf 100
     zurueck — der Schieber sprang beim Neuladen zurueck, ohne Fehlermeldung. */
  var breite = parseInt(d.getAttribute('data-breite'), 10) || 90;
  // Pixelbreite und Einheit (06.09.2026) reisen mit — app/lib/ui-prefs.js
  // haelt beide Werte, damit ein Wechsel der Einheit nichts verliert.
  var breitePx = parseInt(d.getAttribute('data-breite-px'), 10) || 1136;
  var einheit = d.getAttribute('data-breite-einheit') === 'px' ? 'px' : 'prozent';
  fetch('/konto/einstellungen', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'x-csrf-token': feld ? feld.value : '' },
    body: 'theme=' + encodeURIComponent(d.getAttribute('data-theme') || 'light')
      + '&breite=' + breite
      + '&breitePx=' + breitePx
      + '&breiteEinheit=' + einheit
      + '&dichte=' + encodeURIComponent(d.getAttribute('data-density') || 'komfortabel')
      + '&kpi=' + encodeURIComponent(d.getAttribute('data-kpi') || 'normal')
  }).catch(function () { /* Ansicht gilt trotzdem; beim naechsten Laden greift die DB */ });
}

/* ------------------------------------------------- 4) Stufenlose Inhaltsbreite */
(function () {
  var slider = document.getElementById('breiteSlider');
  var wert = document.getElementById('breiteWert');
  if (!slider) return;

  /* DIE ZAHL AM SCHIEBER IST GEMESSEN, NICHT BEHAUPTET (Betreiber-Befund
     05.09.2026: „100 % geht man von browserbreite aus"). Der Schieber
     stellt einen Faktor, herauskommt eine Pixelbreite — und zwischen beiden
     liegen die Buehnen-Stufen aus theme.css. Angezeigt wird deshalb, was
     das <main> nach dem Setzen tatsaechlich breit ist. Erreicht es die
     volle verfuegbare Flaeche, steht „voll" dabei: dann bringt weiteres
     Schieben nichts mehr, und das soll man sehen statt zu suchen. */
  var buehne = document.querySelector('main.content.sr-body');

  function gemessen() {
    if (!buehne) return null;
    var breit = Math.round(buehne.getBoundingClientRect().width);
    var eltern = buehne.parentElement;
    // clientWidth statt getBoundingClientRect: der Elternrahmen kann eine
    // Bildlaufleiste tragen, die nicht zur nutzbaren Flaeche gehoert.
    var frei = eltern ? eltern.clientWidth : breit;
    return { breit: breit, voll: frei - breit <= 1 };
  }

  /* ZWEI EINHEITEN (Betreiber-Auftrag 06.09.2026): „%" ist der bisherige
     Faktor auf die Buehnen-Stufe, „px" eine feste Obergrenze der Arbeits-
     buehne von 600 bis 4000 px. Der Schieber ist derselbe — beim Umschalten
     wechseln nur Bereich und Wert (aus data-prozent-… und data-px-… am Schieber).
     Die Rechnung fuer px steht identisch in theme.js (vor dem ersten Bild). */
  var ARBEIT_PX = 1136; // --sr-breite-arbeit (theme.css)
  function einheit() { return document.documentElement.getAttribute('data-breite-einheit') === 'px' ? 'px' : 'prozent'; }

  /* Die Anzeige nennt die GEWAEHLTE Einheit zuerst: bei „%" den Prozentwert,
     die gemessene Pixelbreite dahinter; bei „px" die gemessene Breite
     (Betreiber-Befund 12.09.2026: „1.212 px" bei gewaehltem Prozent). */
  function anzeige(v) {
    var m = gemessen();
    var px = m ? m.breit.toLocaleString('de-DE') + '\u00a0px' + (m.voll ? ' · voll' : '') : '';
    if (einheit() === 'px') return px || v + '\u00a0px';
    return v + '\u00a0%' + (px ? ' · ' + px : '');
  }

  function setzen(v, speichern) {
    var d = document.documentElement;
    if (einheit() === 'px') {
      // Feste Obergrenze: deckelt Seiten ohne Stufe direkt, die Stufen ueber
      // den Faktor (Arbeitsbuehne = genau v px, Lesen/Uebersicht anteilig).
      d.style.setProperty('--inhalt-breite', 'min(100%,' + v + 'px)');
      d.style.setProperty('--sr-kopf-breite', 'min(100%,calc(' + v + 'px - 2 * var(--sr-kopf-seitenrand)))');
      d.style.setProperty('--inhalt-faktor', String(v / ARBEIT_PX * 0.9));
      d.setAttribute('data-breite-px', String(v));
      slider.setAttribute('data-px-wert', String(v));
    } else {
      // --inhalt-breite ist der Prozentdeckel der Buehne und bleibt bei 100
      // stehen (siehe theme.js): .content.sr-body setzt damit width UND
      // max-width, ein groesserer Wert waere eine Seite breiter als das Fenster.
      d.style.setProperty('--inhalt-breite', Math.min(v, 100) + '%');
      d.style.removeProperty('--sr-kopf-breite');
      // Zweite Schreibweise desselben Werts fuer die Buehnen-Stufen in sr.css
      // (calc darf nicht durch Prozent teilen). Ohne sie blieb der Schieber
      // ohne sichtbare Wirkung: min(87 %, 1136 px) landete auf breiten
      // Schirmen IMMER bei den 1136 px der Stufe. UEBER 100 wirkt der Faktor
      // allein — er hebt den Pixeldeckel der Stufe, bis das min() greift.
      d.style.setProperty('--inhalt-faktor', String(v / 100));
      // Der Rohwert bleibt am <html>: seoPrefsSpeichern liest ihn dort.
      d.setAttribute('data-breite', String(v));
      slider.setAttribute('data-prozent-wert', String(v));
    }
    var text = anzeige(v);
    if (wert) wert.textContent = text;
    slider.setAttribute('aria-valuetext', text);
    if (speichern) { try { localStorage.setItem('wbreite', String(v)); localStorage.setItem('wbreite-einheit', einheit()); } catch (e) {} }
  }

  /** Schieber auf die Einheit einstellen (Bereich + gemerkter Wert). */
  function schieberEinrichten() {
    var px = einheit() === 'px';
    slider.min = slider.getAttribute(px ? 'data-px-min' : 'data-prozent-min') || (px ? '800' : '70');
    slider.max = slider.getAttribute(px ? 'data-px-max' : 'data-prozent-max') || (px ? '4000' : '200');
    slider.step = px ? '10' : '1';
    var v = parseInt(slider.getAttribute(px ? 'data-px-wert' : 'data-prozent-wert'), 10) || (px ? ARBEIT_PX : 90);
    slider.value = String(v);
    return v;
  }

  // Fenstergroesse aendert die Pixelbreite, ohne dass der Schieber sich
  // bewegt — die Zahl muesste sonst luegen, sobald jemand das Fenster zieht.
  window.addEventListener('resize', function () {
    var text = anzeige(parseInt(slider.value, 10) || 90);
    if (wert) wert.textContent = text;
    slider.setAttribute('aria-valuetext', text);
  });

  // Startwert: angemeldet steht der Serverstand (ui_prefs) schon im Markup —
  // localStorage gilt nur ohne die Server-Marke (siehe theme.js, E4).
  if (!document.documentElement.hasAttribute('data-theme-quelle')) {
    try {
      var ge = localStorage.getItem('wbreite-einheit') === 'px' ? 'px' : 'prozent';
      var g = parseInt(localStorage.getItem('wbreite'), 10);
      if (ge === 'px' ? (g >= 800 && g <= 4000) : (g >= 70 && g <= 200)) {
        document.documentElement.setAttribute('data-breite-einheit', ge);
        slider.setAttribute(ge === 'px' ? 'data-px-wert' : 'data-prozent-wert', String(g));
      }
    } catch (e) {}
  }
  setzen(schieberEinrichten(), false);
  slider.addEventListener('input', function () { setzen(parseInt(slider.value, 10) || 90, true); });
  // Gespeichert wird erst beim Loslassen — nicht bei jedem Pixel Schieben.
  slider.addEventListener('change', seoPrefsSpeichern);

  // Einheit umschalten: Knoepfe „%" / „px" neben dem Titel.
  [].slice.call(document.querySelectorAll('[data-breite-einheit]')).forEach(function (b) {
    if (b === document.documentElement) return;
    b.addEventListener('click', function () {
      var neu = b.getAttribute('data-breite-einheit') === 'px' ? 'px' : 'prozent';
      document.documentElement.setAttribute('data-breite-einheit', neu);
      [].slice.call(document.querySelectorAll('button[data-breite-einheit]')).forEach(function (k) {
        k.setAttribute('aria-pressed', k === b ? 'true' : 'false');
      });
      setzen(schieberEinrichten(), true);
      seoPrefsSpeichern();
    });
  });
})();

/* ------------------------------------------- 4b) Randloser Modus als Marke */
/**
 * „Randlos" ist kein gespeicherter Schalter, sondern ein ERREICHTER Zustand:
 * die Inhaltsbreite (Zahnrad → Inhaltsbreite) ist so weit aufgedreht, dass
 * die Buehne die volle verfuegbare Flaeche fuellt — genau die Lage, bei der
 * der Schieber „· voll" anzeigt (Abschnitt 4 oben, gemessen()).
 *
 * Stylesheets koennen das nicht selbst erkennen: zwischen dem gespeicherten
 * Faktor und der tatsaechlichen Pixelbreite liegen die Buehnen-Stufen aus
 * theme.css UND die Fensterbreite. Deshalb steht das Ergebnis der Messung
 * als data-randlos="1" am <html> — dort, wo Theme, Dichte und Breite schon
 * stehen. Gemessen wird beim Laden, bei jeder Fensteraenderung und nach
 * jedem Zug am Breiten-Schieber (Delegation, damit dieser Block nicht in
 * Abschnitt 4 hineingreift).
 */
(function () {
  var buehne = document.querySelector('main.content.sr-body');
  if (!buehne) return;
  var d = document.documentElement;
  function messen() {
    var eltern = buehne.parentElement;
    if (!eltern) return;
    // clientWidth am Elternrahmen: eine Bildlaufleiste gehoert nicht zur
    // nutzbaren Flaeche (dieselbe Rechnung wie gemessen() in Abschnitt 4).
    var frei = eltern.clientWidth;
    var breit = buehne.getBoundingClientRect().width;
    if (frei - breit <= 1) d.setAttribute('data-randlos', '1');
    else d.removeAttribute('data-randlos');
  }
  messen();
  window.addEventListener('resize', messen);
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'breiteSlider') messen();
  });
  // Einheiten-Knoepfe „%"/„px" setzen die Breite ohne input-Ereignis.
  document.addEventListener('click', function (e) {
    var k = e.target && e.target.closest ? e.target.closest('button[data-breite-einheit]') : null;
    if (k) setTimeout(messen, 0);
  });
})();

/* -------------------------------------- 5) Theme + Tabellendichte (Zahnrad) */
(function () {
  var opts = [].slice.call(document.querySelectorAll('.zahnrad-opt'));
  if (!opts.length) return;

  function drueckAn(attr, wert) {
    opts.forEach(function (b) {
      if (b.hasAttribute(attr)) b.setAttribute('aria-pressed', b.getAttribute(attr) === wert ? 'true' : 'false');
    });
  }
  // Anmeldeseite (06.09.2026): dort rendert der Server keinen gedrueckten
  // Kreis (kein Konto, Theme kommt aus localStorage via theme.js) — den
  // Stand aus data-theme uebernehmen, sonst zeigt keiner der drei „aktiv".
  if (!document.documentElement.hasAttribute('data-theme-quelle')) {
    drueckAn('data-theme-wert', document.documentElement.getAttribute('data-theme') || 'light');
  }

  opts.forEach(function (b) {
    b.addEventListener('click', function () {
      var d = document.documentElement;
      var theme = b.getAttribute('data-theme-wert');
      var dichte = b.getAttribute('data-dichte-wert');
      var kpi = b.getAttribute('data-kpi-wert');
      if (theme) {
        d.setAttribute('data-theme', theme);
        drueckAn('data-theme-wert', theme);
        try { localStorage.setItem('wtheme', theme); } catch (e) {}
      }
      if (dichte) {
        d.setAttribute('data-density', dichte);
        drueckAn('data-dichte-wert', dichte);
        try { localStorage.setItem('wdichte', dichte); } catch (e) {}
      }
      if (kpi) {
        d.setAttribute('data-kpi', kpi);
        drueckAn('data-kpi-wert', kpi);
        try { localStorage.setItem('wkpi', kpi); } catch (e) {}
      }
      seoPrefsSpeichern();
    });
  });
})();

/* ------------------------------- 5b) Sammelbearbeitung + Inline-Umbenennen */
/* Betreiber-Anweisung 06.09.2026 („bei allen Tabellen so"): Auswahlfelder
   (ui.auswahlZelle/auswahlKopf) haengen per form-Attribut am Sammelformular
   (ui.auswahlLeiste); dieses Stueck zaehlt, blendet die Leiste ein, waehlt
   alle/keine und fragt vor gefaehrlichen Aktionen (data-bestaetigen) nach.
   Inline-Umbenennen: der Stift am Namen (data-inline-edit) blendet das
   Formular derselben Zelle ein, das Kreuz (data-inline-abbrechen) wieder aus. */
(function () {
  /* [data-bestaetigen] generisch statt nur an der Sammelleiste (K&R-Rollout
     Batch 5, Anbindungen „Trennen"-Formular, 07.09.2026, Aufgabe): ein
     einziger Listener auf dem Dokument statt einem je Sammelleiste — jedes
     <form>, dessen Submitter das Attribut traegt, bekommt denselben
     window.confirm()-Riegel. Ersetzt den vorherigen Listener je Leiste
     (identische Pruefung, jetzt an einer Stelle statt dupliziert). */
  document.addEventListener('submit', function (e) {
    var knopf = e.submitter;
    var frage = knopf && knopf.getAttribute('data-bestaetigen');
    if (frage && !window.confirm(frage)) e.preventDefault();
  });

  var leisten = [].slice.call(document.querySelectorAll('[data-auswahl-leiste]'));
  leisten.forEach(function (leiste) {
    var id = leiste.id;
    if (!id) return;
    var felder = function () { return [].slice.call(document.querySelectorAll('input.sr-wahl:not(.sr-wahl--alle)[data-wahl-form="' + id + '"]')); };
    var alle = document.querySelector('input.sr-wahl--alle[data-wahl-form="' + id + '"]');
    var zahl = leiste.querySelector('[data-auswahl-zahl]');
    function aktualisieren() {
      var spiegel = felder().filter(function (f) { return f.hasAttribute('data-sr-wahl-spiegel'); });
      var n = spiegel.length || felder().filter(function (f) { return f.checked; }).length;
      leiste.hidden = n === 0;
      if (zahl) zahl.textContent = n + ' ausgewählt';
      if (alle) {
        var ursprung = felder().filter(function (f) { return !f.closest('.sr-tabulator'); });
        var gesamt = ursprung.length || felder().length;
        alle.checked = n > 0 && n === gesamt;
        alle.indeterminate = n > 0 && n < gesamt;
      }
    }
    // Delegiert, weil Paging/Serversortierung die <tr> und damit ihre
    // Checkboxen ersetzt. Ein Listener an den ersten DOM-Knoten würde nach
    // dem Nachladen fehlen und die Sammelleiste nicht mehr aktualisieren.
    document.addEventListener('change', function (e) {
      if (e.target.matches('input.sr-wahl:not(.sr-wahl--alle)[data-wahl-form="' + id + '"]')) aktualisieren();
    });
    document.addEventListener('sr-table-rows', function (e) {
      if ((alle && e.target.contains(alle)) || e.target.querySelector('input.sr-wahl[data-wahl-form="' + id + '"]')) aktualisieren();
    });
    if (alle) alle.addEventListener('change', function () {
      var an = alle.checked;
      // Nur sichtbare Zeilen (Filter der Werkzeugzeile): eine gefilterte Liste
      // waehlt nicht heimlich die ausgeblendeten Zeilen mit.
      felder().forEach(function (f) { var tr = f.closest('tr'); f.checked = an && !(tr && (tr.hidden || tr.classList.contains('tbl-gefiltert'))); });
      aktualisieren();
    });
    var leeren = leiste.querySelector('[data-auswahl-leeren]');
    if (leeren) leeren.addEventListener('click', function () { felder().forEach(function (f) { f.checked = false; }); aktualisieren(); });
    aktualisieren();
  });

  var inlineGebunden = new WeakSet();
  function inlineBinden(wurzel) {
  [].slice.call(wurzel.querySelectorAll('[data-inline-edit]')).forEach(function (stift) {
    if (inlineGebunden.has(stift)) return;
    inlineGebunden.add(stift);
    stift.addEventListener('click', function () {
      /* data-inline-ziel (Anbindungen, K&R-Rollout Batch 5, 07.09.2026): das
         Formular liegt NICHT in derselben Zelle wie der Stift, sondern in
         einer eigenen <tr> (Verbinden/Trennen-Formular je Dienst) — per id
         gezielt statt per Zellensuche. Ohne das Attribut bleibt die
         bisherige Suche in der eigenen Zelle unveraendert. */
      var zielId = stift.getAttribute('data-inline-ziel');
      if (zielId) {
        var ziel = document.getElementById(zielId);
        if (!ziel) return;
        ziel.hidden = false;
        var eingabe = ziel.querySelector('input[type="text"], select');
        if (eingabe) { eingabe.focus(); if (eingabe.select) eingabe.select(); }
        return;
      }
      var zelle = stift.closest('td') || stift.parentNode.parentNode;
      var anzeige = zelle.querySelector('[data-inline-anzeige]');
      var form = zelle.querySelector('[data-inline-form]');
      if (!form) return;
      if (anzeige) anzeige.hidden = true;
      form.hidden = false;
      var feld = form.querySelector('input[type="text"]');
      if (feld) { feld.focus(); feld.select(); }
    });
  });
  [].slice.call(wurzel.querySelectorAll('[data-inline-abbrechen]')).forEach(function (kreuz) {
    if (inlineGebunden.has(kreuz)) return;
    inlineGebunden.add(kreuz);
    kreuz.addEventListener('click', function () {
      var zielId = kreuz.getAttribute('data-inline-ziel');
      if (zielId) {
        var ziel = document.getElementById(zielId);
        if (ziel) ziel.hidden = true;
        /* Liegt das Formular in einer Drill-Detailzeile (Anbindungen seit
           07.09.2026), traegt die Zeile darueber den Aufklapp-Zustand. Ohne
           diesen Nachzug bliebe der Chevron offen, obwohl nichts mehr da ist —
           die Zeile wuerde beim naechsten Klick zumachen statt aufzugehen. */
        if (ziel && ziel.classList.contains('drill-detail')) {
          var zeile = ziel.previousElementSibling;
          if (zeile && zeile.classList.contains('drill')) {
            zeile.classList.remove('drill--offen');
            zeile.setAttribute('aria-expanded', 'false');
          }
        }
        var eigenesForm = kreuz.closest('form');
        if (eigenesForm) eigenesForm.reset();
        return;
      }
      var form = kreuz.closest('[data-inline-form]');
      var zelle = form && (form.closest('td') || form.parentNode);
      var anzeige = zelle && zelle.querySelector('[data-inline-anzeige]');
      if (form) { form.hidden = true; form.reset(); }
      if (anzeige) { anzeige.hidden = false; var s = anzeige.querySelector('[data-inline-edit]'); if (s) s.focus(); }
    });
  });
  // Escape im Umbenennen-Feld = Abbrechen
  [].slice.call(wurzel.querySelectorAll('[data-inline-form] input[type="text"]')).forEach(function (feld) {
    if (inlineGebunden.has(feld)) return;
    inlineGebunden.add(feld);
    feld.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var kreuz = feld.closest('[data-inline-form]').querySelector('[data-inline-abbrechen]');
      if (kreuz) { e.preventDefault(); kreuz.click(); }
    });
  });
  }
  inlineBinden(document);
  document.addEventListener('sr-table-rows', function (e) { inlineBinden(e.target); });
})();

/* --------------------------------- 5c) Bildlauf nach Aktionen halten */
/* Betreiber-Befund 06.09.2026: „wenn man einen Aktionsknopf betaetigt, darf die
   Seite nicht nach oben springen — fuer alle Tabellen". Jede Aktion ist ein
   POST mit Weiterleitung auf dieselbe Seite; der Browser laedt sie oben.
   Beim Absenden wird der Bildlauf je Pfad gemerkt (sessionStorage), nach
   dem Laden wieder hergestellt — NACH dem Kapitel-Start, der ohne Anker
   bewusst oben beginnt (Baustein Kapitel), deshalb ueber den load-Tick. */
(function () {
  var SCHL = 'sr-scroll:' + location.pathname;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || form.method.toLowerCase() !== 'post') return;
    if (form.hasAttribute('data-scroll-frei')) return;
    try { sessionStorage.setItem(SCHL, String(Math.round(window.scrollY))); } catch (err) { /* egal */ }
  }, true);
  var y = null;
  try { y = parseInt(sessionStorage.getItem(SCHL), 10); sessionStorage.removeItem(SCHL); } catch (err) { y = null; }
  if (y === null || !isFinite(y) || y <= 0) return;
  /* Mehrere Anlaeufe: Kapitel- und Reiterwechsel (Bausteine oben) und
     spaete Layoutschritte (Charts, Schriften) aendern die Seitenhoehe noch
     nach `load` — ein einzelner scrollTo landet dann am damaligen Ende.
     Sobald der Nutzer selbst rollt, hoert das Nachziehen auf. */
  var selbst = false;
  ['wheel', 'touchstart', 'keydown'].forEach(function (ev) { window.addEventListener(ev, function () { selbst = true; }, { passive: true, once: true }); });
  function herstellen() {
    if (selbst) return;
    if (Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
  }
  function anlaeufe() { [0, 60, 200, 500, 1000].forEach(function (t) { window.setTimeout(herstellen, t); }); }
  if (document.readyState === 'complete') anlaeufe();
  else window.addEventListener('load', anlaeufe);
})();

/* --------------------------------------------------------- 6) XL-Tabellen */

/** Scroll-Schatten + „erste Spalte sticky" nur bei tatsaechlich scrollenden Tabellen. */
(function () {
  /* Auch table.tbl-drill: die scrollt seit dem 390-px-Fix (01.09.2026) auf
     schmalen Schirmen in sich selbst und braucht denselben Hinweis darauf.
     Auf dem Desktop scrollt sie nicht — dort setzt aktualisieren() keine
     Klasse, die Regeln greifen also nur, wo wirklich etwas verborgen ist. */
  var wraps = document.querySelectorAll('.tbl-wrap, table.tbl-drill');
  [].forEach.call(wraps, function (wrap) {
    function aktualisieren() {
      var max = wrap.scrollWidth - wrap.clientWidth;
      wrap.classList.toggle('tbl-scrollable', max > 2);
      wrap.classList.toggle('scroll-left', wrap.scrollLeft > 2);
      wrap.classList.toggle('scroll-right', max - wrap.scrollLeft > 2);
    }
    wrap.addEventListener('scroll', aktualisieren, { passive: true });
    window.addEventListener('resize', aktualisieren);
    aktualisieren();
  });
})();

/**
 * EINE CSV-Zelle fuer die Browser-Exporte — deckungsgleich mit feld() in
 * app/lib/csv.js (01.09.2026, Live-Gang-Durchsicht).
 *
 * Bis heute gab es dieselbe Zelle dreimal: serverseitig in app/lib/csv.js MIT
 * Formel-Entschaerfung, in der Tabellen-Werkzeugleiste hier und im
 * Chart-Export in charts.js jeweils OHNE. Ein Suchbegriff aus der Search
 * Console, der mit = beginnt, kam also je nach angeklicktem Weg harmlos oder
 * als Formel in der Tabellenkalkulation an. Der Schutz war nicht vergessen,
 * er stand nur auf einem von drei Wegen.
 *
 * Das Apostroph zeigt die Tabellenkalkulation NICHT an — der Wert sieht fuer
 * den Leser unveraendert aus, wird nur nicht mehr gerechnet. Das trifft auch
 * legitime Werte wie „+2,3" aus den Veraenderungsspalten; genau diesen
 * Abwaegungssatz begruendet der Kopfkommentar von app/lib/csv.js.
 *
 * Liegt am Fenster, weil das Buendel jede Datei in eine eigene IIFE wickelt
 * (app/lib/assets.js skriptTeil()) — charts.js sieht sonst nichts von hier.
 * app.js laeuft im Buendel vor charts.js.
 */
function seoCsvFeld(v) {
  var s = String(v === null || v === undefined ? '' : v);
  var gefaehrlich = s.length > 0 && ['=', '+', '-', '@', '\t', '\r'].indexOf(s.charAt(0)) !== -1;
  var roh = gefaehrlich ? "'" + s : s;
  if (gefaehrlich || /[;"\r\n]/.test(roh)) return '"' + roh.replace(/"/g, '""') + '"';
  return roh;
}
window.seoCsvFeld = seoCsvFeld;

/** Deutsches Zahlenformat („1.234,5", „▲ 2,3", „±0", „−1,5", „4,2 %") -> Number|null. */
function seoParseZahl(text) {
  var t = text.replace(/ /g, ' ').trim();
  if (!t) return null;
  var vorzeichen = 1;
  if (/^▲/.test(t)) { t = t.replace(/^▲\s*/, ''); }
  else if (/^▼/.test(t)) { vorzeichen = -1; t = t.replace(/^▼\s*/, ''); }
  else if (/^±/.test(t)) { return 0; }
  else if (/^[+\-−]/.test(t)) { vorzeichen = /^[\-−]/.test(t) ? -1 : 1; t = t.replace(/^[+\-−]\s*/, ''); }
  var treffer = t.match(/[\d.,]+/);
  if (!treffer) return null;
  var zahl = treffer[0];
  zahl = /,\d{1,3}$/.test(zahl) ? zahl.replace(/\./g, '').replace(',', '.') : zahl.replace(/,/g, '');
  var wert = parseFloat(zahl);
  return isNaN(wert) ? null : wert * vorzeichen;
}

/** Deutsches Datum/Uhrzeit-Format am Zellenanfang („29.07.2026" / „29.07.2026, 03:31 Uhr") -> Timestamp|null. */
function seoParseDatum(text) {
  var m = /^(\d{1,2})\.(\d{1,2})\.(\d{2,4})(?:,?\s+(\d{1,2}):(\d{2}))?/.exec(text.trim());
  if (!m) return null;
  var jahr = m[3].length === 2 ? 2000 + parseInt(m[3], 10) : parseInt(m[3], 10);
  var d = new Date(jahr, parseInt(m[2], 10) - 1, parseInt(m[1], 10),
    m[4] ? parseInt(m[4], 10) : 0, m[5] ? parseInt(m[5], 10) : 0);
  return isNaN(d.getTime()) ? null : d.getTime();
}

/** Sortierwert einer Zelle: erkennt Datum vor Zahl vor Text; „—"/leer -> null (immer ans Ende). */
function seoZellenWert(zelle, istNum) {
  if (!zelle) return null;
  var sortZiel = zelle.hasAttribute('data-sort-wert') ? zelle : zelle.querySelector('[data-sort-wert]');
  var text = (sortZiel ? sortZiel.getAttribute('data-sort-wert') : zelle.textContent || '').replace(/ /g, ' ').trim();
  if (!text || text === '—' || text === '-') return null;
  var datum = seoParseDatum(text);
  if (datum !== null) return { typ: 'num', wert: datum };
  if (istNum) {
    var zahl = seoParseZahl(text);
    if (zahl !== null) return { typ: 'num', wert: zahl };
  }
  return { typ: 'text', wert: text.toLowerCase() };
}

/* ------------------------------------------------ 6b) Tabellen-Werkzeuge */

/** Suchfeld + Export je Datentabelle (Runde 9, 28.08.2026): rechts ueber der
 *  Tabelle sitzt eine schmale Werkzeugzeile — Volltext-Filter links vom
 *  Export (CSV/XLSX des AKTUELL gefilterten Stands, in Sortierreihenfolge).
 *  Kleine Tabellen (< 5 Zeilen) bleiben werkzeuglos; die Export-Menue-
 *  Klassen kommen bewusst von den Chart-Werkzeugen (ein Baukasten). */
(function () {
  function download(blob, name) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url; a.download = name;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    window.setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
  }
  function dateiname(basis, ext) {
    var jetzt = new Date();
    var z = function (n) { return String(n).padStart(2, '0'); };
    var slug = String(basis || '').toLowerCase().replace(/[^a-z0-9äöüß]+/gi, '-')
      .replace(/^-+|-+$/g, '').slice(0, 48) || 'tabelle';
    return 'kauz360-' + slug + '-' + jetzt.getFullYear() + z(jetzt.getMonth() + 1) + z(jetzt.getDate()) + '.' + ext;
  }
  /** Kopf + SICHTBARE Zeilen in aktueller (ggf. sortierter) Reihenfolge. */
  async function matrix(table) {
    var kopf = [].map.call(table.tHead.rows[0].cells, function (th) { return (th.textContent || '').trim(); });
    var rows = [].filter.call(table.tBodies[0].rows, function (tr) { return !tr.hidden && !tr.classList.contains('tbl-gefiltert'); });
    var wrap = table.closest('[data-sr-table-token]');
    if (wrap) {
      rows = [];
      var suche = wrap.previousElementSibling && wrap.previousElementSibling.querySelector('.tbl-suche');
      var params = new URLSearchParams({offset: '0', limit: '500', filter: suche ? suche.value.trim() : ''});
      if (wrap.dataset.srSource) params.set('source', wrap.dataset.srSource);
      if (wrap.dataset.srSort) {
        params.set('sort', wrap.dataset.srSort); params.set('direction', wrap.dataset.srDirection || 'ascending');
        params.set('numeric', wrap.dataset.srSortNumeric || '0');
      }
      var more = true;
      while (more) {
        var antwort = await fetch('/api/tabellen/' + encodeURIComponent(wrap.dataset.srTableToken) + '?' + params, {credentials:'same-origin'});
        if (!antwort.ok) throw new Error('Die vollständige Tabelle konnte nicht geladen werden.');
        var daten = await antwort.json();
        var marker = document.createElement('template'); marker.innerHTML = daten.rows.join('');
        rows.push.apply(rows, [].slice.call(marker.content.querySelectorAll('tr')));
        more = daten.hasMore; params.set('offset', String(daten.nextOffset));
      }
    }
    var zeilen = rows
      .map(function (tr) { return [].map.call(tr.cells, function (td) { return (td.textContent || '').trim(); }); });
    return { kopf: kopf, zeilen: zeilen };
  }
  async function exportCsv(table, basis) {
    var m = await matrix(table);
    var zelle = seoCsvFeld;
    var text = [m.kopf.map(zelle).join(';')]
      .concat(m.zeilen.map(function (z) { return z.map(zelle).join(';'); })).join('\r\n');
    download(new Blob(['\uFEFF' + text], { type: 'text/csv;charset=utf-8' }), dateiname(basis, 'csv'));
  }
  /* Echte .xlsx ueber window.srXlsx (app/views/xlsx.js, 03.10.2026) — die
     fruehere SpreadsheetML-Datei mit Endung .xls loeste in Excel die Warnung
     „Dateiformat und Dateierweiterung passen nicht zueinander" aus. */
  async function exportXls(table, basis) {
    var m = await matrix(table);
    var numerisch = [].map.call(table.tHead.rows[0].cells, function (th) {
      return th.classList.contains('num') || th.classList.contains('re');
    });
    var zelle = function (v, idx) {
      var text = String(v);
      if (!numerisch[idx]) return text;
      // Nur vollstaendige deutsche Zahlen in ausgewiesenen Zahlenspalten.
      // Datum, URL, Kennung und Formeltext bleiben Inline-Text im XLSX.
      var t = text.replace(/ /g, ' ').trim();
      if (/^±\s*0(?:,0+)?\s*%?$/.test(t)) return 0;
      var m = /^([+\-−▲▼]?)\s*(\d{1,3}(?:\.\d{3})+|\d+)(?:,(\d+))?\s*%?$/.exec(t);
      if (!m) return text;
      var n = Number(m[2].replace(/\./g, '') + (m[3] ? '.' + m[3] : ''));
      if (/^[\-−▼]$/.test(m[1])) n = -n;
      return isFinite(n) ? n : text;
    };
    var zeilen = m.zeilen.map(function (z) { return z.map(zelle); });
    download(window.srXlsx(m.kopf.map(String), zeilen, 'Tabelle'), dateiname(basis, 'xlsx'));
  }

  /* data-sr-export (09.10.2026): kleine Tabellen und Tabellenkarten
     (.sr-tabelle-wrap) tragen den Export nur, wenn der Aufrufer ihn
     ausdruecklich verlangt (ui.tabelle/srTabellenKarte, Option `export`).
     Solche Tabellen bekommen NUR den Export-Knopf, keinen Filter, und das
     ohne Mindestzahl an Zeilen. */
  /* EXPORT GEHOERT ZUM STANDARD (cmvqii0kg, Dispatcher-Festlegung
     vg-8e225043): jede Tabellenkarte mit Werkzeugzeile bekommt ihn, nicht
     nur die mit `export`. Ohne Werkzeugzeile (kleine Karten, ≤10 Zeilen)
     bleibt es bei der ausdruecklichen Option. */
  var tabellen = document.querySelectorAll('.tbl-wrap table, .sr-tabelle-wrap table');
  [].forEach.call(tabellen, function (table) {
    if (!table.tHead || !table.tHead.rows.length || !table.tBodies.length) return;
    var tbody = table.tBodies[0];
    var wrap = table.closest('.tbl-wrap, .sr-tabelle-wrap');
    if (!wrap) return;
    // Eine SERVERSEITIG gebaute Werkzeugzeile (A4, ui.werkzeugzeile()) kennt
    // die Zeilenzahl vor der Kappung und den Export-Pfad des Kapitels — sie
    // ist die bessere; hier wird dann keine zweite daruebergesetzt. Seit der
    // Standard-Kopfleiste kann sie in einer .sr-tabellen-leiste stecken.
    var vorher = wrap.previousElementSibling;
    if (vorher && vorher.classList && vorher.classList.contains('sr-tabellen-leiste')) {
      vorher = vorher.querySelector('.sr-werkzeugzeile') || vorher;
    }
    var serverZeile = !!(vorher && vorher.classList
      && (vorher.classList.contains('tbl-werkzeuge') || vorher.classList.contains('sr-werkzeugzeile')));
    var karteMitWerkzeug = wrap.classList.contains('sr-tabelle-wrap') && serverZeile && vorher.classList.contains('sr-werkzeugzeile');
    var nurExport = table.hasAttribute('data-sr-export') || karteMitWerkzeug;
    if (wrap.classList.contains('sr-tabelle-wrap') && !nurExport) return;
    if (tbody.rows.length < (nurExport ? 1 : 5)) return;
    if (serverZeile && !(nurExport && vorher.classList.contains('sr-werkzeugzeile')
      && !vorher.querySelector('.sr-werkzeug-export, .chart-export-btn'))) return;

    // Dateiname aus der naechstgelegenen Ueberschrift davor.
    var basis = '';
    for (var el = wrap.previousElementSibling; el; el = el.previousElementSibling) {
      if (/^H[2-4]$/.test(el.tagName)) { basis = el.textContent || ''; break; }
    }
    if (!basis && nurExport) {
      var karte = wrap.closest('.sr-karte');
      var kartenTitel = karte && karte.querySelector('.sr-karte-titel, h2, h3, h4');
      basis = kartenTitel ? (kartenTitel.textContent || '') : '';
    }

    var leiste = document.createElement('div');
    leiste.className = 'tbl-werkzeuge';

    var suche = document.createElement('input');
    suche.type = 'search';
    suche.className = 'tbl-suche';
    suche.placeholder = 'Filtern …';
    suche.setAttribute('aria-label', 'Tabelle filtern');

    var leer = document.createElement('div');
    leer.className = 'tbl-leer';
    leer.hidden = true;
    leer.textContent = 'Keine Zeilen passen zum Filter — Suchbegriff leeren zeigt wieder alle Zeilen.';

    function filterAnwenden() {
      var q = suche.value.trim().toLowerCase();
      var sichtbar = 0;
      [].forEach.call(tbody.rows, function (tr) {
        var passt = !q || (tr.textContent || '').toLowerCase().indexOf(q) !== -1;
        tr.classList.toggle('tbl-gefiltert', !passt);
        if (passt) sichtbar++;
      });
      leer.hidden = sichtbar > 0;
    }
    suche.addEventListener('input', filterAnwenden);
    table.addEventListener('sr-table-rows', filterAnwenden);

    var ex = document.createElement('div');
    ex.className = 'chart-export';
    var exBtn = document.createElement('button');
    exBtn.type = 'button';
    // Export-Schloss (§5.3): dasselbe Merkmal wie beim Chart-Export
    // (charts.js) — fehlt es im Tarif, bleibt der Knopf sichtbar, aber tot.
    // Die harte Schranke sitzt serverseitig an den Export-Routen; hier geht
    // es nur um dieselbe Darstellung, damit der Tabellen-Export nicht als
    // Umweg um das Chart-Schloss herum offen bleibt.
    var exportGesperrt = document.body.getAttribute('data-exporte') === '0';
    if (exportGesperrt) {
      exBtn.className = 'chart-export-btn chart-export-btn--schloss';
      exBtn.innerHTML = '<span aria-hidden="true">🔒</span><svg class="sr-export-icon" viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 2v8m0 0 3-3m-3 3L5 7M3 13.5h10"/></svg><span>Export</span>';
      exBtn.setAttribute('aria-disabled', 'true');
      exBtn.title = document.body.getAttribute('data-exporte-hinweis') || 'Exporte im Tarif nicht enthalten';
      ex.appendChild(exBtn);
    } else {
      exBtn.className = 'chart-export-btn'; exBtn.innerHTML = '<svg class="sr-export-icon" viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 2v8m0 0 3-3m-3 3L5 7M3 13.5h10"/></svg><span>Export</span><span aria-hidden="true">▾</span>';
      var menue = document.createElement('div');
      menue.className = 'chart-export-menue';
      menue.hidden = true;
      [['CSV', exportCsv], ['Excel (XLSX)', exportXls]].forEach(function (eintrag) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'chart-export-eintrag'; b.textContent = eintrag[0];
        b.addEventListener('click', function () {
          menue.hidden = true;
          eintrag[1](table, basis).catch(function (err) { exBtn.textContent = 'Export fehlgeschlagen'; exBtn.title = err.message; });
        });
        menue.appendChild(b);
      });
      exBtn.addEventListener('click', function (ev) {
        ev.stopPropagation();
        [].slice.call(document.querySelectorAll('.chart-export-menue')).forEach(function (m) { if (m !== menue) m.hidden = true; });
        menue.hidden = !menue.hidden;
      });
      ex.appendChild(exBtn); ex.appendChild(menue);
    }

    if (nurExport) {
      if (serverZeile) {
        var rechts = vorher.querySelector('.sr-werkzeug-rechts');
        if (!rechts) {
          rechts = document.createElement('span');
          rechts.className = 'sr-werkzeug-rechts';
          vorher.appendChild(rechts);
        }
        rechts.appendChild(ex);
      } else {
        leiste.appendChild(ex);
        wrap.parentNode.insertBefore(leiste, wrap);
      }
      return;
    }
    leiste.appendChild(suche);
    leiste.appendChild(ex);
    wrap.parentNode.insertBefore(leiste, wrap);
    wrap.appendChild(leer);
  });

  // Menues schliessen — eigener Handler, weil charts.js nur auf Seiten mit
  // Charts laeuft; doppelt schadet nicht (beide schliessen dieselben Menues).
  document.addEventListener('click', function () {
    [].slice.call(document.querySelectorAll('.chart-export-menue')).forEach(function (m) { m.hidden = true; });
  });
})();

/** Klick-sortierbare Spaltenkoepfe — progressive enhancement, aendert nur das DOM. */
(function () {
  var tabellen = document.querySelectorAll('.tbl-wrap table, .sr-tabelle-wrap table');
  [].forEach.call(tabellen, function (table) {
    var thead = table.tHead;
    var tbody = table.tBodies[0];
    if (!thead || !tbody || !thead.rows.length) return;
    if (tbody.rows.length < 2) return; // eine Zeile sortiert sich nicht

    var ursprung = [].slice.call(tbody.rows);
    var ths = [].slice.call(thead.rows[0].cells);
    var aktivIdx = -1;
    var aktivRichtung = '';

    ths.forEach(function (th, idx) {
      // Spalten ohne Zahl/Text (z.B. eine reine Sparkline-Grafikspalte, D.2)
      // markiert ui.tabelle() serverseitig mit data-sort="aus" — keinen
      // Sortierknopf dafuer erzeugen, Kopf bleibt einfacher Text.
      if (th.getAttribute('data-sort') === 'aus') return;
      var kartenMarker = th.querySelector('.sr-tabelle-sort');
      if (table.closest('.sr-tabelle-wrap') && !kartenMarker) return;
      if (kartenMarker) kartenMarker.remove();
      // Ein Spalten-ⓘ (ui.herkunftKnopf) bleibt Knopf neben dem Sortierknopf.
      // Ueber textContent geplaettet stand sein verborgener Erklaertext als
      // eine Zeile im Kopf und zog die Spalte auf mehrere tausend Pixel.
      var erklaerung = th.querySelector('.sr-erklaerung');
      if (erklaerung) erklaerung.remove();
      var text = th.textContent;
      var istNum = th.classList.contains('num') || th.classList.contains('re');
      th.setAttribute('aria-sort', 'none');
      th.classList.add('th-sortable');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'th-sort-btn';
      // Symbolkopf (Favoriten-Stern, Migration 156) bleibt Symbol samt
      // Screenreader-Text, statt zum Wort „Favorit" zu werden.
      var symbol = th.querySelector('.sr-stern-kopf');
      if (symbol) btn.appendChild(symbol); else btn.appendChild(document.createTextNode(text));
      var pfeil = document.createElement('span');
      pfeil.className = 'th-sort-arrow';
      pfeil.setAttribute('aria-hidden', 'true');
      btn.appendChild(pfeil);
      th.textContent = '';
      th.appendChild(btn);
      if (erklaerung) th.appendChild(erklaerung);

      btn.addEventListener('click', function () {
        // Eine umsortierbare Tabelle kann die Zelle seit dem Seitenaufbau
        // verschoben haben. Die stabile Spalten-ID folgt Kopf und Zellen;
        // der aktuelle Index wird erst beim Klick ermittelt.
        var spaltenId = th.getAttribute('data-column-id');
        var aktuellIdx = spaltenId
          ? [].slice.call(thead.rows[0].cells).findIndex(function (z) { return z.getAttribute('data-column-id') === spaltenId; })
          : th.cellIndex;
        if (aktuellIdx < 0) return;
        var aktivSchluessel = spaltenId || String(aktuellIdx);
        var richtung;
        if (aktivIdx !== aktivSchluessel) richtung = 'ascending';
        else if (aktivRichtung === 'ascending') richtung = 'descending';
        else richtung = null; // dritter Klick auf dieselbe Spalte: zurueck zur Ursprungsordnung

        ths.forEach(function (t) { t.setAttribute('aria-sort', 'none'); });

        if (!richtung) {
          aktivIdx = -1; aktivRichtung = '';
          ursprung.forEach(function (tr) { tbody.appendChild(tr); });
          return;
        }

        aktivIdx = aktivSchluessel; aktivRichtung = richtung;
        th.setAttribute('aria-sort', richtung);

        var vorzeichen = richtung === 'ascending' ? 1 : -1;
        var bewertet = [].slice.call(tbody.rows).map(function (tr) {
          return { tr: tr, wert: seoZellenWert(tr.cells[aktuellIdx], istNum) };
        });
        bewertet.sort(function (a, b) {
          if (a.wert === null && b.wert === null) return 0;
          if (a.wert === null) return 1;
          if (b.wert === null) return -1;
          if (a.wert.typ === 'num' && b.wert.typ === 'num') return vorzeichen * (a.wert.wert - b.wert.wert);
          return vorzeichen * String(a.wert.wert).localeCompare(String(b.wert.wert), 'de');
        });
        bewertet.forEach(function (z) { tbody.appendChild(z.tr); });
      });
    });
    table.addEventListener('sr-table-rows', function (e) {
      var neu = e.detail && e.detail.rows ? [].slice.call(e.detail.rows) : [].slice.call(tbody.rows);
      if (e.detail && e.detail.reset) ursprung = neu.slice();
      else neu.forEach(function (tr) { if (ursprung.indexOf(tr) === -1) ursprung.push(tr); });
    });
  });
})();

/* ------------------------------------------------ 7) Kapitel-Navigation ---
 * Navigations-Umbau (01.08.2026): aus der einen Kapitel-Tableiste sind drei
 * Ebenen geworden.
 *   Ebene 2 (Seitenleiste, unter dem aktiven Navigationspunkt — seit R3
 *     layout.js srKapitelListe(), vorher kapitelSubnavHtml(); die DOM-Haken
 *     #kapitelSubnav und .nav-item--kapitel[data-kapitel-id] sind dieselben
 *     geblieben) traegt jetzt den Kapitel-Wechsel: genau ein
 *     .section-Panel sichtbar, Hash-Sync (Direktaufruf + Zurueck-Taste),
 *     gerichteter Panel-Wechsel mit Ein-/Ausflug-Animation — exakt dieselbe
 *     Umschalt-Logik wie zuvor die obere Leiste. Die Kapitel-Links sind
 *     bewusst GANZ NORMALE <a href="#…">-Links (kein role=tab mehr, siehe
 *     Betreiber-Vorgabe) — ein Klick loest deshalb schon nativ einen
 *     hashchange aus (oder, falls der Hash schon passt, das native
 *     Zum-Anker-Springen), der Rest laeuft ueber den zentralen
 *     hashchange-Listener weiter unten. Aktiver Zustand: aria-current statt
 *     aria-selected (layout.js setzt es serverseitig auf den ersten Eintrag
 *     vor, hier nur noch fortgeschrieben).
 *   Ebene 3 (die frei gewordene sticky Leiste unter dem Header — layout.js
 *     unterkapitelZoneHtml()) zeigt die UNTERABSCHNITTE des jeweils aktiven
 *     Kapitels: ein Band je Kapitel mit mindestens zwei Unterkapiteln, alle
 *     anderen serverseitig gar nicht erst gerendert. Kein Panel-Wechsel hier
 *     — die Unterabschnitte liegen alle im selben, schon sichtbaren
 *     Kapitel-Panel — stattdessen Scroll-Spy: der zuletzt passierte
 *     Unterabschnitt gilt als aktiv, ein Klick springt mit dem richtigen
 *     Versatz (Kopfzeile + Leiste) dorthin.
 * Ohne JavaScript (oder wenn eine der Vorbedingungen unten fehlt) bleiben
 * alle .section-Elemente sichtbar und Ebene 2/3 sind schlichte Anker-Listen
 * — das ist der Ausgangszustand, kein Sonderfall, den es hier gesondert zu
 * behandeln gaebe.
 */
(function () {
  var subnav = document.getElementById('kapitelSubnav'); // Ebene 2, kann fehlen
  var content = document.querySelector('.content');
  var leiste = document.getElementById('unterkapitelLeiste'); // Ebene 3, kann fehlen
  if (!content) return;

  var tabs = subnav ? [].slice.call(subnav.querySelectorAll('.nav-item--kapitel')) : [];
  var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('data-kapitel-id')); });
  // Ein Panel fehlt (Markup-Unstimmigkeit) -> lieber gar nicht erst umbauen,
  // dann bleibt wenigstens die Anker-Liste mit vollstaendig sichtbarem Inhalt.
  var hatKapitel = tabs.length >= 2 && !panels.some(function (p) { return !p; });
  if (!hatKapitel) { tabs = []; panels = []; }
  /* EBENE 3 OHNE EBENE 2 (30.08.2026, Runde 5): /konto ist seither EINE Seite
     mit Zwischenueberschriften statt fuenf Kapitel-Reitern. Sie hat also ein
     Band, aber nichts umzuschalten. Vorher stieg dieser Baustein bei
     fehlendem #kapitelSubnav komplett aus — und mit ihm Scroll-Spy und
     Klick-Versatz des Bandes. */
  if (!hatKapitel && !leiste) return;

  // Aktives Verwaltungskapitel auch auf schmalen Bildschirmen zeigen.
  // Ausschließlich die Tab-Leiste bewegen; der Seitenbildlauf bleibt erhalten.
  function kapitelReiterSichtbar() {
    if (!subnav || !subnav.classList.contains('sr-tabs')) return;
    var aktiv = subnav.querySelector('[aria-current]');
    if (!aktiv || subnav.scrollWidth <= subnav.clientWidth) return;
    var rahmen = subnav.getBoundingClientRect();
    var reiter = aktiv.getBoundingClientRect();
    if (reiter.left < rahmen.left) subnav.scrollLeft += reiter.left - rahmen.left;
    else if (reiter.right > rahmen.right) subnav.scrollLeft += reiter.right - rahmen.right;
  }

  /* Alt-Adressen mit Anker (…/technik#cwv — so stehen sie in aelteren
     Berichten, Lesezeichen und in den 301-Zielen von KAPITEL_ALT) zeigen auf
     einen Abschnitt, der seit dem Ansichts-Umbau (31.08.2026) seine eigene
     Adresse hat und in DIESER Seite gar nicht mehr steht. Einmal
     weiterreichen, statt den Leser auf einer Seite stehen zu lassen, die
     seinen Anker nicht kennt. replace(), damit die Zurueck-Taste nicht
     zwischen beiden Adressen pendelt. */
  function altAnkerWeiterreichen() {
    if (!leiste || location.hash.length < 2) return false;
    var altZiel;
    try { altZiel = decodeURIComponent(location.hash.slice(1)); }
    catch (_) { return false; }
    if (!/^[a-z0-9][a-z0-9-]*$/i.test(altZiel) || document.getElementById(altZiel)) return false;
    var altTab = leiste.querySelector('.unterkapitel-band[data-uk-ansichten] .unterkapitel-tab[data-unterkapitel-id="' + altZiel + '"]');
    if (!altTab || !altTab.getAttribute('href')) return false;
    location.replace(altTab.getAttribute('href'));
    return true;
  }
  // Beim Laden — und noch einmal bei jedem hashchange: ein Sprung von
  // …/technik#cwv auf …/technik#befunde laedt das Dokument NICHT neu (nur der
  // Hash aendert sich), erreicht die Ansicht aber trotzdem nicht.
  if (altAnkerWeiterreichen()) return;


  if (hatKapitel) content.classList.add('kapitel-modus');

  // Pfad-Modus (27.08.2026): traegt <main> eine Kapitel-Basis (z.B.
  // /projekt/gigahertz), sind die Ebene-2-Links echte Pfad-URLs
  // (…/keywords) und die Navigation laeuft ueber die History-API statt
  // ueber den Hash. Der Hash bleibt fuer Anker INNERHALB eines Kapitels
  // (Ebene 3 / Zwischenueberschriften) und fuer Alt-Links (#keywords),
  // die beim Start per replaceState auf die Pfad-Form umgeschrieben werden.
  var kapitelBasis = content.getAttribute('data-kapitel-basis') || '';
  var kapitelStart = content.getAttribute('data-kapitel-start') || '';

  function kapitelIdx(id) {
    for (var i = 0; i < tabs.length; i++) { if (tabs[i].getAttribute('data-kapitel-id') === id) return i; }
    return -1;
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var aktivIdx = 0;
  var wechselLaeuft = false;

  function headerHoehe() {
    // 0 ist seit C1 (30.08.2026) ein GUELTIGER Wert: auf dem Schreibtisch gibt
    // es keinen Kopfbalken mehr. Das fruehere `|| 60` haette daraus 60 px
    // gemacht und jeden Ankersprung um genau diesen Betrag verfehlt.
    var roh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10);
    return isNaN(roh) ? 60 : roh;
  }

  /**
   * Hoehe dessen, was oben tatsaechlich KLEBT. Seit R3 ist das der ganze
   * .sr-kopf (Ueberschrift + Reiterzeile), nicht mehr nur die Leiste — die
   * frueheren Rechnungen `headerHoehe() + leiste.offsetHeight` liessen die
   * Titelzeile aus und verfehlten jeden Ankersprung um deren Hoehe.
   *
   * GEMESSEN, NICHT GERECHNET: die Hoehe haengt an Titel-Umbruch, Unterzeile
   * und daran, ob es ueberhaupt Reiter gibt. Eine Konstante stimmt genau so
   * lange, bis ein Titel zweizeilig wird.
   */
  var srKopf = document.querySelector('.sr-kopf');
  function kopfHoehe() {
    if (srKopf) return Math.round(srKopf.getBoundingClientRect().height);
    return headerHoehe() + (leiste && !leiste.hidden ? leiste.offsetHeight : 0);
  }
  /** Luft zwischen klebendem Kopf und Sprungziel (Betreiber-Vorgabe: 30 px). */
  var ANKER_LUFT = 30;

  /**
   * Ankersprung NACHFUEHREN, solange die Seite unter dem Ziel noch waechst.
   *
   * BEFUND 31.08.2026: ein Deeplink auf einen Befund in 6.4
   * (…/technik#befund-a11y-aria-command-name) landete 312 px daneben — beim
   * Sprung sass er richtig (24 px unter dem Kopf), danach rendern die
   * Diagramme DARUEBER aus, schieben alles nach unten, und das Ziel stand
   * schliesslich 288 px ueber der Kopfkante, also ausserhalb des Bildes. Ein
   * einmaliges scrollIntoView trifft eine Seite, die es zu diesem Zeitpunkt
   * noch gar nicht gibt.
   *
   * Deshalb: nach jeder Groessenaenderung des Inhalts nachziehen — hoechstens
   * drei Sekunden lang, und SOFORT aufhoeren, sobald der Leser selbst
   * scrollt. Eine Seite, die gegen den Nutzer zurueckspringt, waere schlimmer
   * als ein danebenliegender Sprung.
   */
  function ankerNachfuehren(ziel) {
    if (!ziel) return;
    ziel.scrollIntoView({ block: 'start' });
    if (!('ResizeObserver' in window)) return;
    var ereignisse = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
    var ro = new ResizeObserver(function () { ziel.scrollIntoView({ block: 'start' }); });
    function aufraeumen() {
      window.clearTimeout(timer);
      ro.disconnect();
      ereignisse.forEach(function (e) { window.removeEventListener(e, aufraeumen); });
    }
    ereignisse.forEach(function (e) { window.addEventListener(e, aufraeumen, { passive: true }); });
    var timer = window.setTimeout(aufraeumen, 3000);
    ro.observe(content);
  }

  /* -------------------------------------------------- Ebene 3: Baender ---- */
  var baender = leiste ? [].slice.call(leiste.querySelectorAll('.unterkapitel-band')) : [];
  var aktuellesBand = null, ukTabs = [], ukZiele = [], ukAktivIdx = 0;

  function bandFuer(kapitelId) {
    for (var i = 0; i < baender.length; i++) {
      if (baender[i].getAttribute('data-fuer-kapitel') === kapitelId) return baender[i];
    }
    return null;
  }

  function ukIndikatorPositionieren(i, animiert) {
    if (!aktuellesBand) return;
    var indikator = aktuellesBand.querySelector('.unterkapitel-indikator');
    var tab = ukTabs[i];
    if (!indikator || !tab) return;
    if (!animiert) indikator.classList.add('unterkapitel-indikator--springt');
    indikator.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
    indikator.style.width = tab.offsetWidth + 'px';
    if (!animiert) {
      void indikator.offsetWidth; // Reflow erzwingen, bevor der Sprung-Modus wieder verlassen wird
      indikator.classList.remove('unterkapitel-indikator--springt');
    }
  }

  function ukAktivSetzen(i) {
    ukAktivIdx = i;
    ukTabs.forEach(function (t, idx) {
      if (idx === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    ukIndikatorPositionieren(i, false);
  }

  /** Scroll-Spy: der zuletzt (von oben) passierte Unterabschnitt gilt als aktiv. */
  function ukScrollSpyAktualisieren() {
    if (bandIstAnsichten(aktuellesBand)) return;
    if (!aktuellesBand || aktuellesBand.hidden || !ukZiele.length) return;
    // Panel (noch) verborgen? getBoundingClientRect() liefert dann 0/0/0/0
    // fuer ALLE Ziele — die Schleife unten saehe "alle passiert" und
    // markierte faelschlich den LETZTEN Unterabschnitt (Betreiber-Meldung
    // 27.08.2026, zweiter Anlauf: der Fall trat beim KLICK-Kapitelwechsel
    // auf, wo bandAnzeigen() vor dem Einblenden des neuen Panels laeuft).
    // Unsichtbar heisst: es gilt der Anfang, Ebene 3 zeigt den ersten Punkt;
    // zeigen() ruft den Spy nach dem Einblenden erneut mit echten Werten.
    var erstes = null;
    for (var v = 0; v < ukZiele.length; v++) { if (ukZiele[v]) { erstes = ukZiele[v]; break; } }
    if (!erstes) return;
    var probe = erstes.getBoundingClientRect();
    if (!probe.width && !probe.height) { ukAktivSetzen(0); return; }
    /* Die Grenze muss ETWAS UNTER dem Landepunkt eines Ankersprungs liegen
       (Kopf + ANKER_LUFT), sonst gilt der gerade angesprungene Abschnitt als
       „noch nicht passiert" und der Scroll-Spy markiert den davor — gemessen
       auf /konto: Klick auf den vierten Reiter, hervorgehoben blieb der
       dritte. Die zehn Pixel sind der Sicherheitsabstand fuer Rundung und die
       1-px-Fuehlerzeile ueber dem Kopf. */
    var grenze = kopfHoehe() + ANKER_LUFT + 10;
    var aktiv = 0;
    for (var i = 0; i < ukZiele.length; i++) {
      if (!ukZiele[i]) continue;
      if (ukZiele[i].getBoundingClientRect().top - grenze <= 0) aktiv = i; else break;
    }
    ukAktivSetzen(aktiv);
  }

  /** Ansichts-Band: jeder Reiter ist eine eigene Adresse, kein Sprungziel. */
  function bandIstAnsichten(band) {
    return !!(band && band.hasAttribute('data-uk-ansichten'));
  }

  /** Ein Band zum aktuellen machen — Reiter und Sprungziele daran aufsammeln. */
  function bandUebernehmen(band) {
    aktuellesBand = band;
    ukTabs = band ? [].slice.call(band.querySelectorAll('.unterkapitel-tab')) : [];
    if (bandIstAnsichten(band)) {
      /* Ansichts-Band (Umbauplan Oberflaeche 31.08.2026): im Panel steht nur
         EIN Abschnitt, der Scroll-Spy haette nichts zu beobachten und wuerde
         mangels Zielen den ersten Reiter markieren — auch wenn gerade der
         vierte gilt. Der aktive Reiter kommt deshalb serverseitig
         (aria-current), der Indikator folgt ihm. */
      ukZiele = [];
      var aktiv = 0;
      for (var n = 0; n < ukTabs.length; n++) {
        if (ukTabs[n].hasAttribute('aria-current')) { aktiv = n; break; }
      }
      ukAktivIdx = aktiv;
      ukIndikatorPositionieren(aktiv, false);
      return;
    }
    ukZiele = ukTabs.map(function (t) { return document.getElementById(t.getAttribute('data-unterkapitel-id')); });
  }

  /** Zeigt das zum Kapitel passende Unterkapitel-Band (falls vorhanden), verbirgt die uebrigen. */
  function bandAnzeigen(kapitelId) {
    if (!leiste) return;
    var passend = bandFuer(kapitelId);
    baender.forEach(function (b) { b.hidden = b !== passend; });
    leiste.hidden = !passend;
    bandUebernehmen(passend);
    if (passend) ukScrollSpyAktualisieren();
  }

  /**
   * animationend abwarten, aber nicht darauf verlassen: faellt das Ereignis
   * aus irgendeinem Grund aus (z.B. eine CSS-Regel greift auf einem Kunden-
   * Bildschirm unerwartet nicht), wuerde der Kapitel-Wechsel sonst fuer immer
   * haengen bleiben — ein deutlich schlimmerer Fehler als eine ausbleibende
   * Animation. timeout liegt knapp ueber der laengsten hier verwendeten
   * Animationsdauer (240ms).
   */
  function nachAnimation(el, callback) {
    var erledigt = false;
    function einmal() {
      if (erledigt) return;
      erledigt = true;
      el.removeEventListener('animationend', einmal);
      window.clearTimeout(timer);
      callback();
    }
    el.addEventListener('animationend', einmal);
    var timer = window.setTimeout(einmal, 320);
  }

  /* R3 (30.08.2026): die Seitenueberschrift IST der Kapitelname. Steht die
     Kapitelliste in der Navigationsspalte, muss sie beim Wechsel mitwandern —
     sonst behauptet der Kopf weiter das zuletzt geladene Kapitel. Der Text
     kommt aus dem Navigationseintrag selbst, damit es keine zweite Quelle
     gibt, die auseinanderlaufen kann. */
  /* REITER-MERKER (08.09.2026, Verwaltung → KI-Anbieter): Formulare, die zur
     SELBEN Seite zurueckfuehren, tragen ein verstecktes Feld `reiter`. Ohne
     es beantwortet der Server jede Aktion wieder mit dem ersten Abschnitt —
     ein GET-Formular verliert beim Absenden den Hash, ein POST kommt ohne
     ihn an. Der Wert wird hier bei JEDEM Wechsel nachgezogen, damit er auch
     nach einem reinen Klickwechsel ohne Neuladen stimmt; ohne das Nachziehen
     traege er ewig den Reiter, mit dem die Seite geladen wurde.
     Die Felder tragen `data-reiter-feld` — welche Seite sie stellt, ist hier
     gleichgueltig, der Baustein gilt fuer jede Seite mit Reitern. */
  function reiterFelderSetzen(id) {
    if (!id) return;
    var felder = document.querySelectorAll('[data-reiter-feld]');
    for (var i = 0; i < felder.length; i++) felder[i].value = id;
  }

  var h1 = document.querySelector('.sr-kopf .sr-h1');
  function ueberschriftSetzen(tab) {
    if (!h1 || !tab) return;
    // NUR wenn die Kapitel in der Navigationsspalte stehen (Projektseiten).
    // Liegen sie als Reiterzeile im Kopf, ist die Ueberschrift der SEITENname
    // und der Reiter ein Abschnitt darin — dort waere das Fortschreiben falsch.
    var t = tab.querySelector('.sr-nav-item-text');
    if (!t) return;
    var text = t.textContent;
    if (text) h1.textContent = text.trim();
  }

  /* NUR DAS ANGEFORDERTE KAPITEL STEHT IM DOM (04.09.2026, Task cmtlsckwh):
     der Server rendert die uebrigen acht als leere Huellen mit
     data-kapitel-lazy — 270 bis 710 KB HTML je Seite waren zu 90 % Kapitel,
     die niemand sah. Ein Wechsel auf eine Huelle ist deshalb eine echte
     Navigation (die Links sind ohnehin echte URLs, der Server rendert jedes
     Kapitel direkt); der SPA-Wechsel bleibt nur noch fuer Panels mit Inhalt —
     heute keines mehr, die Weiche haelt das Verhalten aber tolerant, falls
     eine Seite doch alle Kapitel liefert (Alt-Aufrufer, Proben). */
  function huelle(idx) {
    var p = panels[idx];
    return !!(p && p.hasAttribute('data-kapitel-lazy'));
  }
  function nachladen(idx, ersetzen) {
    var url = kapitelBasis + '/' + tabs[idx].getAttribute('data-kapitel-id') + (location.hash || '');
    if (ersetzen) location.replace(url); else location.assign(url);
  }

  /** Anfangszustand ohne jede Animation setzen — das ist Seitenaufbau, kein Wechsel. */
  function anfangsZustand(idx) {
    if (kapitelBasis && huelle(idx)) { nachladen(idx, true); return; }
    panels.forEach(function (p, i) { p.hidden = i !== idx; });
    tabs.forEach(function (t, i) { if (i === idx) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    aktivIdx = idx;
    bandAnzeigen(tabs[idx].getAttribute('data-kapitel-id'));
    ueberschriftSetzen(tabs[idx]);
    reiterFelderSetzen(tabs[idx].getAttribute('data-kapitel-id'));
    requestAnimationFrame(kapitelReiterSichtbar);
  }

  /** Von einem Panel zum anderen wechseln — gerichteter Ein-/Ausflug. */
  function aktivieren(ziel, o) {
    o = o || {};
    if (ziel === aktivIdx || wechselLaeuft || ziel < 0 || ziel >= panels.length) return;
    if (kapitelBasis && huelle(ziel)) { nachladen(ziel, false); return; }
    var alt = aktivIdx;
    var altPanel = panels[alt];
    var neuPanel = panels[ziel];
    var nachRechts = ziel > alt;

    tabs.forEach(function (t, i) { if (i === ziel) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    aktivIdx = ziel;
    bandAnzeigen(tabs[ziel].getAttribute('data-kapitel-id'));
    ueberschriftSetzen(tabs[ziel]);
    reiterFelderSetzen(tabs[ziel].getAttribute('data-kapitel-id'));
    requestAnimationFrame(kapitelReiterSichtbar);

    function zeigen() {
      neuPanel.hidden = false;
      // Jetzt existieren echte Positionen — Ebene 3 nachziehen (siehe
      // Unsichtbar-Guard in ukScrollSpyAktualisieren()).
      ukScrollSpyAktualisieren();
      if (!reduceMotion) {
        var reinKlasse = nachRechts ? 'kapitel-enter-rechts' : 'kapitel-enter-links';
        neuPanel.classList.add(reinKlasse);
        nachAnimation(neuPanel, function () { neuPanel.classList.remove(reinKlasse); });
      }
      wechselLaeuft = false;
    }

    if (reduceMotion) {
      altPanel.hidden = true;
      zeigen();
    } else {
      wechselLaeuft = true;
      var rausKlasse = nachRechts ? 'kapitel-exit-links' : 'kapitel-exit-rechts';
      altPanel.classList.add(rausKlasse);
      nachAnimation(altPanel, function () {
        altPanel.hidden = true;
        altPanel.classList.remove(rausKlasse);
        zeigen();
      });
    }

    if (o.scrollen && window.scrollY > 40) {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }

  /**
   * Ziel-Kapitel aus einem Hash ermitteln: entweder ein Kapitel selbst
   * (#keywords) oder ein Element INNERHALB eines Kapitels (#keyword-verlauf,
   * eine Zwischenueberschrift — z.B. ein Unterkapitel aus Ebene 3) — dann
   * zaehlt das umschliessende Kapitel, und nach dem Wechsel wird zusaetzlich
   * zu genau dieser Stelle gescrollt.
   */
  function ausHash(hash) {
    var id = (hash || '').replace(/^#/, '');
    if (!id) return null;
    var direktIdx = -1;
    for (var i = 0; i < tabs.length; i++) { if (tabs[i].getAttribute('data-kapitel-id') === id) { direktIdx = i; break; } }
    if (direktIdx !== -1) return { idx: direktIdx, ziel: null };
    var el = document.getElementById(id);
    if (!el) return null;
    var panel = el.closest('.section');
    var idx = panels.indexOf(panel);
    if (idx === -1) return null;
    return { idx: idx, ziel: el };
  }

  window.addEventListener('hashchange', function () {
    if (altAnkerWeiterreichen()) return;
    var treffer = ausHash(location.hash);
    if (!treffer) return;
    aktivieren(treffer.idx, { scrollen: !treffer.ziel });
    if (kapitelBasis) {
      // Pfad nachziehen: ein Anker-Klick (#cwv) darf die Kapitel-URL nicht
      // luegen lassen. Ein reiner Kapitel-Hash (#keywords) wird komplett
      // durch die Pfad-Form ersetzt (kein doppeltes Ziel in der URL).
      history.replaceState(null, '', kapitelBasis + '/' + tabs[treffer.idx].getAttribute('data-kapitel-id') + (treffer.ziel ? location.hash : ''));
    }
    if (treffer.ziel) {
      window.setTimeout(function () {
        var y = treffer.ziel.getBoundingClientRect().top + window.pageYOffset - kopfHoehe() - ANKER_LUFT;
        window.scrollTo({ top: y < 0 ? 0 : y, behavior: reduceMotion ? 'auto' : 'smooth' });
      }, 60);
    }
  });

  window.addEventListener('resize', function () {
    ukIndikatorPositionieren(ukAktivIdx, false);
    kapitelReiterSichtbar();
  });

  if (hatKapitel) {
    // Anfangszustand: ein Hash gewinnt immer — er traegt Alt-Links
    // (#keywords) und Anker-Deeplinks (…/technik#cwv). Danach zaehlt im
    // Pfad-Modus das server-validierte Start-Kapitel aus der URL
    // (data-kapitel-start), sonst das erste Kapitel.
    var start = ausHash(location.hash);
    var hatteHash = !!location.hash;
    // `kapitelBasis` ist hier KEINE Bedingung mehr (04.09.2026, Punkt 19):
    // auch eine Seite ohne Kapitelpfade darf sagen, welches Kapitel offen
    // sein soll — etwa die Antwort auf einen POST, der aus Kapitel 04 kam.
    if (!start && kapitelStart) {
      var startIdx = kapitelIdx(kapitelStart);
      if (startIdx !== -1) start = { idx: startIdx, ziel: null };
    }
    if (!start) start = { idx: 0, ziel: null };
    anfangsZustand(start.idx);
    if (kapitelBasis && hatteHash) {
      // Alt-Hash-Links kanonisieren: #keywords -> …/keywords, #cwv -> …/technik#cwv.
      history.replaceState(null, '', kapitelBasis + '/' + tabs[start.idx].getAttribute('data-kapitel-id') + (start.ziel ? '#' + start.ziel.id : ''));
    }
    if (start.ziel) {
      window.setTimeout(function () { ankerNachfuehren(start.ziel); }, 0);
    } else if (hatteHash) {
      // Startbug-Fix (Betreiber-Meldung 27.08.2026): bei #kapitel-Aufrufen war
      // der Browser schon zum Panel-Anker gesprungen, BEVOR die uebrigen
      // Panels versteckt wurden — die Seite stand danach irgendwo unten und
      // der Scroll-Spy markierte den LETZTEN Unterabschnitt statt des ersten.
      // Ein Kapitel-Start ohne Ziel-Anker beginnt IMMER oben.
      window.scrollTo(0, 0);
      window.setTimeout(function () { window.scrollTo(0, 0); ukScrollSpyAktualisieren(); }, 0);
    }

    if (kapitelBasis) {
      // Ebene-2-Klicks: SPA-Wechsel + pushState statt Seiten-Neuladen. Klicks
      // mit Modifier oder Nicht-Haupttaste bleiben dem Browser ueberlassen —
      // die Links sind echte URLs, der Server rendert jedes Kapitel direkt.
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function (e) {
          if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          if (i !== aktivIdx) {
            history.pushState(null, '', kapitelBasis + '/' + t.getAttribute('data-kapitel-id'));
            aktivieren(i, { scrollen: true });
          } else if (window.scrollY > 40) {
            window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        });
      });

      // Zurueck/Vor: Kapitel aus dem Pfad wiederherstellen. Steht ein
      // aufloesbarer Hash in der URL, hat der hashchange-Listener oben den
      // Wechsel bereits behandelt (Anker-Historie) — doppeltes Scrollen waere
      // schlimmer als gar keins.
      window.addEventListener('popstate', function () {
        // Die Detail-Drawer veraendern nur die Suchparameter derselben
        // Ansicht. Dabei weder Kapitel wechseln noch die Tabelle nach oben scrollen.
        var detailParameter = new URLSearchParams(location.search);
        if (detailParameter.has('keyword') || detailParameter.has('seite') || document.querySelector('.kw-detail-drawer[open]')) return;
        if (location.hash && ausHash(location.hash)) return;
        var seg = '';
        try { seg = decodeURIComponent(location.pathname.split('/').pop() || ''); }
        catch (_) {} // Ungueltiger Pfad nutzt denselben Fallback wie unbekannte Kapitel.
        var idx = kapitelIdx(seg);
        aktivieren(idx === -1 ? 0 : idx, { scrollen: true });
      });
    }
  } else {
    /* SEITE OHNE KAPITEL (/konto seit dem 30.08.2026): es gibt genau ein Band,
       es ist von Anfang an sichtbar und wechselt nie. Kein Anfangszustand, kein
       Hash-Kapitel, kein Pfad-Modus — nur das Band uebernehmen, damit Klicks
       und Scroll-Spy darunter greifen. Ein Hash in der URL erledigt der
       Browser selbst; den Versatz gibt ihm scroll-padding-top (sr.css, aus
       --sr-kopf-h gerechnet). */
    bandUebernehmen(baender[0] || null);
    ukScrollSpyAktualisieren();
  }

  /* ------------------------------------------ Ebene 3: Klicks + Scroll-Spy */
  if (leiste) {
    [].slice.call(leiste.querySelectorAll('.unterkapitel-tab')).forEach(function (t) {
      // Extern-Link-Kachel (Slice M, z.B. "3.5 Cluster" -> eigene Seite,
      // layout.js unterkapitelZoneHtml()): kein In-Seiten-Ziel, also nativ
      // navigieren lassen statt Scroll-Spy-Logik anzuwenden.
      if (t.hasAttribute('data-unterkapitel-extern')) return;
      t.addEventListener('click', function (e) {
        // Eigener Versatz (Kopfzeile + Leiste) noetig, deshalb kein natives
        // Anker-Springen — anders als bei Ebene 2 hier IMMER preventDefault.
        e.preventDefault();
        var id = t.getAttribute('data-unterkapitel-id');
        if (location.hash === '#' + id) {
          var idx = ukTabs.indexOf(t);
          if (idx !== -1) ukAktivSetzen(idx);
          var ziel = document.getElementById(id);
          if (ziel) {
            var y = ziel.getBoundingClientRect().top + window.pageYOffset - kopfHoehe() - ANKER_LUFT;
            window.scrollTo({ top: y < 0 ? 0 : y, behavior: reduceMotion ? 'auto' : 'smooth' });
          }
          return;
        }
        location.hash = id;
      });
    });

    var spyTicking = false;
    window.addEventListener('scroll', function () {
      if (spyTicking) return;
      spyTicking = true;
      window.requestAnimationFrame(function () { ukScrollSpyAktualisieren(); spyTicking = false; });
    }, { passive: true });
  }
})();

/* ------------------------------------------------ 8) Kennzahl-Karten -------
 * Ganzzahlige Kennzahlen bewegen sich beim ersten Sichtbarwerden kurz in
 * ihre Position. Ihr Text bleibt dabei vom ersten DOM-Aufbau an der echte
 * Endwert, damit Screenshots, Vorlesehilfen und Auswertungen keinen
 * Zwischenstand als Kennzahl erfassen.
 * Karten in einem gerade verborgenen Kapitel werden erst beobachtet, sobald
 * sie durch einen Kapitel-Wechsel sichtbar werden (IntersectionObserver
 * feuert fuer display:none-Vorfahren ohnehin nicht).
 */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // '.kpi > .kv' war das Markup der entfallenen kpiLeiste() (01.09.2026).
  // Seit alle Kennzahlen ueber srKpiGitter() laufen, heisst die Zahl
  // .sr-kpi-wert — ohne diese Zeile haetten die zehn Kapitelkoepfe ihre
  // Aufbauanimation still verloren.
  var ziele = [].slice.call(document.querySelectorAll('.cards .card > .cv, .sr-kpi-wert'));
  if (!ziele.length) return;

  /** Fuehrende Ganzzahl (deutsches Tausendertrennzeichen) am Textanfang —
   * Datum ("30.07.2026") und Dezimalzahl ("3,4") bewusst ausgeschlossen. */
  function ersteZahl(text) {
    var m = /^(\d{1,3}(?:\.\d{3})+|\d+)/.exec(text);
    if (!m) return null;
    if (/^[.,]\d/.test(text.slice(m[0].length))) return null;
    var wert = parseInt(m[0].replace(/\./g, ''), 10);
    if (!isFinite(wert) || wert <= 0) return null;
    return { wert: wert, laenge: m[0].length };
  }

  function aufbauen(el) {
    if (typeof el.animate !== 'function') return;
    el.animate([
      { opacity: 0, transform: 'translateY(4px)' },
      { opacity: 1, transform: 'translateY(0)' }
    ], { duration: 360, easing: 'cubic-bezier(.23,1,.32,1)' });
  }

  /* Gleiche Kennzahl beim Reiterwechsel nicht erneut animieren (04.09.2026).
   * Ein Reiterwechsel ist hier eine echte Seitennavigation — nur das
   * angeforderte Kapitel und nur seine aktive Ansicht stehen im DOM. Der
   * Browser hat danach keine Erinnerung, also bewegte sich jede Kachel bei
   * jedem Reiterklick erneut, auch wenn dieselbe Zahl schon dastand.
   * Eine Aufbau-Animation soll den Aufbau zeigen, nicht das Blaettern.
   *
   * Gemerkt wird je Kapitelpfad und Kachel-Etikett (data-sr-kpi aus
   * srKpiGitter) der zuletzt gezeigte Zielwert. Stimmt er ueberein, bleibt
   * die Zahl einfach stehen. Der Kapitelpfad ist /projekt/<domain>/<kapitel>
   * OHNE die Ansicht — genau das, was ueber einen Reiterwechsel gleich
   * bleibt und sich beim Kapitel- oder Projektwechsel aendert.
   *
   * sessionStorage, nicht localStorage: die Erinnerung soll mit dem Tab
   * enden. Jeder Zugriff in try/catch — im privaten Fenster wirft schon das
   * Lesen, und eine fehlende Erinnerung ist kein Fehler, sondern nur eine
   * Animation mehr. */
  var kapitelPfad = window.location.pathname.split('/').slice(0, 4).join('/');
  function merkerLesen(schluessel) {
    try { return window.sessionStorage.getItem(schluessel); } catch (err) { return null; }
  }
  function merkerSchreiben(schluessel, wert) {
    try { window.sessionStorage.setItem(schluessel, wert); } catch (err) { /* egal */ }
  }
  function schluesselFuer(el) {
    var kachel = el.closest ? el.closest('[data-sr-kpi]') : null;
    if (!kachel) return null;
    return 'sr-kpi:' + kapitelPfad + '|' + kachel.getAttribute('data-sr-kpi');
  }

  /* ABGELOEST, SOBALD DER AUFTRITT LAEUFT (12.09.2026, Baustein 23).
   * Die Auftritts-Choreografie hebt die ganze Kachel ins Bild. Liefe hier
   * zusaetzlich die Zahl IN der Kachel los, federte derselbe Inhalt zweimal —
   * einmal mit seinem Rahmen, einmal gegen ihn. Der Baustein bleibt fuer
   * alles, was der Auftritt nicht anfasst; sobald dieser laeuft, traegt das
   * <html> die Marke und der Beobachter macht Schluss.
   * Die Pruefung steht IM Rueckruf, nicht davor: die Bausteine werden der
   * Reihe nach aufgebaut, der Auftritt ist der letzte — hier oben stuende die
   * Marke noch nicht. */
  function auftrittLaeuft() {
    var k = document.documentElement.classList;
    return k.contains('sr-auftritt-lauf') || k.contains('sr-auftritt-fertig');
  }

  var beobachter = new IntersectionObserver(function (eintraege) {
    if (auftrittLaeuft()) { beobachter.disconnect(); return; }
    eintraege.forEach(function (e) {
      if (!e.isIntersecting) return;
      beobachter.unobserve(e.target);
      var text = e.target.textContent;
      var info = ersteZahl(text);
      if (!info) return;
      var schluessel = schluesselFuer(e.target);
      if (schluessel) {
        // Verglichen wird der VOLLE Text der Kachel, nicht nur die fuehrende
        // Zahl: „24" und „24 %" sind verschiedene Aussagen, und ein
        // gewechselter Suffix soll die Animation wieder ausloesen.
        if (merkerLesen(schluessel) === text) return;
        merkerSchreiben(schluessel, text);
      }
      aufbauen(e.target);
    });
  }, { threshold: 0.4 });

  ziele.forEach(function (z) { beobachter.observe(z); });
})();

/* --------------------------------------------------------- 9) Diagramme ----
 * Linien (lib/svg.js lineChart) und Sparklines zeichnen sich beim ersten
 * Sichtbarwerden ein (stroke-dashoffset), Punkte blenden kurz danach nach.
 * pathLength="1" normiert die Pfadlaenge, damit kein getTotalLength() noetig
 * ist. Alles inline per .style gesetzt (wie schon der Breite-Regler,
 * Baustein 4) — von style-src unter der strikten CSP unbetroffen.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var charts = [].slice.call(document.querySelectorAll('svg.chart, svg.spark'));
  if (!charts.length) return;

  // Dieselbe Kurve wie --ease in theme.css (dort nicht per JS auslesbar ohne
  // Whitespace-Stolperfallen) — ein sanftes Abbremsen zum Ende hin.
  var EASE = 'cubic-bezier(.23,1,.32,1)';

  var beobachter = new IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (e) {
      if (!e.isIntersecting) return;
      beobachter.unobserve(e.target);
      var svg = e.target;
      var linie = svg.querySelector('path[fill="none"]');
      var punkte = [].slice.call(svg.querySelectorAll('circle'));
      punkte.forEach(function (p) { p.style.opacity = '0'; p.style.transition = 'opacity 240ms ' + EASE; });
      if (linie) {
        linie.setAttribute('pathLength', '1');
        linie.style.strokeDasharray = '1';
        linie.style.strokeDashoffset = '1';
        linie.style.transition = 'stroke-dashoffset 820ms ' + EASE;
      }
      void svg.getBoundingClientRect(); // Reflow erzwingen, bevor die Zielwerte gesetzt werden
      requestAnimationFrame(function () {
        if (linie) linie.style.strokeDashoffset = '0';
        window.setTimeout(function () {
          punkte.forEach(function (p) { p.style.opacity = '1'; });
        }, linie ? 560 : 0);
      });
    });
  }, { threshold: 0.2 });

  charts.forEach(function (c) { beobachter.observe(c); });
})();

/* --------------------------------------- 10) DashboardMaster-Fassade -------
 * Feature 3, Stufe A (Fable-Gate 31.07.2026, Entscheidungs-Doku Abschnitt 7).
 * Click-to-Load laeuft ueber ein ECHTES <form method="post"> auf
 * /projekt/:name/dbm-embed-laden (app/server.js) — der Server rendert die
 * ganze Seite neu und liefert dabei erst den iframe mit der echten DBM-URL
 * (app/views/projekt.js, dbmFassadeGeladenHtml()); vor dem Klick besteht
 * keine Verbindung zum DashboardMaster. BEWUSST KEIN fetch()/XHR hier: die
 * CSP hat kein connect-src (faellt sonst auf default-src 'none' zurueck) —
 * ein fetch auf den eigenen Origin waere ebenso blockiert wie einer auf den
 * DBM-Host, und `connect-src` nachzuruesten haette Auflage 1 verletzt
 * ("GENAU EINE neue Direktive", siehe app/server.js CSP-Middleware). Das
 * Formular funktioniert deshalb sogar ganz OHNE JavaScript.
 *
 * Dieser Baustein ist rein kosmetisch: er deaktiviert den Knopf beim
 * Absenden, damit ein zweiter Klick waehrend des Ladens der neuen Seite
 * nicht doppelt sendet, und zeigt "Lädt …" an. Kein message-Listener
 * (Auflage 6) — diese Fassade tauscht ohnehin keine Daten mit dem
 * eingebetteten Inhalt aus.
 */
(function () {
  var formulare = [].slice.call(document.querySelectorAll('[data-dbm-fassade] form'));
  formulare.forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[data-dbm-fassade-btn]');
      if (!btn) return;
      btn.disabled = true;
      btn.textContent = 'Lädt …';
    });
  });
})();

/* ------------------------------------------- 11) Drilldown-Tabellenzeilen
 * Tabellen mit der Klasse .tbl-drill (Content-Aenderungs-Log 3.3,
 * Audit-Befunde 3.4): auf jede .drill-Zeile folgt eine .drill-detail-Zeile
 * mit den Details. Ohne JavaScript bleiben alle Details sichtbar
 * (progressive enhancement); hier werden sie eingeklappt und die Zeile wird
 * zum Schalter (Klick, Enter, Leertaste). Ein Anker-Sprung auf eine
 * Drill-Zeile (Heatmap-Klick #log-…) klappt sie automatisch auf.
 * Diese Tabellen liegen bewusst NICHT in .tbl-wrap — Betreiber-Vorgabe
 * "komplett anzeigen, kein Scrollfenster" — und bleiben damit auch von der
 * Spalten-Sortierung (Baustein 6, bindet nur .tbl-wrap table) unberuehrt,
 * die die Zeilen-Paare zerreissen wuerde.
 */
(function () {
  var zeilen = [].slice.call(document.querySelectorAll('table.tbl-drill tr.drill'));
  if (!zeilen.length) return;

  function umschalten(zeile, detail) {
    detail.hidden = !detail.hidden;
    zeile.classList.toggle('drill--offen', !detail.hidden);
    zeile.setAttribute('aria-expanded', detail.hidden ? 'false' : 'true');
  }

  zeilen.forEach(function (zeile) {
    var detail = zeile.nextElementSibling;
    if (!detail || !detail.classList.contains('drill-detail')) return;
    detail.hidden = true;
    zeile.setAttribute('tabindex', '0');
    zeile.setAttribute('role', 'button');
    zeile.setAttribute('aria-expanded', 'false');
    zeile.addEventListener('click', function (e) {
      // Links bleiben Links — und Bedienelemente bleiben Bedienelemente:
      // die Cluster-Tabelle (Keywords → Verwaltung, 06.09.2026) traegt in
      // ihren Drill-Zeilen Auswahlkaestchen, Icon-Knoepfe und ein
      // Inline-Formular; ein Klick darauf darf die Zeile nicht umschalten.
      if (e.target.closest('a, button, input, select, textarea, label, form')) return;
      umschalten(zeile, detail);
    });
    zeile.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (e.target !== zeile) return; // Enter im Inline-Formular schickt das Formular ab, nicht die Zeile um
      e.preventDefault();
      umschalten(zeile, detail);
    });
  });

  function ankerOeffnen() {
    var id = (location.hash || '').replace(/^#/, '');
    if (!id) return;
    var el = document.getElementById(id);
    if (!el || !el.classList || !el.classList.contains('drill')) return;
    var detail = el.nextElementSibling;
    if (detail && detail.classList.contains('drill-detail') && detail.hidden) umschalten(el, detail);
  }
  window.addEventListener('hashchange', function () { window.setTimeout(ankerOeffnen, 100); });
  ankerOeffnen();
})();


/* ------------------------------------- 11b) Cluster-Zuordnung im Drilldown
 * (Keywords → Verwaltung, 06.09.2026): das Formular data-zuordnung traegt
 * einen Zaehler „n von m zugeordnet" und die Knoepfe „Alle"/„Keine". Ohne
 * JavaScript stehen Kaestchen und Speichern-Knopf unveraendert da — die
 * beiden Knoepfe sind type=button und tun dann schlicht nichts.
 */
(function () {
  [].slice.call(document.querySelectorAll('form[data-zuordnung]')).forEach(function (form) {
    var kaestchen = [].slice.call(form.querySelectorAll('input[type="checkbox"][name="keywords"]'));
    var zaehler = form.querySelector('[data-zuordnung-zaehler]');
    function zaehlen() {
      if (!zaehler) return;
      var n = kaestchen.filter(function (k) { return k.checked; }).length;
      zaehler.textContent = n + ' von ' + kaestchen.length + ' zugeordnet';
    }
    kaestchen.forEach(function (k) { k.addEventListener('change', zaehlen); });
    var alle = form.querySelector('[data-zuordnung-alle]');
    var keine = form.querySelector('[data-zuordnung-keine]');
    if (alle) alle.addEventListener('click', function () { kaestchen.forEach(function (k) { k.checked = true; }); zaehlen(); });
    if (keine) keine.addEventListener('click', function () { kaestchen.forEach(function (k) { k.checked = false; }); zaehlen(); });
  });
})();


/* --------------------------------------- 13) Anbindungen-Sofortlauf --------
 * Nur auf /anbindungen fuer superadmin vorhanden (.anb-aktionen, gebaut in
 * app/views/anbindungen.js). Ein Klick: POST /anbindungen/lauf startet die
 * definierte Aktion, dann EventSource auf /anbindungen/lauf/<id>/strom —
 * jede Protokollzeile faellt weich in die Konsole (CSS .anb-zeile), der
 * Status-Chip atmet solange der Lauf laeuft. Es laeuft serverseitig genau
 * EIN Lauf zur Zeit — waehrenddessen sind ALLE Knoepfe gesperrt. CSRF wie
 * ueberall: x-csrf-token aus dem Abmelde-Formular (Baustein 4-Muster).
 * Ohne EventSource-Faehigkeit bleibt die Seite reine Bestandsansicht. */
(function () {
  var bloecke = [].slice.call(document.querySelectorAll('.anb-aktionen'));
  if (!bloecke.length || !window.EventSource) return;
  var csrfFeld = document.querySelector('.usermenu-form input[name="_csrf"]');
  var alleKnoepfe = [].slice.call(document.querySelectorAll('.anb-btn[data-aktion]'));
  var aktiv = false;

  bloecke.forEach(function (block) {
    var konsole = block.querySelector('.anb-konsole');
    var strom = block.querySelector('.anb-konsole-strom');
    var statusEl = block.querySelector('.anb-konsole-status');
    var ausKnopf = block.querySelector('[data-anb-aus]');
    if (!konsole || !strom || !statusEl) return;

    /* R9 "Ladezustand mit Zeitgrenze und Ausgang": bis hierher hatte der
       Ladezustand einen Ausgang (es.onerror), aber keine Grenze — blieb der
       Strom stumm, drehte der Knopf unbegrenzt weiter. Drei Uhren beheben das:
         TICK      laufende Sekundenanzeige, damit Warten messbar ist
         STILLE    90 s ohne jede Zeile: einmalige Meldung, Ausgang wird sichtbar
         GRENZE    15 min: harte Kappe, deckungsgleich mit ZEITLIMIT_MS in
                   app/lib/anbindungen-lauf.js — laeuft der Server in sein
                   eigenes Limit, sagt die Anzeige dasselbe.
       Der Ausgang beendet nur die ANZEIGE. Der Lauf auf dem Server laeuft
       weiter — genau das sagt der Knopf auch, statt eine Wirkung vorzutaeuschen
       die er nicht hat. */
    var STILLE_MS = 90 * 1000;
    var GRENZE_MS = 15 * 60 * 1000;
    var esOffen = null;
    var uhrTick = null, uhrStille = null, uhrGrenze = null;
    var beginn = 0;
    var stilleGemeldet = false;

    function mmss(ms) {
      var t = Math.max(0, Math.round(ms / 1000));
      return Math.floor(t / 60) + ':' + ('0' + (t % 60)).slice(-2);
    }
    function uhrenAus() {
      if (uhrTick) { clearInterval(uhrTick); uhrTick = null; }
      if (uhrStille) { clearTimeout(uhrStille); uhrStille = null; }
      if (uhrGrenze) { clearTimeout(uhrGrenze); uhrGrenze = null; }
    }
    function stilleNeuStellen() {
      if (uhrStille) clearTimeout(uhrStille);
      uhrStille = setTimeout(function () {
        if (!aktiv || stilleGemeldet) return;
        stilleGemeldet = true;
        zeile('── Seit ' + Math.round(STILLE_MS / 1000) + ' s keine Zeile mehr. Die Verbindung steht noch; lange Schritte melden sich erst am Ende. Spaetestens nach ' + Math.round(GRENZE_MS / 60000) + ' Minuten bricht die Anzeige von selbst ab. ──', 'anb-zeile--meta');
      }, STILLE_MS);
    }

    function zeile(text, klasse) {
      var d = document.createElement('div');
      d.className = 'anb-zeile' + (klasse ? ' ' + klasse : '');
      d.textContent = text;
      strom.appendChild(d);
      while (strom.children.length > 2000) strom.removeChild(strom.firstChild);
      strom.scrollTop = strom.scrollHeight;
    }
    function status(text, art) {
      statusEl.textContent = text;
      statusEl.className = 'anb-konsole-status' + (art ? ' anb-konsole-status--' + art : '');
      konsole.classList.toggle('anb-konsole--laeuft', art === 'laeuft');
    }
    function sperren(zu) {
      alleKnoepfe.forEach(function (b) { b.disabled = zu; });
    }
    function abschliessen(btn, art, text) {
      aktiv = false;
      uhrenAus();
      esOffen = null;
      if (ausKnopf) ausKnopf.hidden = true;
      btn.classList.remove('laedt');
      sperren(false);
      status(text, art);
      zeile(art === 'fertig'
        ? '── Lauf beendet. Bestandszahlen oben aktualisieren sich mit dem nächsten Seitenaufruf. ──'
        : '── Lauf mit Fehler beendet — Details stehen oben im Protokoll. ──', 'anb-zeile--meta');
    }

    if (ausKnopf) {
      ausKnopf.addEventListener('click', function () {
        if (!aktiv) return;
        if (esOffen) { try { esOffen.close(); } catch (e) { /* schon zu */ } }
        var laufender = block.querySelector('.anb-btn.laedt') || block.querySelector('.anb-btn[data-aktion]');
        zeile('── Anzeige beendet. Der Lauf auf dem Server laeuft weiter und wird dort zu Ende gefuehrt. ──', 'anb-zeile--meta');
        abschliessen(laufender, '', 'Anzeige beendet');
      });
    }

    [].slice.call(block.querySelectorAll('.anb-btn[data-aktion]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (aktiv) return;
        aktiv = true;
        sperren(true);
        btn.classList.add('laedt');
        konsole.hidden = false;
        strom.textContent = '';
        status('verbinde …', 'laeuft');
        zeile('── Starte „' + (btn.textContent || '').trim() + '" … ──', 'anb-zeile--meta');

        fetch('/anbindungen/lauf', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'x-csrf-token': csrfFeld ? csrfFeld.value : ''
          },
          body: 'aktion=' + encodeURIComponent(btn.getAttribute('data-aktion'))
        }).then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, j: j }; });
        }).then(function (antwort) {
          if (!antwort.ok || !antwort.j.id) {
            zeile('[fehler] ' + (antwort.j.fehler || 'Start fehlgeschlagen'), 'anb-zeile--err');
            abschliessen(btn, 'fehler', 'Start fehlgeschlagen');
            return;
          }
          status('läuft …', 'laeuft');
          var es = new EventSource('/anbindungen/lauf/' + encodeURIComponent(antwort.j.id) + '/strom');
          esOffen = es;
          beginn = Date.now();
          stilleGemeldet = false;
          if (ausKnopf) ausKnopf.hidden = false;
          uhrTick = setInterval(function () {
            if (aktiv) status('läuft … ' + mmss(Date.now() - beginn), 'laeuft');
          }, 1000);
          stilleNeuStellen();
          uhrGrenze = setTimeout(function () {
            if (!aktiv) return;
            es.close();
            zeile('── Zeitgrenze von ' + Math.round(GRENZE_MS / 60000) + ' Minuten erreicht — die Anzeige bricht ab. Das Ergebnis des Laufs steht im Protokoll auf dem Server; die Bestandszahlen oben zeigen es beim naechsten Seitenaufruf. ──', 'anb-zeile--err');
            abschliessen(btn, 'fehler', 'Zeitgrenze erreicht');
          }, GRENZE_MS);
          es.addEventListener('zeile', function (ev) {
            var z = {};
            try { z = JSON.parse(ev.data); } catch (e) { z = { text: ev.data }; }
            stilleNeuStellen();
            zeile(z.text || '', z.strom === 'err' ? 'anb-zeile--err' : '');
          });
          es.addEventListener('ende', function (ev) {
            var z = {};
            try { z = JSON.parse(ev.data); } catch (e) { z = {}; }
            es.close();
            if (z.fehler) {
              zeile('[fehler] ' + z.fehler, 'anb-zeile--err');
              abschliessen(btn, 'fehler', 'abgebrochen');
            } else if (z.rc === 0) {
              abschliessen(btn, 'fertig', 'beendet · rc=0');
            } else {
              abschliessen(btn, 'fehler', 'beendet · rc=' + z.rc);
            }
          });
          es.onerror = function () {
            if (!aktiv) { es.close(); return; }
            es.close();
            zeile('[verbindung] Protokoll-Strom unterbrochen.', 'anb-zeile--err');
            abschliessen(btn, 'fehler', 'Verbindung unterbrochen');
          };
        }).catch(function (e) {
          zeile('[fehler] ' + e.message, 'anb-zeile--err');
          abschliessen(btn, 'fehler', 'Start fehlgeschlagen');
        });
      });
    });
  });
})();


/* ---------------------------------------------- 14) Kommandopalette --------
 * Strg/Cmd+K (Design v2, AP2 „App-Gefühl"): zentriertes Such-Modal ueber die
 * schon gerenderte Navigation — kein eigener Server-Endpunkt, keine eigene
 * Datenhaltung. Datenquelle beim OEFFNEN frisch aus dem DOM eingesammelt
 * (drei Koerbe: Kapitel-Subnav der aktuellen Seite, uebrige Sidebar-Links,
 * Mega-Menue falls vorhanden) — die Gruppen-Beschriftung kommt, wo moeglich,
 * aus dem jeweils naechstgelegenen .nav-group/.mega-gruppe-titel (tolerant,
 * mit generischem Rueckfall). Markup wird einmalig per createElement gebaut
 * und an den Body gehaengt; Sichtbarkeit traegt [hidden] (selbes Muster wie
 * die Dropdowns oben), .offen setzt nur die Zielwerte der Transition
 * (motion-spec „Modal öffnen": Karte scale(.97)→1 + Scrim-Fade, 200 ms/spring).
 */
(function () {
  var scrim = document.createElement('div');
  scrim.className = 'palette-scrim';
  scrim.setAttribute('hidden', '');

  var palette = document.createElement('div');
  palette.className = 'palette';
  palette.setAttribute('hidden', '');
  palette.setAttribute('role', 'dialog');
  palette.setAttribute('aria-modal', 'true');
  palette.setAttribute('aria-label', 'Schnellsuche');

  var eingabe = document.createElement('input');
  eingabe.type = 'text';
  eingabe.className = 'palette-eingabe';
  eingabe.setAttribute('placeholder', 'Wohin? Bereich, Seite oder Projekt…');
  eingabe.setAttribute('autocomplete', 'off');
  eingabe.setAttribute('spellcheck', 'false');

  var liste = document.createElement('div');
  liste.className = 'palette-liste';
  liste.setAttribute('role', 'listbox');

  palette.appendChild(eingabe);
  palette.appendChild(liste);
  document.body.appendChild(scrim);
  document.body.appendChild(palette);

  var offen = false;
  var vorherigerFokus = null;
  var alleEintraege = [];
  var treffer = [];
  var zeilenEls = [];
  var aktiverIndex = -1;

  /** Sichtbarer Text eines Nav-Links OHNE Ziffern-Glyphe/Ampel/Meta-Zusatz
   *  (die stehen in eigenen <span>s, ohne sie klebt z.B. die Kapitelnummer
   *  direkt am Titel: "01Übersicht" statt "Übersicht"). */
  function paletteText(el) {
    var klon = el.cloneNode(true);
    [].slice.call(klon.querySelectorAll('.n, .nav-ampel, .ampel')).forEach(function (x) {
      if (x.parentNode) x.parentNode.removeChild(x);
    });
    return (klon.textContent || '').replace(/\s+/g, ' ').trim();
  }

  /** Gruppen-Beschriftung eines Sidebar-Links: Verwaltung traegt ihren eigenen
   *  Knopf statt eines .nav-group, sonst zaehlt der naechste .nav-group-
   *  Geschwisterknoten davor (gleiche Ebene — auch innerhalb von .nur-mobil). */
  function paletteGruppeFuer(el) {
    if (el.closest('.sr-projektwechsel')) return el.getAttribute('href').startsWith('/cluster/') ? 'Cluster' : 'Projekte';
    var verwaltung = el.closest('.nav-verwaltung');
    if (verwaltung) {
      var kopf = verwaltung.querySelector('.nav-verwaltung-kopf');
      return ((kopf && kopf.textContent) || 'Verwaltung').trim();
    }
    for (var sib = el.previousElementSibling; sib; sib = sib.previousElementSibling) {
      if (sib.classList && sib.classList.contains('nav-group')) return (sib.textContent || '').trim();
    }
    return 'Seiten';
  }

  function paletteEinsammeln() {
    var eintraege = [];
    var subnav = document.getElementById('kapitelSubnav');
    if (subnav) {
      [].slice.call(subnav.querySelectorAll('.nav-item[data-kapitel-id]')).forEach(function (a) {
        eintraege.push({ label: paletteText(a), gruppe: 'Bereiche', el: a });
      });
    }
    [].slice.call(document.querySelectorAll('.sidebar a.nav-item')).forEach(function (a) {
      if (subnav && subnav.contains(a)) return; // schon oben erfasst (Kapitel)
      eintraege.push({ label: paletteText(a), gruppe: paletteGruppeFuer(a), el: a });
    });
    // Dublette raus (z.B. Projekt in Sidebar UND Mega-Menue): gleicher Text
    // + gleiches Ziel (href, sonst Kapitel-id) = EIN Eintrag; der erste
    // gewinnt (Sidebar vor Mega-Menue, Reihenfolge des Einsammelns).
    var gesehen = {};
    return eintraege.filter(function (e) {
      if (!e.label) return false;
      var ziel = e.el.getAttribute('href') || e.el.getAttribute('data-kapitel-id') || '';
      var schluessel = e.label.toLowerCase() + '|' + ziel;
      if (gesehen[schluessel]) return false;
      gesehen[schluessel] = true;
      return true;
    });
  }

  /** Case-insensitive Teilstring, bei mehreren Woertern muessen alle treffen. */
  function paletteGefiltert(alle, q) {
    var woerter = String(q || '').toLowerCase().trim().split(/\s+/).filter(Boolean);
    var basis = !woerter.length ? alle : alle.filter(function (e) {
      var hay = e.label.toLowerCase();
      return woerter.every(function (w) { return hay.indexOf(w) !== -1; });
    });
    return basis.slice(0, 10);
  }

  function aktivSetzen(i) {
    aktiverIndex = i;
    zeilenEls.forEach(function (z, idx) { z.classList.toggle('aktiv', idx === i); });
    if (zeilenEls[i]) zeilenEls[i].scrollIntoView({ block: 'nearest' });
  }

  function eintragWaehlen(e) {
    paletteSchliessen();
    if (e && e.el && typeof e.el.click === 'function') e.el.click();
  }

  function paletteRendern() {
    liste.textContent = '';
    treffer = paletteGefiltert(alleEintraege, eingabe.value);
    zeilenEls = [];
    if (!treffer.length) {
      var leer = document.createElement('div');
      leer.className = 'palette-leer';
      leer.textContent = 'Keine Treffer — ein kürzerer Suchbegriff oder ein anderes Wort führt meist weiter.';
      liste.appendChild(leer);
      aktiverIndex = -1;
      return;
    }
    var letzteGruppe = null;
    treffer.forEach(function (e, i) {
      if (e.gruppe !== letzteGruppe) {
        var kopf = document.createElement('div');
        kopf.className = 'palette-gruppe';
        kopf.textContent = e.gruppe;
        liste.appendChild(kopf);
        letzteGruppe = e.gruppe;
      }
      var zeile = document.createElement('div');
      zeile.className = 'palette-zeile';
      zeile.setAttribute('role', 'option');
      var text = document.createElement('span');
      text.textContent = e.label;
      var tagEl = document.createElement('span');
      tagEl.textContent = e.gruppe;
      zeile.appendChild(text);
      zeile.appendChild(tagEl);
      zeile.addEventListener('mouseenter', function () { aktivSetzen(i); });
      zeile.addEventListener('mousedown', function (ev) { ev.preventDefault(); }); // Fokus im Eingabefeld behalten
      zeile.addEventListener('click', function () { eintragWaehlen(e); });
      liste.appendChild(zeile);
      zeilenEls.push(zeile);
    });
    aktivSetzen(0);
  }

  function paletteOeffnen() {
    if (offen) return;
    offen = true;
    vorherigerFokus = document.activeElement;
    seoDropdowns.forEach(function (d) { if (d.offen()) d.setzen(false); });
    alleEintraege = paletteEinsammeln();
    eingabe.value = '';
    scrim.removeAttribute('hidden');
    palette.removeAttribute('hidden');
    paletteRendern();
    // Zwei rAF, damit der Browser den [hidden]-Ausgangszustand erst rendert,
    // bevor .offen die Zielwerte setzt — sonst greift die Transition nicht
    // (Sprung statt Einblenden), selbes Problem wie beim Kapitel-Wechsel oben.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scrim.classList.add('offen');
        palette.classList.add('offen');
      });
    });
    eingabe.focus();
  }

  function paletteSchliessen() {
    if (!offen) return;
    offen = false;
    scrim.classList.remove('offen');
    palette.classList.remove('offen');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function versteckt() {
      scrim.setAttribute('hidden', '');
      palette.setAttribute('hidden', '');
    }
    if (reduceMotion) {
      versteckt();
    } else {
      var erledigt = false;
      var timer = window.setTimeout(einmal, 260);
      function einmal() {
        if (erledigt) return;
        erledigt = true;
        palette.removeEventListener('transitionend', einmal);
        window.clearTimeout(timer);
        versteckt();
      }
      palette.addEventListener('transitionend', einmal);
    }
    if (vorherigerFokus && typeof vorherigerFokus.focus === 'function') vorherigerFokus.focus();
  }

  scrim.addEventListener('click', paletteSchliessen);

  eingabe.addEventListener('input', paletteRendern);
  eingabe.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (zeilenEls.length) aktivSetzen((aktiverIndex + 1 + zeilenEls.length) % zeilenEls.length);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (zeilenEls.length) aktivSetzen((aktiverIndex - 1 + zeilenEls.length) % zeilenEls.length);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (aktiverIndex !== -1 && treffer[aktiverIndex]) eintragWaehlen(treffer[aktiverIndex]);
    } else if (e.key === 'Escape') {
      e.preventDefault();
      paletteSchliessen();
    }
  });

  // KEIN ZEIGBARER WEG MEHR IN DIE PALETTE (08.09.2026). Bis hierhin hing ein
  // Klick-Binder auf #kopfSuche; den Knopf hat der R3-Kopf seit dem 30.08.2026
  // nicht mehr gerendert, der Binder lief also ins Leere. Folge, bewusst in
  // Kauf genommen und hier notiert, damit sie nicht unbemerkt bleibt: auf
  // Touch-Geraeten gibt es kein Strg+K und damit gar keinen Zugang. Wer ihn
  // zurueckholt, braucht beides — einen Knopf im Kopf (layout.js) und wieder
  // einen Binder hier.

  // Strg/Cmd+K oeffnet IMMER (preventDefault) — Browser-Standard (Adressleiste
  // fokussieren u.ae.) tritt dahinter zurueck, das ist bei einer Kommando-
  // palette so gewollt. War sie schon offen, holt der zweite Druck nur den
  // Fokus zurueck ins Eingabefeld (kein Zu-/Umschalten, kein Datenverlust).
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'k' || e.key === 'K') && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      if (offen) eingabe.focus(); else paletteOeffnen();
      return;
    }
    if (e.key === 'Escape' && offen) paletteSchliessen();
  });
})();

/* ------------------------------------------------- 16) Popups (R3-Paket) ---
 * Serverseitig gerendert, versteckt, hier geoeffnet. Ein Ausloeser traegt
 * data-sr-modal-auf="<id>", jedes Schliesselement data-sr-modal-zu.
 *
 * Fokus wird beim Oeffnen ins Popup gesetzt und beim Schliessen an den
 * Ausloeser zurueckgegeben — ohne das landet die Tastatur nach dem Schliessen
 * am Seitenanfang. Tab laeuft im Popup im Kreis (aria-modal allein haelt den
 * Fokus nicht fest, das tut nur eine Falle wie diese).
 */
(function () {
  var offenes = null;
  var rueckkehr = null;

  function fokusierbare(el) {
    return [].slice.call(el.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )).filter(function (e) { return e.offsetParent !== null; });
  }

  function zu() {
    if (!offenes) return;
    offenes.hidden = true;
    offenes = null;
    if (rueckkehr && document.contains(rueckkehr)) rueckkehr.focus();
    rueckkehr = null;
  }

  function auf(id, ausloeser) {
    var el = document.getElementById(id);
    if (!el) return;
    zu();
    el.hidden = false;
    offenes = el;
    rueckkehr = ausloeser || null;
    var ziele = fokusierbare(el);
    if (ziele.length) ziele[0].focus();
  }

  document.addEventListener('click', function (e) {
    var aufKnopf = e.target.closest ? e.target.closest('[data-sr-modal-auf]') : null;
    if (aufKnopf) { e.preventDefault(); auf(aufKnopf.getAttribute('data-sr-modal-auf'), aufKnopf); return; }
    if (!offenes) return;
    if (e.target.closest && e.target.closest('[data-sr-modal-zu]')) { e.preventDefault(); zu(); return; }
    // Klick auf den Grund (nicht auf die Karte) schliesst ebenfalls.
    if (e.target === offenes) zu();
  });

  document.addEventListener('keydown', function (e) {
    if (!offenes) return;
    if (e.key === 'Escape') { e.preventDefault(); zu(); return; }
    if (e.key !== 'Tab') return;
    var ziele = fokusierbare(offenes);
    if (!ziele.length) return;
    var erster = ziele[0], letzter = ziele[ziele.length - 1];
    if (e.shiftKey && document.activeElement === erster) { e.preventDefault(); letzter.focus(); }
    else if (!e.shiftKey && document.activeElement === letzter) { e.preventDefault(); erster.focus(); }
  });
})();

/* ---------------------------------- 16b) Produktkatalog sortieren (17.09.) --
 * Toggles über den eCommerce-Produktkacheln — gleiche Bedienung wie die
 * Seiten-Analyse des Dashboards: Sortierschlüssel als Reiter, ein Knopf für
 * die Richtung. Sortiert wird per DOM-Umordnung; ohne JavaScript bleibt die
 * Server-Reihenfolge (alphabetisch) stehen. */
(function () {
  var gitter = document.querySelector('[data-ec-produkte]');
  var leiste = document.querySelector('[data-ec-sortier]');
  if (!gitter || !leiste) return;
  var ausgewaehlt = leiste.querySelector('[data-ec-sort][aria-pressed="true"]');
  var zustand = { sort: ausgewaehlt ? ausgewaehlt.getAttribute('data-ec-sort') : 'warenkorb', absteigend: true };
  var richtung = leiste.querySelector('[data-ec-richtung]');
  var karte = gitter.closest('.sr-karte') || document;
  var sprachen = karte.querySelector('[data-ec-sprachen]');
  function sprachenAnwenden() {
    if (!sprachen) return;
    var gewaehlt = [].slice.call(sprachen.querySelectorAll('[data-ec-sprache]:checked'));
    var codes = gewaehlt.map(function (feld) { return feld.value; });
    var sichtbar = 0;
    [].slice.call(gitter.children).forEach(function (produkt) {
      produkt.hidden = codes.length > 0 && codes.indexOf(produkt.getAttribute('data-sprache') || '') === -1;
      if (!produkt.hidden) sichtbar++;
    });
    var auswahl = sprachen.querySelector('[data-ec-sprachen-auswahl]');
    if (auswahl) auswahl.textContent = codes.length ? ' · ' + codes.length : '';
    var status = karte.querySelector('[data-ec-filter-status]');
    if (status) {
      var namen = gewaehlt.map(function (feld) { return feld.parentElement.querySelector('span').textContent; });
      var unbekannt = [].slice.call(gitter.children).filter(function (p) { return !p.getAttribute('data-sprache'); }).length;
      status.textContent = codes.length
        ? sichtbar + ' von ' + gitter.children.length + ' Produkten · ' + namen.join(', ')
        : 'Alle ' + gitter.children.length + ' Produkte · alle Sprachen' + (unbekannt ? ' · ' + unbekannt + ' nicht zugeordnet' : '');
    }
  }
  function anwenden() {
    if (richtung) {
      richtung.setAttribute('aria-pressed', zustand.absteigend ? 'false' : 'true');
      richtung.setAttribute('aria-label', zustand.absteigend ? 'Aufsteigend sortieren' : 'Absteigend sortieren');
      richtung.setAttribute('title', zustand.absteigend ? 'Absteigend · aufsteigend sortieren' : 'Aufsteigend · absteigend sortieren');
      var symbol = richtung.querySelector('span');
      if (symbol) symbol.textContent = zustand.absteigend ? '↓' : '↑';
    }
    var karten = [].slice.call(gitter.children);
    karten.sort(function (a, b) {
      var av = a.getAttribute('data-' + zustand.sort) || '';
      var bv = b.getAttribute('data-' + zustand.sort) || '';
      var cmp;
      if (zustand.sort === 'name') cmp = String(av).localeCompare(String(bv), 'de');
      else {
        var an = av === '' || !Number.isFinite(Number(av)) ? null : Number(av);
        var bn = bv === '' || !Number.isFinite(Number(bv)) ? null : Number(bv);
        if (an === null && bn === null) cmp = 0;
        else if (an === null) return 1; // Unbekanntes immer ans Ende
        else if (bn === null) return -1;
        else cmp = an - bn;
      }
      return cmp ? (zustand.absteigend ? -cmp : cmp) : String(a.getAttribute('data-name')).localeCompare(String(b.getAttribute('data-name')), 'de');
    });
    karten.forEach(function (k) {
      gitter.appendChild(k);
      [].slice.call(k.querySelectorAll('[data-ec-kennzahl]')).forEach(function (kennzahl) {
        kennzahl.classList.toggle('ist-aktiv', kennzahl.getAttribute('data-ec-kennzahl') === zustand.sort);
      });
    });
    sprachenAnwenden();
  }
  [].slice.call(leiste.querySelectorAll('[data-ec-sort]')).forEach(function (knopf) {
    knopf.addEventListener('click', function () {
      [].slice.call(leiste.querySelectorAll('[data-ec-sort]')).forEach(function (b) { b.setAttribute('aria-pressed', b === knopf ? 'true' : 'false'); });
      zustand.sort = knopf.getAttribute('data-ec-sort');
      zustand.absteigend = zustand.sort !== 'name';
      anwenden();
    });
  });
  if (richtung) richtung.addEventListener('click', function () {
    zustand.absteigend = !zustand.absteigend;
    anwenden();
  });
  if (sprachen) {
    sprachen.addEventListener('change', function (e) {
      if (e.target.matches('[data-ec-sprache]')) sprachenAnwenden();
    });
    var alleSprachen = sprachen.querySelector('[data-ec-sprachen-alle]');
    if (alleSprachen) alleSprachen.addEventListener('click', function () {
      [].slice.call(sprachen.querySelectorAll('[data-ec-sprache]')).forEach(function (feld) { feld.checked = false; });
      sprachenAnwenden();
    });
    sprachen.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { sprachen.open = false; sprachen.querySelector('summary').focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!sprachen.contains(e.target)) sprachen.open = false;
    });
  }
  anwenden();
})();

/* ------------------------------------------- 17) Kategorien-Reiter (R3) ---
 * Die Reiter ueber „Probleme & Tipps" filtern die Liste darunter. Ohne
 * JavaScript bleiben ALLE Zeilen sichtbar — Verstecken muss der Ausnahmefall
 * sein, nicht die Voreinstellung; ein Reiter, der ohne Skript nichts tut,
 * darf nicht dazu fuehren, dass man nichts mehr sieht.
 */
(function () {
  var leisten = [].slice.call(document.querySelectorAll('[data-sr-filter]'));
  if (!leisten.length) return;
  leisten.forEach(function (leiste) {
    var name = leiste.getAttribute('data-sr-filter');
    var tabs = [].slice.call(leiste.querySelectorAll('.sr-filterreiter-tab'));
    var liste = document.getElementById('sr-' + name);
    if (!tabs.length || !liste) return;
    var zeilen = [].slice.call(liste.querySelectorAll('[data-sr-filter-kat]'));
    /* Suchfeld (31.08.2026) — es gehoert zur SELBEN Filterung wie die Reiter,
       nicht zu einer zweiten. Zwei getrennte Mechaniken, die beide `hidden`
       setzen, ueberschreiben einander: wer erst nach „secret" sucht und dann
       auf „Security" klickt, saehe sonst wieder alle Security-Zeilen. Es gibt
       deshalb EINE Funktion, die beide Bedingungen zusammen auswertet. */
    var feld = document.querySelector('[data-sr-filter-suche="' + name + '"]');
    var leerHinweis = document.getElementById('sr-' + name + '-leer');
    var kategorie = '';
    /* SERVER-BLAETTERUNG (17.09.2026). Liegt die Liste in einer Tabelle mit
       Nachladen (app/views/tabellen-seiten.js), stehen im Browser nur die
       ersten 200 Zeilen. Eine Filterung hier saehe den Rest nie — bei
       Inhalte → Seiten zeigte „Nicht indexierbar" deshalb dieselben 200
       Zeilen wie „Alle". Der Reiter reicht seine Kategorie dann als `source`
       an den Server weiter, der ueber `data-kw-quelle` aller Zeilen filtert. */
    var seitenWrap = liste.querySelector('[data-sr-table-token]');
    /* Eine Zeile kann mehrere Kategorien tragen („indexierbar im-index"). */
    function hatKategorie(z) {
      return (' ' + (z.getAttribute('data-sr-filter-kat') || '') + ' ').indexOf(' ' + kategorie + ' ') !== -1;
    }

    function anwenden() {
      if (seitenWrap) {
        /* Mit UND ohne Tabulator: die Kategorie geht als `source` an die
           Tabelle. tabellen-seiten.js filtert serverseitig über alle Zeilen,
           tabellen-tabulator.js (falls übernommen) über seinen Zeilenbestand
           — genau eine der beiden Mechaniken hört zu. */
        var tabelle = seitenWrap.querySelector('table');
        if (tabelle) {
          tabelle.dispatchEvent(new CustomEvent('sr-table-source', { bubbles: true, detail: { source: kategorie } }));
          return;
        }
      }
      var suche = feld ? feld.value.trim().toLowerCase() : '';
      var treffer = 0;
      zeilen.forEach(function (z) {
        var katPasst = kategorie === '' || hatKategorie(z);
        // data-sr-filter-text traegt den SUCHTEXT (deutscher Titel + englischer
        // Werkzeugname + Regel-Code + Kategorie), weil die Zeile selbst nur
        // noch deutsch beschriftet ist. Ohne das Attribut gilt der sichtbare
        // Text — so bleiben aeltere Listen ohne Suchtext benutzbar.
        var quelle = z.getAttribute('data-sr-filter-text') || z.textContent || '';
        var textPasst = suche === '' || quelle.toLowerCase().indexOf(suche) !== -1;
        /* In einer Tabelle traegt die erste Zelle die Kategorie — versteckt
           wird die ganze Zeile, sonst verschiebt sich nur eine Spalte. */
        var ziel = z.tagName === 'TD' || z.tagName === 'TH' ? z.closest('tr') || z : z;
        ziel.hidden = !(katPasst && textPasst);
        if (!ziel.hidden) treffer++;
      });
      if (leerHinweis) leerHinweis.hidden = treffer !== 0;
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        kategorie = t.getAttribute('data-sr-filter-wert') || '';
        tabs.forEach(function (x) { if (x === t) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current'); });
        anwenden();
      });
    });
    if (feld) {
      feld.addEventListener('input', anwenden);
      // Escape leert das Feld — sonst muesste man es von Hand ausraeumen, um
      // die volle Liste zurueckzubekommen.
      feld.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && feld.value) { e.preventDefault(); feld.value = ''; anwenden(); }
      });
    }
  });
})();

/* ---------------------------- Serien-Mehrfachfilter (generisch) -----------
 * Mehrere UNABHAENGIGE Knoepfe blenden Tabellenzeilen serienweise ein/aus --
 * jede Serie fuer sich an- und abschaltbar, beliebige Kombination. Vorbild
 * ist optisch UND im Verhalten der Eigen/GSC-Schalter der Keyword-Tabelle
 * (app/views/keyword-quellen.js) -- der bleibt dort unveraendert (anderes
 * Feature, eigene zwei fest benannte Knoepfe); dies ist das generische
 * Gegenstueck fuer eine BELIEBIGE Anzahl benannter Serien (z.B. Herkunft
 * einer Frage: eigen/system/analyst/admin).
 *
 * Markup-Vertrag:
 *   <div id="sr-NAME">
 *     <div data-sr-serienfilter="NAME">
 *       <button type="button" data-sr-serie-schalter="WERT" aria-pressed="true">
 *         <span class="sr-serie-punkt" aria-hidden="true"></span>Label
 *         <span class="sr-serie-zahl">3</span>
 *       </button>
 *       ... (ein Knopf je Serie)
 *       <p data-sr-serie-leer hidden>Kein Text passt zur gewaehlten Auswahl.</p>
 *     </div>
 *     … Tabelle mit <tr data-sr-serie="WERT"> je Zeile …
 *   </div>
 *
 * Reiter (data-sr-serienfilter) UND Zeilen (data-sr-serie) muessen im
 * SELBEN `#sr-NAME` stehen -- dasselbe Muster wie der Kategorien-Reiter
 * oben, nur mehrfach statt exklusiv waehlbar (aria-pressed statt
 * aria-current) und ohne eigenes Suchfeld: die Tabelle bringt ihr eigenes
 * bereits mit (ui.tabelle()/A4-Werkzeugzeile) und markiert seine Treffer
 * ueber die KLASSE `.tbl-gefiltert`, nicht ueber `hidden` -- beide
 * Mechaniken vertragen sich deshalb, ohne sich gegenseitig zu ueberschreiben
 * (siehe die Werkzeugzeilen-Filterung weiter oben in dieser Datei).
 *
 * `sr-table-rows` (von tabellen-seiten.js bei jeder Seiten-/Sortieraenderung
 * gefeuert) wendet den bestehenden Knopfzustand auf etwaig neu eingefuegte
 * Zeilen erneut an -- ohne das saehe eine gerade geladene Seite kurz ALLE
 * Serien, bis man den Schalter noch einmal anfasst.
 *
 * MINDESTENS-EINS-REGEL: schaltet der letzte aktive Knopf ab, bleiben alle
 * Zeilen verborgen und der Leerhinweis erscheint -- kein Zwang, den letzten
 * Knopf aktiv zu halten (das waere ueberraschendes Verhalten fuer einen
 * Umschalter), aber auch kein stiller Leerzustand ohne Erklaerung.
 *
 * GROSSE TABELLEN (Gesamttabelle Inhalte → Übersicht, cmvqgl8p6, 27.10.2026):
 *   data-sr-serie-fest      Zahlen stehen fest (Server kennt alle Zeilen, der
 *                           Browser nur die geladenen) -- nicht nachzaehlen.
 *   data-sr-serie-speicher  localStorage-Schluessel fuer abgeschaltete Serien.
 *   [data-sr-serie-sichtbar] mit data-sr-serie-gesamt: „x von N sichtbar".
 * Liegt die Tabelle in der Server-Blaetterung oder bei Tabulator, geht die
 * Auswahl als `sr-table-source` (Kommaliste, `none` = nichts) an die
 * Tabelle -- gefiltert wird dann ueber data-kw-quelle ALLER Zeilen. Eine
 * Serie kann am <tr> oder an einer Zelle haengen; versteckt wird die Zeile.
 */
(function () {
  var leisten = [].slice.call(document.querySelectorAll('[data-sr-serienfilter]'));
  if (!leisten.length) return;
  leisten.forEach(function (leiste) {
    var name = leiste.getAttribute('data-sr-serienfilter');
    var wurzel = document.getElementById('sr-' + name);
    if (!wurzel) return;
    var knoepfe = [].slice.call(leiste.querySelectorAll('[data-sr-serie-schalter]'));
    if (!knoepfe.length) return;
    var leer = leiste.querySelector('[data-sr-serie-leer]');
    var fest = leiste.hasAttribute('data-sr-serie-fest');
    var speicher = leiste.getAttribute('data-sr-serie-speicher') || '';
    var sichtbarEl = leiste.querySelector('[data-sr-serie-sichtbar]');
    var zahl = function (n) { return Number(n).toLocaleString('de-DE'); };

    if (speicher) {
      try {
        var aus = JSON.parse(localStorage.getItem(speicher) || '[]');
        if (Array.isArray(aus)) knoepfe.forEach(function (k) {
          if (aus.indexOf(k.getAttribute('data-sr-serie-schalter')) !== -1) k.setAttribute('aria-pressed', 'false');
        });
      } catch (_) {}
    }

    function aktiveWerte() {
      return knoepfe.filter(function (k) { return k.getAttribute('aria-pressed') === 'true'; })
        .map(function (k) { return k.getAttribute('data-sr-serie-schalter'); });
    }

    /* Tabelle mit Nachladen oder Tabulator: Auswahl an die Tabelle geben. */
    function tabelleMelden(aktiv) {
      var table = wurzel.querySelector('[data-sr-table-token] table, table[data-sr-tabulator]');
      if (!table) return;
      var alle = aktiv.length === knoepfe.length;
      table.dispatchEvent(new CustomEvent('sr-table-source', { bubbles: true,
        detail: { source: alle ? '' : (aktiv.length ? aktiv.join(',') : 'none') } }));
    }

    function anwenden(melden) {
      var aktiv = aktiveWerte();
      var zeilen = [].slice.call(wurzel.querySelectorAll('[data-sr-serie]'));
      var sichtbar = 0;
      var jeSerie = {};
      zeilen.forEach(function (z) {
        var wert = z.getAttribute('data-sr-serie');
        jeSerie[wert] = (jeSerie[wert] || 0) + 1;
        var passt = aktiv.indexOf(wert) !== -1;
        var ziel = z.tagName === 'TD' || z.tagName === 'TH' ? z.closest('tr') || z : z;
        ziel.hidden = !passt;
        if (passt) sichtbar++;
      });
      if (fest) {
        sichtbar = knoepfe.reduce(function (summe, k) {
          var zahlEl = k.querySelector('.sr-serie-zahl');
          return summe + (k.getAttribute('aria-pressed') === 'true' && zahlEl ? Number(zahlEl.getAttribute('data-wert') || 0) : 0);
        }, 0);
      } else {
        knoepfe.forEach(function (k) {
          var zahlEl = k.querySelector('.sr-serie-zahl');
          if (zahlEl) zahlEl.textContent = String(jeSerie[k.getAttribute('data-sr-serie-schalter')] || 0);
        });
      }
      if (sichtbarEl) sichtbarEl.textContent = zahl(sichtbar) + ' von ' + zahl(sichtbarEl.getAttribute('data-sr-serie-gesamt') || 0) + ' sichtbar';
      if (leer) leer.hidden = sichtbar !== 0;
      if (melden) tabelleMelden(aktiv);
    }

    knoepfe.forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        knopf.setAttribute('aria-pressed', knopf.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        if (speicher) {
          try {
            localStorage.setItem(speicher, JSON.stringify(knoepfe.filter(function (k) { return k.getAttribute('aria-pressed') !== 'true'; })
              .map(function (k) { return k.getAttribute('data-sr-serie-schalter'); })));
          } catch (_) {}
        }
        anwenden(true);
      });
    });

    wurzel.addEventListener('sr-table-rows', function () { anwenden(false); });
    /* Tabulator baut sich nach dem Laden auf und kennt die gespeicherte
       Auswahl nicht -- nach dem Aufbau erneut melden. */
    document.addEventListener('sr-tabulator-fertig', function () {
      if (aktiveWerte().length !== knoepfe.length) tabelleMelden(aktiveWerte());
    });
    anwenden(aktiveWerte().length !== knoepfe.length);
  });
})();

/* ------------------------------------- 18) Klebender Seitenkopf (R3) ------
 * .sr-kopf steht per position:sticky oben. Die untere Kante und der Schatten
 * sollen aber NUR erscheinen, wenn er tatsaechlich klebt — im Ruhezustand
 * zoege sich sonst quer ueber die Seite eine Linie, die es im Entwurf nicht
 * gibt.
 *
 * Erkannt mit einem IntersectionObserver auf einem Fuehler-Element DIREKT
 * ueber dem Kopf: verlaesst der Fuehler das Bild, klebt der Kopf. Das ist
 * genauer als eine Abfrage von scrollY gegen eine gemerkte Position — die
 * waere eine Zahl, die falsch wird, sobald sich oben etwas an der Hoehe
 * aendert.
 */
(function () {
  var kopf = document.querySelector('.sr-kopf');
  if (!kopf || !('IntersectionObserver' in window)) return;
  var fuehler = document.createElement('div');
  fuehler.setAttribute('aria-hidden', 'true');
  fuehler.style.height = '1px';
  kopf.parentNode.insertBefore(fuehler, kopf);
  new IntersectionObserver(function (eintraege) {
    kopf.classList.toggle('klebt', !eintraege[0].isIntersecting);
  }, { threshold: 0 }).observe(fuehler);
})();

/* ------------------------- 18b) Kopfhoehe als CSS-Variable (Runde 5) -------
 * --sr-kopf-h traegt die GEMESSENE Hoehe des klebenden Seitenkopfs. sr.css
 * rechnet daraus den Sprung-Versatz fuer jeden Anker (scroll-padding-top am
 * <html>, scroll-margin-top an den Zielen) plus die vom Betreiber verlangten
 * 30 px Luft.
 *
 * WARUM GEMESSEN UND NICHT GERECHNET: die Kopfhoehe haengt an Titel-Umbruch,
 * Unterzeile und daran, ob die Seite ueberhaupt eine Reiterzeile hat. Die
 * feste 96 in sr.css stimmte fuer den haeufigsten Fall und daneben fuer
 * keinen. Beobachtet wird deshalb fortlaufend (ResizeObserver): ein Titel,
 * der beim Verkleinern des Fensters zweizeilig wird, aendert die Zahl.
 *
 * Ohne ResizeObserver (sehr alte Browser) bleibt es bei einer Messung beim
 * Start plus einer je resize — schlechter als fortlaufend, besser als die
 * Konstante.
 */
(function () {
  var kopf = document.querySelector('.sr-kopf');
  if (!kopf) return;
  var zuletzt = -1;
  function schreiben() {
    var h = Math.round(kopf.getBoundingClientRect().height);
    if (h === zuletzt) return;
    zuletzt = h;
    document.documentElement.style.setProperty('--sr-kopf-h', h + 'px');
  }
  schreiben();
  if ('ResizeObserver' in window) new ResizeObserver(schreiben).observe(kopf);
  else window.addEventListener('resize', schreiben);
})();

/* Zeilenfenster fuer lange Tabellen (Baustein 31.08.2026/R3) entfernt
   (Batch 0 des K&R-Rollouts, 07.09.2026: volle Listen app-weit, keine
   Fensterung mehr — Betreiber-Ansage 04.09.2026/06.09.2026). Die
   Drilldown-Klapplogik fuer table.tbl-drill (auf/zu je Zeile) steht separat
   in Baustein 11 oben und ist von dieser Entfernung nicht betroffen. */

/* ------------------------------------------- 19) Bausteine des Overhauls ---
 * Verhalten zu den Bausteinen aus app/views/ui.js (Entwurfsblatt „Bausteine
 * 03.09.“). Alles ueber Ereignis-Delegation am document: die Bausteine stehen
 * in jeder zweiten Ansicht, und ein Zuhoerer je Vorkommen waere bei 17
 * Kennzahl-Gittern und 41 Erklaerungen eine dreistellige Zahl von Zuhoerern
 * fuer dasselbe Verhalten.
 */

/* ---- A2: Erklaerung als Popover (>= 900 px) bzw. Seitenblatt (darunter) ---
 * Das Markup ist in beiden Faellen dasselbe; den Unterschied macht allein das
 * Stylesheet. Hier steht nur: auf, zu, Fokus.
 *
 * FOKUS IST DER GRUND, WARUM DAS NICHT drei Zeilen sind. Ohne Rueckgabe an
 * den Ausloeser landet die Tastatur nach dem Schliessen am Seitenanfang —
 * bei einer Kachel in Kapitel 9 heisst das: von vorn durch die ganze Seite.
 */
(function () {
  var offen = null;          // das Panel
  var ausloeser = null;      // der Knopf, der es geoeffnet hat
  var offenScrim = null;
  var portal = null;
  var schlussTimer = null, schlussFertig = null;

  function scrimVon(panel) {
    var w = panel.closest('[data-sr-erklaerung]');
    return w ? w.querySelector('[data-sr-erklaerung-scrim]') : null;
  }

  /* Die Klasse haelt den Ausloeser sichtbar. Das Panel selbst liegt beim
     Oeffnen im Top-Layer und ist damit unabhaengig von Stapelkontexten und
     overflow/contain eines Widgets. */
  function kachelVon(el) { return el && el.closest ? el.closest('.sr-kpi') : null; }

  function mobil() { return window.matchMedia('(max-width:899.98px)').matches; }

  /* Desktop: rechtsbuendig zum Ausloeser, bei Platzmangel darueber und stets
     innerhalb des sichtbaren Viewports. Mobil macht das Stylesheet daraus
     ein Blatt am unteren Rand. */
  function ausrichten(panel, knopf) {
    panel.style.left = '';
    panel.style.top = '';
    panel.style.right = '';
    panel.style.bottom = '';
    panel.style.maxHeight = '';
    if (mobil()) return;

    var vv = window.visualViewport;
    var vx = vv ? vv.offsetLeft : 0;
    var vy = vv ? vv.offsetTop : 0;
    var vw = vv ? vv.width : window.innerWidth;
    var vh = vv ? vv.height : window.innerHeight;
    var rand = 8, luft = 6;
    var a = knopf.getBoundingClientRect();
    panel.style.maxHeight = Math.max(80, Math.floor(Math.min(vh * .6, vh - rand * 2))) + 'px';
    var r = panel.getBoundingClientRect();
    var unten = vy + vh - rand - a.bottom - luft;
    var oben = a.top - vy - rand - luft;
    var nachUnten = unten >= Math.min(r.height, 240) || unten >= oben;
    var platz = Math.max(80, nachUnten ? unten : oben);
    panel.style.maxHeight = Math.floor(Math.min(vh * .6, platz)) + 'px';
    r = panel.getBoundingClientRect();

    var links = Math.max(vx + rand, Math.min(a.right - r.width, vx + vw - rand - r.width));
    var top = nachUnten ? a.bottom + luft : a.top - luft - r.height;
    top = Math.max(vy + rand, Math.min(top, vy + vh - rand - r.height));
    panel.style.left = Math.round(links) + 'px';
    panel.style.top = Math.round(top) + 'px';
  }

  /* Alte Browser ohne Popover API bekommen denselben Ausweg aus begrenzenden
     Vorfahren ueber ein zeitweises Portal an body. */
  function portalAuf(panel, scrim) {
    var panelMarke = document.createComment('sr-erklaerung-panel');
    var scrimMarke = scrim ? document.createComment('sr-erklaerung-scrim') : null;
    panel.parentNode.insertBefore(panelMarke, panel);
    if (scrim) scrim.parentNode.insertBefore(scrimMarke, scrim);
    panel.setAttribute('data-sr-erklaerung-portal', '');
    if (scrim) { scrim.setAttribute('data-sr-erklaerung-portal', ''); document.body.appendChild(scrim); }
    document.body.appendChild(panel);
    portal = { panel: panel, panelMarke: panelMarke, scrim: scrim, scrimMarke: scrimMarke };
  }

  function portalZu(panel) {
    if (!portal || portal.panel !== panel) return;
    portal.panel.removeAttribute('data-sr-erklaerung-portal');
    if (portal.scrim) portal.scrim.removeAttribute('data-sr-erklaerung-portal');
    if (portal.scrim && portal.scrimMarke.parentNode) portal.scrimMarke.parentNode.replaceChild(portal.scrim, portal.scrimMarke);
    if (portal.panelMarke.parentNode) portal.panelMarke.parentNode.replaceChild(portal.panel, portal.panelMarke);
    portal = null;
  }

  /* MOUSEOVER STATT KLICK (Betreiber-Vorgabe 06.09.2026: „lange Saetze in
     ein Info-Icon per Mouseover, minimale Verzoegerung, animiertes Ein-/
     Ausblenden — generell Mouseover statt Klick"). Zwei Betriebsarten
     desselben Panels:
       * SCHWEBEND: Zeiger ruht 120 ms auf dem Knopf -> Panel blendet ein
         (CSS-Uebergang ueber .sr-erklaerung-panel--sichtbar), kein Fokus-
         wechsel; verlaesst der Zeiger Knopf UND Panel fuer 240 ms, blendet
         es wieder aus. Nur mit echtem Zeiger (hover: hover) und nur im
         Popover-Bild (>= 900 px, position:absolute) — auf Touch gibt es
         kein Schweben, und das Seitenblatt darunter soll nicht auf- und
         zuklappen, waehrend man scrollt.
       * ANGEHEFTET: Klick, Tastatur (Enter/Leertaste) und Touch oeffnen wie
         bisher mit Fokus aufs Panel, Escape/Aussenklick/X schliessen. Ein
         Klick auf ein schwebendes Panel heftet es an.
     Damit bleibt jeder Inhalt ohne Maus erreichbar (WCAG 1.4.13: per
     Zeiger eingeblendeter Inhalt ist schliessbar, ueberfahrbar und bleibt
     stehen, solange der Zeiger darauf ist). */
  var schwebend = false;
  var aufTimer = null, zuTimer = null;
  var DAUER = 180; // ms, gleich der CSS-Transition
  var hoverMoeglich = (function () {
    try { return window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) { return false; }
  })();
  function reduziert() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }

  function zu(sofort) {
    if (!offen) {
      if (sofort && schlussFertig) schlussFertig();
      return;
    }
    var panel = offen, knopf = ausloeser;
    var scrim = offenScrim;
    if (scrim) scrim.hidden = true;
    var kachel = kachelVon(knopf);
    if (kachel) kachel.classList.remove('sr-erkl-aktiv');
    if (knopf && document.contains(knopf)) {
      knopf.setAttribute('aria-expanded', 'false');
      if (!schwebend) knopf.focus();
    }
    var warSchwebend = schwebend;
    offen = null; ausloeser = null; offenScrim = null; schwebend = false;
    panel.classList.remove('sr-erklaerung-panel--sichtbar');
    var fertig = function () {
      if (schlussTimer !== null) window.clearTimeout(schlussTimer);
      schlussTimer = null; schlussFertig = null;
      try { if (panel.matches(':popover-open')) panel.hidePopover(); } catch (_) {}
      panel.style.left = ''; panel.style.top = ''; panel.style.right = '';
      panel.style.bottom = ''; panel.style.maxHeight = '';
      panel.hidden = true;
      portalZu(panel);
    };
    if (sofort || reduziert() || !warSchwebend) fertig();
    else { schlussFertig = fertig; schlussTimer = window.setTimeout(fertig, DAUER); }
  }

  function auf(knopf, alsSchwebend) {
    var panel = document.getElementById(knopf.getAttribute('data-sr-erklaerung-auf'));
    if (!panel) return;
    if (offen === panel) {
      // Schon offen (schwebend) — ein Klick heftet an.
      if (!alsSchwebend && schwebend) {
        schwebend = false;
        if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
        panel.focus();
      }
      return;
    }
    zu(true);
    var scrim = scrimVon(panel);
    var nativ = typeof panel.showPopover === 'function';
    if (nativ) panel.setAttribute('popover', 'manual');
    else portalAuf(panel, scrim);
    panel.hidden = false;
    if (nativ) {
      try { panel.showPopover(); } catch (_) {
        nativ = false;
        panel.removeAttribute('popover');
        portalAuf(panel, scrim);
      }
    }
    // Im Top-Layer zeichnet ::backdrop das mobile Scrim. Der DOM-Scrim ist
    // nur der Ersatzpfad fuer Browser ohne Popover API.
    if (scrim) scrim.hidden = nativ || !mobil();
    knopf.setAttribute('aria-expanded', 'true');
    var kachel = kachelVon(knopf);
    if (kachel) kachel.classList.add('sr-erkl-aktiv');
    ausrichten(panel, knopf);
    offen = panel;
    ausloeser = knopf;
    offenScrim = scrim;
    schwebend = !!alsSchwebend;
    // Naechster Frame: erst sichtbar machen, dann die Klasse fuer den
    // Uebergang — sonst springt das Panel ohne Einblenden auf.
    window.requestAnimationFrame(function () {
      if (offen === panel) panel.classList.add('sr-erklaerung-panel--sichtbar');
    });
    if (!schwebend) {
      // Fokus AUFS PANEL, nicht auf sein erstes Bedienelement: der Inhalt ist
      // Text, nicht Formular — der Leser soll ihn lesen, nicht das X anspringen.
      if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
      panel.focus();
    }
  }

  function popoverBild(knopf) {
    return !!document.getElementById(knopf.getAttribute('data-sr-erklaerung-auf')) && !mobil();
  }

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest ? e.target.closest('[data-sr-erklaerung-auf]') : null;
    if (knopf) {
      e.preventDefault();
      if (aufTimer) { window.clearTimeout(aufTimer); aufTimer = null; }
      if (offen && offen.id === knopf.getAttribute('data-sr-erklaerung-auf') && !schwebend) zu(); else auf(knopf, false);
      return;
    }
    if (!offen) return;
    if (e.target.closest && e.target.closest('[data-sr-erklaerung-zu]')) { e.preventDefault(); zu(); return; }
    if (e.target.closest && e.target.closest('[data-sr-erklaerung-scrim]')) { zu(); return; }
    /* Ein Klick auf ::backdrop hat das Panel selbst als Ziel, seine
       Koordinaten liegen aber ausserhalb des Panel-Rechtecks. */
    if (e.target === offen) {
      var r = offen.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { zu(); return; }
    }
    if (offen.contains(e.target)) { if (schwebend) { schwebend = false; } return; } // Klick ins schwebende Panel heftet an
    if (!offen.contains(e.target)) zu();
  });

  if (hoverMoeglich) {
    document.addEventListener('mouseover', function (e) {
      var knopf = e.target.closest ? e.target.closest('[data-sr-erklaerung-auf]') : null;
      var imPanel = offen && offen.contains(e.target);
      if (imPanel || (knopf && offen && ausloeser === knopf)) {
        if (zuTimer) { window.clearTimeout(zuTimer); zuTimer = null; }
        return;
      }
      if (!knopf) return;
      /* PANELS MIT EINGABEFELDERN NUR AUF KLICK (11.09.2026): ein Panel, das
         der Zeiger oeffnet, schliesst sich 240 ms nach dem Wegziehen wieder —
         bei einem Formular waere die halb getippte Eingabe damit weg. Der
         Auslöser sagt das selbst an (data-sr-erklaerung-klick), statt dass
         diese Stelle den Inhalt erraten muesste. */
      if (knopf.hasAttribute('data-sr-erklaerung-klick')) return;
      if (!popoverBild(knopf)) return;
      if (aufTimer) window.clearTimeout(aufTimer);
      aufTimer = window.setTimeout(function () {
        aufTimer = null;
        if (offen && !schwebend) return; // ein angeheftetes Panel bleibt
        auf(knopf, true);
      }, 120);
    });
    document.addEventListener('mouseout', function (e) {
      var knopf = e.target.closest ? e.target.closest('[data-sr-erklaerung-auf]') : null;
      if (knopf && aufTimer) { window.clearTimeout(aufTimer); aufTimer = null; }
      if (!offen || !schwebend) return;
      var ziel = e.relatedTarget;
      if (ziel && (offen.contains(ziel) || (ausloeser && ausloeser.contains(ziel)))) return;
      if (zuTimer) window.clearTimeout(zuTimer);
      zuTimer = window.setTimeout(function () { zuTimer = null; if (offen && schwebend) zu(); }, 240);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (offen && e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); zu(true); }
  }, true);

  document.addEventListener('toggle', function (e) {
    if (e.target === offen && e.newState === 'closed') zu(true);
  }, true);

  var lageFrame = 0;
  document.addEventListener('scroll', function (e) {
    if (!offen || offen.contains(e.target) || lageFrame) return;
    lageFrame = window.requestAnimationFrame(function () {
      lageFrame = 0;
      if (!offen || !ausloeser) return;
      if (!ausloeser.getClientRects().length) zu(true);
      else ausrichten(offen, ausloeser);
    });
  }, true);

  window.addEventListener('resize', function () {
    if (offen && ausloeser) ausrichten(offen, ausloeser);
  });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', function () {
    if (offen && ausloeser) ausrichten(offen, ausloeser);
  });
})();

/* ---- A6: Zeitraum-Segmente mit den Pfeiltasten ---------------------------
 * Die Gruppe traegt `role="radiogroup"`, die Segmente `role="radio"` — dann
 * erwartet die Tastatur Pfeiltasten statt Tabulator, und genau EIN Segment
 * liegt im Tabulator-Fluss (Roving Tabindex, serverseitig gesetzt).
 * Gesperrte Segmente (Tarif) werden uebersprungen statt angesteuert: ein
 * Fokus, der nichts tut, ist eine Sackgasse.
 */
(function () {
  var gruppen = [].slice.call(document.querySelectorAll('[data-sr-zeitraum]'));
  if (!gruppen.length) return;
  gruppen.forEach(function (gruppe) {
    gruppe.addEventListener('keydown', function (e) {
      var richtung = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1
        : ((e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0);
      if (!richtung) return;
      var offene = [].slice.call(gruppe.querySelectorAll('a.sr-zeitraum-seg'));
      if (offene.length < 2) return;
      var jetzt = offene.indexOf(document.activeElement);
      if (jetzt === -1) jetzt = offene.findIndex(function (a) { return a.getAttribute('aria-checked') === 'true'; });
      if (jetzt === -1) jetzt = 0;
      e.preventDefault();
      var ziel = offene[(jetzt + richtung + offene.length) % offene.length];
      offene.forEach(function (a) { a.setAttribute('tabindex', a === ziel ? '0' : '-1'); });
      ziel.focus();
      // Radios wechseln beim Pfeil den Zustand — hier heisst das: die Ansicht
      // laedt mit dem neuen Zeitraum. Ohne das waere der Fokus gewandert und
      // nichts passiert, und man muesste zusaetzlich Enter druecken.
      window.location.href = ziel.href;
    });
  });
})();

/* ---- A4: der Filter der Werkzeugzeile ----------------------------------
 * Die gekappten Zeilen stehen im DOM und tragen `hidden`. Der Knopf nimmt es
 * den naechsten `schritt` Zeilen ab und schreibt seine Beschriftung fort —
 * sie nennt IMMER beide Zahlen, sonst weiss niemand, wovon er die ersten
 * sieht.
 */
(function () {
  /* „Weitere n anzeigen“ (data-sr-mehr) ist mit Batch 0 des K&R-Rollouts
     (07.09.2026, volle Listen app-weit) entfallen — kein Markup traegt das
     Attribut mehr, der Klick-Handler dazu ist raus. */

  /* Filter der gebauten Werkzeugzeile. Er setzt dieselbe Klasse wie der
     Client-Filter (.tbl-gefiltert) — sonst haetten zwei Mechaniken zwei
     Begriffe fuer „diese Zeile ist gerade nicht gemeint“, und der Export
     wuerde die falschen Zeilen mitnehmen. */
  function tabelleZu(zeile) {
    var ziel = zeile.getAttribute('data-sr-werkzeuge-ziel');
    if (ziel) {
      var byId = document.getElementById(ziel);
      if (byId) return byId.querySelector('table') || byId;
    }
    var el = zeile.nextElementSibling;
    while (el) {
      var t = el.matches && el.matches('table') ? el : (el.querySelector ? el.querySelector('table') : null);
      if (t) return t;
      el = el.nextElementSibling;
    }
    return null;
  }

  [].slice.call(document.querySelectorAll('.sr-werkzeugzeile')).forEach(function (zeile) {
    var feld = zeile.querySelector('[data-sr-tabfilter]');
    if (!feld) return;
    var tabelle = tabelleZu(zeile);
    var tbody = tabelle && tabelle.tBodies && tabelle.tBodies[0];
    if (!tbody) return;
    var zaehler = zeile.querySelector('[data-sr-zaehler]');
    var grundtext = zaehler ? (zaehler.getAttribute('data-sr-zaehler-text') || zaehler.textContent) : '';

    function anwenden() {
      var q = feld.value.trim().toLowerCase();
      var treffer = 0;
      [].forEach.call(tbody.rows, function (tr) {
        var passt = !q || (tr.textContent || '').toLowerCase().indexOf(q) !== -1;
        tr.classList.toggle('tbl-gefiltert', !passt);
        if (passt) treffer++;
      });
      if (zaehler) zaehler.textContent = q ? (treffer + ' von ' + grundtext) : grundtext;
    }
    feld.addEventListener('input', anwenden);
    feld.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && feld.value) { e.preventDefault(); feld.value = ''; feld.dispatchEvent(new Event('input', { bubbles: true })); }
    });
    // A7-Variante „Filter ohne Treffer“: der Knopf im Leerzustand raeumt das
    // Feld — er steht dort, wo der Nutzer gerade hinschaut, nicht oben.
    var huelle = zeile.closest('.sr-karte, .section') || document.body;
    huelle.addEventListener('click', function (e) {
      var k = e.target.closest ? e.target.closest('[data-sr-aktion="filter-zuruecksetzen"]') : null;
      if (!k || !feld.value) return;
      e.preventDefault();
      feld.value = '';
      feld.dispatchEvent(new Event('input', { bubbles: true }));
      feld.focus();
    });
  });
})();

/* ---- A8: aktiven Reiter beim Laden sichtbar machen -----------------------
 * Die Leiste scrollt waagerecht statt zweizeilig zu werden — dann kann der
 * aktive Reiter beim Aufruf ausserhalb des Sichtfelds liegen. `inline:
 * 'nearest'` holt ihn mit dem kuerzest moeglichen Weg herein; BEWUSST OHNE
 * `behavior:'smooth'`, sonst laeuft die Leiste beim Oeffnen jeder Seite
 * sichtbar los — eine Animation, die niemand ausgeloest hat.
 */
(function () {
  var leiste = document.getElementById('unterkapitelLeiste');
  if (!leiste) return;
  var band = leiste.querySelector('.unterkapitel-band:not([hidden])');
  var aktiv = band && band.querySelector('.unterkapitel-tab[aria-current]');
  if (!aktiv) return;
  /* NUR WAAGERECHT (06.09.2026): scrollIntoView mit block:'nearest' schob
     auch das FENSTER, bis die Leiste im Bild war — nach jeder Tabellenaktion
     landete die Seite bei der Reiterleiste statt an der Stelle, an der man
     geklickt hatte (Baustein 5c stellt den Bildlauf wieder her, und dieser
     Sprung kam ihm dazwischen). Die Leiste rollt jetzt selbst. */
  /* Der Rollbereich ist der naechste Vorfahre, der tatsaechlich ueberlaeuft:
     in den Recherche-Bereichen die Primaerzeile (recherche-navigation.css),
     sonst Band oder Leiste. Ihr rechter Innenabstand haelt dem Zahnrad
     „Pflege“ den Platz frei und zaehlt nicht zur sichtbaren Flaeche; ohne
     beides stand bei 390 px „Keyword Tra…“ unter dem Zahnrad (Intensivtest
     gigahertz P3 #18). */
  var rolle = null;
  for (var e = aktiv.parentElement; e && e !== leiste.parentElement; e = e.parentElement) {
    if (e.scrollWidth > e.clientWidth + 1) { rolle = e; break; }
  }
  if (!rolle) return;
  var ra = aktiv.getBoundingClientRect(), rr = rolle.getBoundingClientRect();
  var sichtRechts = rr.left + rolle.clientLeft + rolle.clientWidth - (parseFloat(getComputedStyle(rolle).paddingRight) || 0);
  if (ra.left < rr.left + rolle.clientLeft) rolle.scrollLeft += ra.left - rr.left - rolle.clientLeft;
  else if (ra.right > sichtRechts) rolle.scrollLeft += ra.right - sichtRechts;
})();

/* ------------------------------------------- 14) Kommunikator (BETA) --------
 * KI-Assistent der Projektseite (Betreiber-Anweisung 06.09.2026): eine Figur
 * unten rechts, die in einer Sprechblase Tipps aus den Zahlen des Projekts
 * gibt und auf Klick ein Gespraechsfenster oeffnet. Markup:
 * app/views/assistent.js figurHtml(); Antworten kommen von
 * POST <data-km-aktion> (app/api/assistent.js) als JSON {html}.
 *
 * GESTEN kamen bis zum Materialsatz v12 (11.09.2026) aus Bildwechseln
 * (sechs Blickwinkel je Figur). Seither bewegt sich die Figur im Video, seit
 * v13 in vier Zustaenden; der Bildwechsel und die Datenablage dahinter sind
 * mit dem Aufraeumen vom 12.09.2026 entfallen. Seit dem 21.10.2026 ist die
 * Figur der Kauz mit Zustaenden (Sprites); den Zustand setzt dieser Baustein
 * selbst (kauz(), weiter unten). Den ANLASS meldet er zusaetzlich weiter,
 * kommunikator-optionen.js horcht darauf:
 *
 *   km:zeigen  Tipp-Blase geht auf oder eine Antwort ist da (zeigenMelden)
 *   km:winken  Gespraechsfenster geht auf — hoechstens einmal je Sitzung
 *              (winkenMelden, Merker im sessionStorage des Tabs)
 *   km:denkt   Antwort laeuft (detail.an true) bzw. ist da (false)
 *
 * Zwei CSS-Klassen bleiben daneben: km-figur--nickt (kurzes Nicken, wenn ein
 * Tipp erscheint) und km--denkt (Puls, waehrend eine Antwort laeuft — er
 * bleibt zusaetzlich zur Denk-Schleife, weil er auch dann steht, wenn kein
 * Video laeuft). Bei prefers-reduced-motion entfallen Nicken, Video und
 * Meldung; es steht das Standbild.
 *
 * WAS DER CLIENT NICHT TUT: keine Themenpruefung (die sitzt serverseitig im
 * Systemprompt), kein Speichern von Antworten ausser im sessionStorage
 * dieses Tabs (Verlauf je Projekt, hoechstens acht Wechsel), keine Zahlen
 * — jede Zahl in der Blase kommt fertig vom Server (Regel-Befunde).
 */
(function () {
  var wurzel = document.querySelector('[data-km]');
  if (!wurzel) {
    document.addEventListener('click', function (e) {
      var button = e.target.closest && e.target.closest('[data-km-frage]');
      var projektPfad = location.pathname.match(/^(\/projekt\/[^/]+)/);
      if (!button || !projektPfad) return;
      e.preventDefault();
      location.assign(projektPfad[1] + '/technik/wasserfall#kommunikator=' + encodeURIComponent((button.getAttribute('data-km-frage') || '').slice(0, 4000)));
    });
    return;
  }
  var lesen = function (sel) { try { return JSON.parse((wurzel.querySelector(sel) || {}).textContent || 'null'); } catch (e) { return null; } };
  var tipps = lesen('[data-km-tipps]') || [];
  var figur = wurzel.querySelector('[data-km-figur]');
  var blase = wurzel.querySelector('[data-km-blase]');
  var blaseText = wurzel.querySelector('[data-km-blase-text]');
  var blaseLink = wurzel.querySelector('[data-km-blase-link]');
  var panel = wurzel.querySelector('[data-km-panel]');
  var verlaufEl = wurzel.querySelector('[data-km-verlauf]');
  var form = wurzel.querySelector('[data-km-form]');
  var aktion = wurzel.getAttribute('data-km-aktion') || '';
  var basis = wurzel.getAttribute('data-km-basis') || '';
  var verfuegbar = wurzel.getAttribute('data-km-verfuegbar') === '1';
  var projekt = wurzel.getAttribute('data-km-projekt') || '';
  var kapitel = wurzel.getAttribute('data-km-kapitel') || 'keywords';
  var reduziert = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobilAbfrage = window.matchMedia ? window.matchMedia('(max-width: 559px)') : null;
  var SCHL = 'sr-km:' + projekt + ':' + kapitel;
  /* Das Gespraech gilt dem Projekt (28.10.2026, cmvskhbm9): Verlauf, Token
     und die schwebende Frage liegen unter GSCHL, nicht je Bereich. Tipps-
     Merker und Modellwahl bleiben unter SCHL. */
  var GSCHL = 'sr-km:' + projekt + ':gespraech';
  // Der Gruss gilt dem Projekt, nicht dem Bereich: wer zwischen Reitern
  // wechselt, bekommt ihn nicht noch einmal.
  var WINK_SCHL = 'sr-km:' + projekt + ':gewinkt';
  /* Tipps hoechstens alle 3 Minuten (Betreiber-Anweisung 26.10.2026, vorher
     45 s): die Blase soll die Ruhe der Figur nicht brechen. */
  var TIPP_START_MS = 4000, TIPP_TAKT_MS = 180000, TIPP_DAUER_MS = 16000;
  var tippIdx = -1, tippTimer = 0, ausTimer = 0;

  function istMobil() { return !!(mobilAbfrage && mobilAbfrage.matches); }

  /* Gemeldet wird nur der Anlass (siehe Kopf dieses Bausteins). */
  function zeigenMelden() {
    if (reduziert) return;
    document.dispatchEvent(new CustomEvent('km:zeigen'));
  }
  /* WINKEN GENAU EINMAL JE SITZUNG (Auftrag 11.09.2026). Der Gruss gehoert
     zum ersten Oeffnen des Gespraechsfensters; ab dem zweiten Mal ist er
     Zierrat und zieht die Aufmerksamkeit vom Gespraech weg. Der Merker liegt
     im sessionStorage dieses Tabs — er endet mit dem Tab, nicht mit der
     Seite. Bei reduzierter Bewegung wird gar nicht erst gemeldet. */
  function winkenMelden(ohneGeste) {
    if (reduziert || gemerkt(WINK_SCHL) === '1') return;
    gemerkt(WINK_SCHL, '1');
    document.dispatchEvent(new CustomEvent('km:winken'));
    if (!ohneGeste) oeffnenGeste();
  }
  /* Anlass „oeffnen" (26.10.2026): dieselbe Einmaligkeit und derselbe Schalter
     „Beim Oeffnen winken" wie der Gruss; „begruesst", sonst eine andere Geste mit
     diesem Anlass. Gesten, die leer beginnen (fliegt-ein), kommen hier nicht
     vor: sie holen die Figur nur aus „weg" zurueck (oeffnen()). Was der Satz nicht
     traegt, faellt aus. */
  function oeffnenGeste() {
    if (wurzel.getAttribute('data-km-winken-oeffnen') !== '1' || laeuft || kauzWeg) return;
    var kandidaten = kauzGesten('oeffnen');
    if (!kandidaten.length) return;
    var z = kandidaten.indexOf('begruesst') !== -1 ? 'begruesst' : kandidaten[Math.floor(Math.random() * kandidaten.length)];
    kauz(z);
  }
  /* Denken laeuft als Schleife, solange die Antwort unterwegs ist. */
  function denkenMelden(an) {
    if (reduziert) return;
    document.dispatchEvent(new CustomEvent('km:denkt', { detail: { an: !!an } }));
  }
  function nicken() {
    if (reduziert || !figur) return;
    figur.classList.remove('km-figur--nickt');
    void figur.offsetWidth; // Animation neu starten
    figur.classList.add('km-figur--nickt');
  }
  /* ZUSTAENDE DES KAUZES (21.10.2026, Stufe B). Grundzustand Leerlauf;
     „denkt", solange eine Antwort laeuft; „zeigt" zur Sprechblase hin,
     solange ein Tipp steht; „freut" nach einer Antwort; „stutzt" bei einem
     Fehler oder einer Antwort, die der Server als nicht gegengeprueft meldet
     (`geprueft:false`). Einmal-Zustaende halten ihr Endbild und kehren nach
     KAUZ_HALTE_MS in den Leerlauf zurueck. Die Gesten-Schalter des Kontos
     gelten auch hier: ohne „denkt" bzw. „zeigen" bleibt der Kauz in diesen
     Faellen im Leerlauf. Bei reduzierter Bewegung wechselt nur das
     Standbild (kommunikator-polish.css). Gesetzt wird an jedem
     [data-km-kauz] neu gesucht — das Optionsfenster baut die Figur um.

     GESTEN AUS DEM MANIFEST (26.10.2026). Welche Zustaende es gibt und wann
     eine Geste spielt, steht nicht mehr in diesem Baustein, sondern im Manifest
     des Bildsatzes (am Kasten als data-km-kauz-medien; geschrieben von
     scripts/marke/baue-kauz-radar.py aus pruefung.json): je Zustand das Feld
     `ausloeser`. Ohne Manifest gilt die feste Vorgabe von frueher
     (KAUZ_STANDARD, „ordnet" im Leerlauf und nach einer Antwort). Eine Geste
     spielt nur, wenn (a) die Bewegung nicht reduziert ist, (b) der Bildsatz sie
     traegt (--kauz-gesten im Stylesheet, kauzTraegt) und (c) falls sie einen
     Schalter hat, er im Konto an ist (data-km-gesten). Einen Schalter haben nur
     Gesten mit den Anlaessen leerlauf-variation oder lange-ruhe; die
     ereignisgebundenen Gesten und die Grundzustaende laufen ohne. Fehlt eine Geste, passiert nichts: der Kauz bleibt im Leerlauf
     bzw. nimmt die bisherige Antwort (freut, stutzt, denkt, zeigt).

     RUHE VOR BEWEGUNG (Betreiber-Anweisung 26.10.2026: „Einen Zappelphilipp
     braucht niemand"). Die Gesten aus eigenem Antrieb — leerlauf-variation,
     lange-ruhe, nach-antwort, erfolg — spielen nur, wenn seit dem Ende der
     letzten Geste mindestens GESTE_PAUSE_MS (90 s) vergangen sind
     (kauzRuhig). Die Leerlaufschleife selbst laeuft weiter; sie ist keine
     Geste. Ereignisgebundene Gesten (zustimmung, fehler, oeffnen, schliessen,
     hinweis-aussen) antworten auf eine Handlung und bleiben ungebremst.
     Eine Schleifen-Geste (blinzelt) spielt aus eigenem Antrieb genau einen
     Durchlauf (Dauer d aus dem Manifest) und geht dann in den Leerlauf.

     AUSLOESER (Anlass → Ereignis in diesem Baustein):
       leerlauf-variation  Zeitgeber 120–300 s im Leerlauf (variationPlanen)
       nach-antwort        nach „freut" einer gelungenen Antwort, nur in einem
                           von drei Faellen (NACH_ANTWORT_ANTEIL, Absenden)
       erfolg              wie nach-antwort, im gezogenen Drittel mit 50 %
                           statt nach-antwort (Absenden)
       fehler              Antwort mit Fehler (HTTP-Fehler, Netz) statt „stutzt"
       antwort-laeuft      beim Absenden statt „denkt" (Schleife)
       zustimmung          beim Absenden einer Frage, vor „denkt"
       oeffnen             oeffnen(), einmal je Sitzung (winkenMelden); war die
                           Figur „weg", stattdessen das Gegenstueck (fliegt-ein)
       schliessen          schliessen(), wenn die Figur sichtbar bleibt und das
                           Gegenstueck der Geste (paar) im Satz liegt; endet die
                           Geste leer (fliegt-ab), bleibt die Figur „weg" bis zum
                           naechsten Oeffnen, ohne Variation und lange Ruhe
       lange-ruhe          5 min ohne Eingabe, danach fruehestens nach weiteren 5 min
       hinweis-aussen      tippZeigen(), wenn das Sprungziel ausserhalb des
                           sichtbaren Reiters liegt
       ablehnung           NUR ueber das Ereignis km:kauz-ausloeser — der Client
                           hat weder „nicht hilfreich" an einer Antwort noch
                           einen Abbruch einer Aktion (Stand 26.10.2026)
     Jeder Anlass laesst sich auch von aussen melden:
     document.dispatchEvent(new CustomEvent('km:kauz-ausloeser',
     { detail: { ausloeser: 'ablehnung' } })). Gleichverteilt waehlt kauzWahl
     unter den Gesten, die den Anlass tragen und erlaubt sind.

     ORDNET (26.10.2026). Geste „Gefieder ordnen": spielt einmal (2,5 s gross
     und schwebend, 2,0 s klein) und endet in der Ruhepose. Sie ist die erste
     Geste mit den Anlaessen leerlauf-variation und nach-antwort. */
  var KAUZ_STANDARD = ['leerlauf', 'denkt', 'zeigt-rechts', 'zeigt-links', 'freut', 'stutzt', 'ordnet'];
  var KAUZ_STANDARD_AUSLOESER = { ordnet: ['leerlauf-variation', 'nach-antwort'] };
  /* Zustaende mit eigenem Verhalten in diesem Baustein: kein eigener Schalter. */
  var KAUZ_GRUND = ['leerlauf', 'denkt', 'zeigt-rechts', 'zeigt-links', 'freut', 'stutzt'];
  var kauzSatz = null;
  try { kauzSatz = JSON.parse(wurzel.getAttribute('data-km-kauz-medien') || 'null'); } catch (e) { kauzSatz = null; }
  if (!kauzSatz || typeof kauzSatz !== 'object' || !kauzSatz.b) kauzSatz = null;
  /* Zustaende des Satzes: Vereinigung der Tabellen aller Richtungen und Groessen. */
  function kauzZustaendeAus(satz) {
    var liste = [];
    ['links', 'rechts'].forEach(function (r) {
      var groessen = satz[r] || {};
      Object.keys(groessen).forEach(function (g) {
        Object.keys(groessen[g] || {}).forEach(function (z) { if (liste.indexOf(z) === -1) liste.push(z); });
      });
    });
    return liste;
  }
  var KAUZ_ZUSTAENDE = KAUZ_STANDARD.slice();
  var KAUZ_AUSLOESER = KAUZ_STANDARD_AUSLOESER;
  /* PAARE (26.10.2026). Eine Geste mit endet_leer (fliegt-ab) laesst die Figur auf
     dem leeren Endbild stehen — Zustand „weg", kein Leerlauf. Zurueck holt sie nur
     das Gegenstueck aus `paar` (fliegt-ein, beginnt_leer) beim naechsten Oeffnen,
     danach folgt der Leerlauf. Gesten mit beginnt_leer spielen nie von sich aus.
     KAUZ_KLEIN nennt die Zustaende, die auch als Kleinform (Streifen) im Satz liegen. */
  var KAUZ_ENDET_LEER = [], KAUZ_BEGINNT_LEER = [], KAUZ_PAAR = {}, KAUZ_KLEIN = null;
  var kauzWeg = false;
  if (kauzSatz) {
    var ausSatz = kauzZustaendeAus(kauzSatz);
    if (ausSatz.length) {
      if (ausSatz.indexOf('leerlauf') === -1) ausSatz.unshift('leerlauf');
      KAUZ_ZUSTAENDE = ausSatz;
    }
    if (kauzSatz.a && typeof kauzSatz.a === 'object') KAUZ_AUSLOESER = kauzSatz.a;
    if (Array.isArray(kauzSatz.endetLeer)) KAUZ_ENDET_LEER = kauzSatz.endetLeer;
    if (Array.isArray(kauzSatz.beginntLeer)) KAUZ_BEGINNT_LEER = kauzSatz.beginntLeer;
    if (kauzSatz.paar && typeof kauzSatz.paar === 'object') KAUZ_PAAR = kauzSatz.paar;
    if (Array.isArray(kauzSatz.k)) KAUZ_KLEIN = kauzSatz.k;
  }
  var KAUZ_HALTE_MS = { freut: 3200, stutzt: 4200, ordnet: 2700 };
  /* Sicherung fuer Einmal-Gesten ohne Haltezeit: das Medium meldet km:kauz-ende;
     kommt es nicht (Kleinform als Streifen, Standbild, Laden gescheitert),
     beendet dieser Zeitgeber die Geste nach Dauer + Puffer. */
  var KAUZ_PUFFER_MS = 2000, KAUZ_VORSCHAU_SCHLEIFE_MS = 3000, KAUZ_DAUER_VORGABE_MS = 3000;
  var VARIATION_MIN_MS = 120000, VARIATION_MAX_MS = 300000;
  var RUHE_ERST_MS = 300000, RUHE_NEU_MS = 300000, RUHE_WIEDER_MS = 30000;
  var GESTE_PAUSE_MS = 90000, NACH_ANTWORT_ANTEIL = 1 / 3;
  var kauzStand = 'leerlauf', kauzTimer = 0, variationTimer = 0, kauzDanach = [];
  /* Zeitpunkt, an dem zuletzt eine Geste begann oder endete; beim Laden der
     Seite zaehlt das Laden selbst, damit nicht gleich etwas spielt. */
  var gesteStempel = Date.now();
  /* Von kauzWahl fuer einen Anlass aus eigenem Antrieb gewaehlt: laeuft als
     Schleife nur einen Durchlauf (Dauer aus dem Manifest). */
  var einmalZustand = null;
  /* Gesten aus eigenem Antrieb: nur nach GESTE_PAUSE_MS Ruhe. */
  var SPONTAN = ['leerlauf-variation', 'lange-ruhe', 'nach-antwort', 'erfolg'];
  function istGeste(z) { return !!z && KAUZ_GRUND.indexOf(z) === -1; }
  function kauzRuhig() { return Date.now() - gesteStempel >= GESTE_PAUSE_MS; }
  /* Rueckkehr aus „weg": das Gegenstueck der Weg-Geste spielt (fliegt-ein) und
     endet im Leerlauf. Gibt zurueck, ob die Figur gerade zurueckgeholt wird. */
  function kauzRueckkehr() {
    if (!kauzWeg) return false;
    var g = KAUZ_PAAR[kauzStand];
    if (g && !reduziert && kauzTraegt(g)) kauz(g); else kauz('leerlauf');
    return true;
  }
  function gesteAn(name) { return (wurzel.getAttribute('data-km-gesten') || '').split(',').indexOf(name) !== -1; }
  /* Traegt der Bildsatz diese Geste? Gelesen aus dem Stylesheet, nicht aus dem
     Dateisystem: --kauz-gesten steht am ersten Kauz der Wurzel. */
  function kauzTraegt(name) {
    var el = wurzel.querySelector('[data-km-kauz]');
    if (!el || !window.getComputedStyle) return false;
    return (' ' + window.getComputedStyle(el).getPropertyValue('--kauz-gesten').trim() + ' ').indexOf(' ' + name + ' ') !== -1;
  }
  /* Eintrag eines Zustands im Manifest (Dauer d in s, Schleife s), erst der
     schwebende Satz, dann der grosse; die Kleinformen stehen dort nicht. */
  function kauzEintrag(z) {
    if (!kauzSatz) return null;
    var r = ['links', 'rechts'], g = ['schwebend', 'gross'];
    for (var i = 0; i < r.length; i++) {
      for (var j = 0; j < g.length; j++) {
        var e = kauzSatz[r[i]] && kauzSatz[r[i]][g[j]] && kauzSatz[r[i]][g[j]][z];
        if (e) return e;
      }
    }
    return null;
  }
  function kauzDauerMs(z) {
    var e = kauzEintrag(z);
    return e && e.d > 0 ? Math.round(e.d * 1000) : 0;
  }
  function kauzSchleife(z) {
    var e = kauzEintrag(z);
    return !!(e && e.s) || z === 'leerlauf' || z === 'denkt';
  }
  function kauzHalte(z) {
    return KAUZ_HALTE_MS[z] ? Math.max(KAUZ_HALTE_MS[z], kauzDauerMs(z) ? kauzDauerMs(z) + 150 : 0) : 0;
  }
  /* Nur Gesten mit dem Anlass leerlauf-variation oder lange-ruhe haben einen
     Schalter im Konto; die ereignisgebundenen laufen ohne. */
  function kauzHatSchalter(z) {
    var liste = [].concat(KAUZ_AUSLOESER[z] || []);
    return liste.indexOf('leerlauf-variation') !== -1 || liste.indexOf('lange-ruhe') !== -1;
  }
  /* Liegt zu einer Geste mit endet_leer ihr Gegenstueck im Satz? Die kleine feste
     Figur (Kopf, klein) nutzt das Paar nur, wenn beide auch als Kleinform im Satz
     liegen; sonst bleibt sie stehen. */
  function kauzPaarDa(z) {
    var g = KAUZ_PAAR[z];
    if (!g || KAUZ_ZUSTAENDE.indexOf(g) === -1 || !kauzTraegt(g)) return false;
    if (!wurzel.classList.contains('km--schwebend') && wurzel.classList.contains('km--klein')) {
      return !!KAUZ_KLEIN && KAUZ_KLEIN.indexOf(z) !== -1 && KAUZ_KLEIN.indexOf(g) !== -1;
    }
    return true;
  }
  /* Darf dieser Zustand jetzt gespielt werden? */
  function kauzErlaubt(z) {
    if (reduziert || KAUZ_ZUSTAENDE.indexOf(z) === -1) return false;
    if (KAUZ_GRUND.indexOf(z) !== -1) return true;
    if (!kauzTraegt(z)) return false;
    if (kauzHatSchalter(z) && !gesteAn(z)) return false;
    return KAUZ_ENDET_LEER.indexOf(z) === -1 || kauzPaarDa(z);
  }
  /* Alle erlaubten Gesten, die diesen Anlass tragen. */
  function kauzGesten(anlass) {
    return Object.keys(KAUZ_AUSLOESER).filter(function (z) {
      return KAUZ_BEGINNT_LEER.indexOf(z) === -1 && [].concat(KAUZ_AUSLOESER[z] || []).indexOf(anlass) !== -1 && kauzErlaubt(z);
    });
  }
  function kauzWahl(anlass) {
    if (SPONTAN.indexOf(anlass) !== -1 && !kauzRuhig()) return null;
    var liste = kauzGesten(anlass);
    var z = liste.length ? liste[Math.floor(Math.random() * liste.length)] : null;
    /* Eine Schleifen-Geste aus eigenem Antrieb (blinzelt) spielt genau einen
       Durchlauf und kehrt dann in den Leerlauf zurueck (kauz(), einmalZustand). */
    if (z && SPONTAN.indexOf(anlass) !== -1) einmalZustand = z;
    return z;
  }
  /* Laeuft ein Zustand ueber eine Folge, folgt er nach dem Ende dem naechsten
     Eintrag; was der Satz nicht traegt, wird uebersprungen. */
  function kauzWeiter(von) {
    if (kauzStand !== von) return;
    var n = kauzDanach.shift();
    while (n && KAUZ_GRUND.indexOf(n) === -1 && !kauzTraegt(n)) n = kauzDanach.shift();
    kauz(n || 'leerlauf', kauzDanach);
  }
  /* `danach` ist der Zustand (oder die Folge von Zustaenden) nach dem Halten
     eines Einmal-Zustands (Vorgabe: Leerlauf). `haltMs` erzwingt eine Haltezeit
     (Vorschau einer Schleife).

     BEWEGTBILD (26.10.2026). In den Groessen gross und schwebend spielt
     kommunikator-kauz-medien.js ein Video bzw. animiertes WebP; es liest
     dafuer Klasse, data-km-kauz-zustand und den Zaehler data-km-kauz-lauf (er
     startet auch denselben Zustand neu). Eine Einmal-Geste, fuer die hier
     keine Haltezeit steht, endet mit der Meldung km:kauz-ende des Mediums und
     geht dann zum naechsten Zustand bzw. in den Leerlauf; die Gesten mit
     Haltezeit bleiben bei ihrem Zeitgeber, das Video steht solange auf seinem
     letzten Bild. */
  function kauz(zustand, danach, haltMs) {
    clearTimeout(kauzTimer);
    if (istGeste(zustand) || istGeste(kauzStand)) gesteStempel = Date.now();
    kauzStand = zustand;
    kauzWeg = KAUZ_ENDET_LEER.indexOf(zustand) !== -1;
    kauzDanach = danach ? [].concat(danach) : [];
    [].slice.call(wurzel.querySelectorAll('[data-km-kauz]')).forEach(function (el) {
      var bisher = el.getAttribute('data-km-kauz-zustand');
      if (bisher) el.classList.remove('kauz-radar--' + bisher);
      KAUZ_ZUSTAENDE.forEach(function (z) { el.classList.remove('kauz-radar--' + z); });
      void el.offsetWidth; // Einmal-Zustand neu abspielen
      el.classList.add('kauz-radar--' + zustand);
      el.setAttribute('data-km-kauz-zustand', zustand);
      el.setAttribute('data-km-kauz-lauf', String((parseInt(el.getAttribute('data-km-kauz-lauf'), 10) || 0) + 1));
    });
    var halte = haltMs || kauzHalte(zustand);
    if (einmalZustand === zustand) {
      einmalZustand = null;
      if (!halte && kauzSchleife(zustand)) halte = kauzDauerMs(zustand) || KAUZ_DAUER_VORGABE_MS;
    }
    if (kauzWeg) {
      /* weg: Endbild bleibt stehen, kein Zeitgeber, kein Leerlauf */
    } else if (halte) {
      kauzTimer = setTimeout(function () { kauzWeiter(zustand); }, halte);
    } else if (KAUZ_STANDARD.indexOf(zustand) === -1 && !kauzSchleife(zustand) && !/^zeigt-/.test(zustand)
      && (KAUZ_AUSLOESER[zustand] || []).indexOf('hinweis-aussen') === -1) {
      kauzTimer = setTimeout(function () { kauzWeiter(zustand); }, (kauzDauerMs(zustand) || KAUZ_DAUER_VORGABE_MS) + KAUZ_PUFFER_MS);
    }
  }
  document.addEventListener('km:kauz-ende', function (e) {
    var z = e && e.detail && e.detail.zustand;
    if (!z || z !== kauzStand || z === 'leerlauf' || kauzWeg || kauzHalte(z)) return;
    kauzWeiter(z);
  });
  /* Einen Anlass jetzt spielen — fuer alles, was nur im Leerlauf ohne laufende
     Antwort und bei sichtbarem Tab geschehen darf (leerlauf-variation,
     lange-ruhe) bzw. nur ohne laufende Antwort (die uebrigen). Gibt zurueck, ob
     etwas gespielt wird. */
  function kauzAusloeser(anlass, danach) {
    if (reduziert || laeuft || kauzWeg || document.hidden) return false;
    if ((anlass === 'leerlauf-variation' || anlass === 'lange-ruhe') && kauzStand !== 'leerlauf') return false;
    var z = kauzWahl(anlass);
    if (!z) return false;
    kauz(z, danach);
    return true;
  }
  /* Von aussen melden: { detail: { ausloeser: '<Anlass>' } }. */
  document.addEventListener('km:kauz-ausloeser', function (e) {
    var anlass = e && e.detail && e.detail.ausloeser;
    if (typeof anlass === 'string') kauzAusloeser(anlass);
  });
  /* Gelegentliche Variation im Leerlauf. Der Zeitgeber laeuft immer weiter;
     ob er etwas ausloest, entscheidet erst der Zeitpunkt. */
  function variationPlanen() {
    clearTimeout(variationTimer);
    if (reduziert) return;
    variationTimer = setTimeout(function () {
      kauzAusloeser('leerlauf-variation');
      variationPlanen();
    }, VARIATION_MIN_MS + Math.random() * (VARIATION_MAX_MS - VARIATION_MIN_MS));
  }
  variationPlanen();
  /* Lange Ruhe: 3 min ohne Eingabe einmal, danach fruehestens nach weiteren
     5 min. Eingaben schieben den Zeitgeber, die Sperre nach einer Geste
     gilt auch dann. */
  var ruheTimer = 0, ruheSperre = false, ruheSperreTimer = 0, regungStempel = 0;
  function ruhePlanen(ms) {
    clearTimeout(ruheTimer);
    if (reduziert) return;
    ruheTimer = setTimeout(ruheFaellig, ms === undefined ? RUHE_ERST_MS : ms);
  }
  function ruheFaellig() {
    if (!ruheSperre && kauzAusloeser('lange-ruhe')) {
      ruheSperre = true;
      clearTimeout(ruheSperreTimer);
      ruheSperreTimer = setTimeout(function () { ruheSperre = false; }, RUHE_NEU_MS - 1000);
      ruhePlanen(RUHE_NEU_MS);
    } else {
      ruhePlanen(RUHE_WIEDER_MS);
    }
  }
  function regung() {
    var t = Date.now();
    if (t - regungStempel < 500) return;
    regungStempel = t;
    ruhePlanen();
  }
  ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(function (name) {
    document.addEventListener(name, regung, { capture: true, passive: true });
  });
  ruhePlanen();
  /* „Abspielen" im Optionsfenster (km:<geste> mit erzwingen): ignoriert nur den
     Schalter, nicht den Bildsatz und nicht die reduzierte Bewegung. Eine
     Schleife laeuft zur Vorschau KAUZ_VORSCHAU_SCHLEIFE_MS. */
  KAUZ_ZUSTAENDE.filter(function (z) { return KAUZ_GRUND.indexOf(z) === -1; }).forEach(function (z) {
    document.addEventListener('km:' + z, function (e) {
      if (laeuft || reduziert || kauzWeg || !kauzTraegt(z)) return;
      if (e && e.detail && e.detail.erzwingen) kauz(z, null, kauzSchleife(z) ? KAUZ_VORSCHAU_SCHLEIFE_MS : 0);
    });
  });
  function gemerkt(schluessel, wert) {
    try {
      if (wert === undefined) return sessionStorage.getItem(schluessel);
      sessionStorage.setItem(schluessel, wert);
    } catch (e) { return null; }
    return null;
  }

  /* ---- Sprechblase ---- */
  function tippZeigen(idx) {
    if (!tipps.length || !blase || istMobil()) return;
    tippIdx = ((idx % tipps.length) + tipps.length) % tipps.length;
    var t = tipps[tippIdx];
    blaseText.textContent = t.text;
    var ziel = '';
    if (t.reiter && basis) {
      var tippKapitel = t.kapitel || kapitel;
      blaseLink.href = basis + '/' + encodeURIComponent(tippKapitel) + '/' + encodeURIComponent(t.reiter);
      ziel = blaseLink.href;
      blaseLink.textContent = (t.reiterTitel ? t.reiterTitel : 'Dorthin') + ' →';
      blaseLink.hidden = false;
    } else {
      blaseLink.hidden = true;
    }
    blase.hidden = false;
    zeigenMelden();
    /* Die Blase steht immer; Nicken und Zeigen nur, wenn die Ruhepause
       (GESTE_PAUSE_MS) es zulaesst — sie zaehlen dann selbst als Geste. */
    if (kauzRuhig() && !laeuft && !kauzWeg) {
      nicken();
      if (gesteAn('zeigen')) {
        var hinaus = ziel && ausserhalbDesReiters(ziel) ? kauzWahl('hinweis-aussen') : null;
        kauz(hinaus || (wurzel.classList.contains('km--links') ? 'zeigt-rechts' : 'zeigt-links'));
      }
      gesteStempel = Date.now();
    }
    if (ausTimer) clearTimeout(ausTimer);
    ausTimer = setTimeout(blaseZu, TIPP_DAUER_MS);
  }
  function blaseZu() {
    if (blase) blase.hidden = true;
    if (ausTimer) { clearTimeout(ausTimer); ausTimer = 0; }
    if (/^zeigt-/.test(kauzStand) || (KAUZ_AUSLOESER[kauzStand] || []).indexOf('hinweis-aussen') !== -1) kauz('leerlauf');
  }
  /* Liegt das Sprungziel des Tipps ausserhalb des Reiters, der gerade steht? */
  function ausserhalbDesReiters(href) {
    try {
      var z = new URL(href, window.location.href);
      var strip = function (p) { return decodeURIComponent(p).replace(/\/+$/, ''); };
      return strip(z.pathname) !== strip(window.location.pathname);
    } catch (e) { return false; }
  }
  function tippPlanen(ms) {
    if (tippTimer) { clearTimeout(tippTimer); tippTimer = 0; }
    if (istMobil()) return;
    tippTimer = setTimeout(function () {
      tippTimer = 0;
      if (istMobil()) { blaseZu(); return; }
      if (panel && !panel.hidden) { tippPlanen(TIPP_TAKT_MS); return; }
      if (document.hidden) { tippPlanen(TIPP_TAKT_MS); return; }
      tippZeigen(tippIdx + 1);
      tippPlanen(TIPP_TAKT_MS);
    }, ms);
  }
  var weiter = wurzel.querySelector('[data-km-blase-weiter]');
  if (weiter) weiter.addEventListener('click', function () { tippZeigen(tippIdx + 1); tippPlanen(TIPP_TAKT_MS); });
  var zu = wurzel.querySelector('[data-km-blase-zu]');
  if (zu) zu.addEventListener('click', function () { blaseZu(); gemerkt(SCHL + ':still', '1'); });
  // Wer die Blase einmal weggeklickt hat, bekommt in diesem Tab keine
  // ungefragten Tipps mehr — die Figur bleibt, ein Klick oeffnet weiter.
  function automatischeTippsStarten() {
    if (tipps.length && gemerkt(SCHL + ':still') !== '1') tippPlanen(TIPP_START_MS);
  }
  function breiteGeaendert(e) {
    if (e.matches) {
      if (tippTimer) { clearTimeout(tippTimer); tippTimer = 0; }
      blaseZu();
      return;
    }
    automatischeTippsStarten();
  }
  if (mobilAbfrage) {
    if (typeof mobilAbfrage.addEventListener === 'function') mobilAbfrage.addEventListener('change', breiteGeaendert);
    else if (typeof mobilAbfrage.addListener === 'function') mobilAbfrage.addListener(breiteGeaendert);
  }
  automatischeTippsStarten();

  /* ---- Gespraechsfenster ---- */
  /* Ein Verlauf je Projekt und Tab. Jeder Eintrag traegt sein kapitel; der
     Server bekommt nur rolle und text der letzten acht. Angezeigt werden
     bis zu VERLAUF_BEHALTEN Eintraege. */
  var VERLAUF_BEHALTEN = 24;
  var verlauf = [];
  try { verlauf = JSON.parse(gemerkt(GSCHL + ':verlauf') || '[]') || []; } catch (e) { verlauf = []; }
  if (!Array.isArray(verlauf)) verlauf = [];
  /* Bereichsverlaeufe von vor dem 28.10.2026 einmal zusammenfuehren: sie
     kommen vor den neuen Eintraegen, der aktuelle Bereich zuletzt; Token
     werden addiert, die alten Schluessel danach entfernt. */
  (function altVerlaeufeZusammenfuehren() {
    var praefix = 'sr-km:' + projekt + ':', alt = [], altTok = { ein: 0, aus: 0, cache: 0 }, weg = [];
    try {
      for (var i = 0; i < sessionStorage.length; i++) {
        var k = sessionStorage.key(i);
        if (!k || k.indexOf(praefix) !== 0) continue;
        var teile = k.slice(praefix.length).split(':');
        if (teile.length !== 2 || teile[0] === 'gespraech' || (teile[1] !== 'verlauf' && teile[1] !== 'tokens')) continue;
        weg.push(k);
        var wert = JSON.parse(sessionStorage.getItem(k) || 'null');
        if (teile[1] === 'tokens' && wert && typeof wert === 'object') {
          altTok.ein += +wert.ein || 0; altTok.aus += +wert.aus || 0; altTok.cache += +wert.cache || 0;
        } else if (teile[1] === 'verlauf' && Array.isArray(wert)) {
          alt.push({ kapitel: teile[0], liste: wert });
        }
      }
    } catch (e) { return; }
    if (!weg.length) return;
    alt.sort(function (a, b) { return (a.kapitel === kapitel) - (b.kapitel === kapitel); });
    var zusammen = [];
    alt.forEach(function (a) { a.liste.forEach(function (w) { if (w && typeof w === 'object') { w.kapitel = w.kapitel || a.kapitel; zusammen.push(w); } }); });
    verlauf = zusammen.concat(verlauf).slice(-VERLAUF_BEHALTEN);
    gemerkt(GSCHL + ':verlauf', JSON.stringify(verlauf));
    if (altTok.ein + altTok.aus + altTok.cache > 0) {
      var tokJetzt = null;
      try { tokJetzt = JSON.parse(gemerkt(GSCHL + ':tokens') || 'null'); } catch (e) { tokJetzt = null; }
      tokJetzt = tokJetzt && typeof tokJetzt === 'object' ? tokJetzt : {};
      gemerkt(GSCHL + ':tokens', JSON.stringify({ ein: (+tokJetzt.ein || 0) + altTok.ein, aus: (+tokJetzt.aus || 0) + altTok.aus, cache: (+tokJetzt.cache || 0) + altTok.cache }));
    }
    weg.forEach(function (k) { try { sessionStorage.removeItem(k); } catch (e) { /* egal */ } });
  })();
  if (verlauf.length) wurzel.classList.add('km--gespraech');
  function nachricht(rolle, html, text) {
    var box = document.createElement('div');
    box.className = 'km-nachricht km-nachricht--' + rolle;
    if (html) box.innerHTML = html; else { var p = document.createElement('p'); p.textContent = text; box.appendChild(p); }
    verlaufEl.appendChild(box);
    verlaufEl.scrollTop = verlaufEl.scrollHeight;
    return box;
  }
  verlauf.forEach(function (w) { nachricht(w.rolle === 'assistent' ? 'assistent' : 'nutzer', w.rolle === 'assistent' ? w.html : '', w.text); });

  /* ---- Welche KI antwortet (03.10.2026) ----
     Anbieter, Modell und Stufe kommen beim ersten Oeffnen von GET …/ki und
     danach mit jeder Antwort; die Token addiert der Browser, weil das
     Gespraech nur hier existiert (dieselbe Lebensdauer wie der Verlauf).
     `sysadmin` liefert der Server nur dem Superadmin. */
  var kiBox = wurzel.querySelector('[data-km-ki]');
  var kiGeladen = false;
  var tokenSumme = { ein: 0, aus: 0, cache: 0 };
  try { var tokRoh = JSON.parse(gemerkt(GSCHL + ':tokens') || 'null'); if (tokRoh && typeof tokRoh === 'object') tokenSumme = { ein: +tokRoh.ein || 0, aus: +tokRoh.aus || 0, cache: +tokRoh.cache || 0 }; } catch (e) {}
  function zahlDe(n) { try { return Number(n || 0).toLocaleString('de-DE'); } catch (e) { return String(n || 0); } }
  function kiZeigen(ki) {
    if (!kiBox) return;
    var zeile = kiBox.querySelector('[data-km-ki-zeile]');
    var tok = kiBox.querySelector('[data-km-ki-token]');
    var admin = kiBox.querySelector('[data-km-ki-admin]');
    if (ki) {
      zeile.textContent = 'KI: ' + ki.anbieter + ' · ' + ki.modell + ' · Stufe ' + (ki.stufe || 'Vorgabe des Anbieters')
        + (ki.ersatz ? ' · Ersatzmodell, das Hauptmodell war nicht erreichbar' : '');
      if (ki.sysadmin) {
        var s = ki.sysadmin;
        admin.textContent = 'Zugang: ' + s.zugang + (s.quelle ? ' (' + s.quelle + ')' : '')
          + (s.mandantId ? ' · Mandant ' + s.mandantId : '')
          + (s.dialogId ? ' · Dialog #' + s.dialogId : '')
          + (s.kostenAbrufId ? ' · Kostenabruf #' + s.kostenAbrufId : '');
        admin.hidden = false;
      }
      kiBox.hidden = false;
    }
    var summe = tokenSumme.ein + tokenSumme.aus + tokenSumme.cache;
    if (summe > 0) {
      tok.textContent = 'Token seit Gesprächsbeginn: ' + zahlDe(summe) + ' (ein ' + zahlDe(tokenSumme.ein)
        + ' · aus ' + zahlDe(tokenSumme.aus) + (tokenSumme.cache ? ' · Cache ' + zahlDe(tokenSumme.cache) : '') + ')';
      tok.hidden = false;
    }
  }
  /* MODELLWAHL JE FRAGE (28.10.2026). Die Optionen liefert der Server (nur
     erlaubte, nur bei mehr als einer Wahl). Im Fuss steht ein Chip mit
     Kurzname und Stufe; er oeffnet ueber der Eingabe ein Feld mit den Reihen
     Anbieter → Konto → Modell → Stufe. Jede Reihe zeigt nur, was zur Wahl
     darueber passt, und erscheint erst ab zwei Werten (das Modell immer). Ein
     Wechsel oben behaelt unten den bisherigen Wert, wenn er dort gilt, sonst
     den ersten gueltigen — es entsteht nie eine Kombination ohne
     Serveroption. Gesendet wird genau deren `wert`.
     Der Eintrag „Vorgabe“ steht fuer die aufgeloeste Vorgabe von Bereich,
     Projekt oder Mandant und sendet kein Feld `wahl`; ist sie ein
     Abo-Zugang, hat sie in den Reihen ihren Platz. Kundenkonten (und
     Optionen ohne Gliederung) sehen nur die Modelle als Chips. */
  var wahlBox = wurzel.querySelector('[data-km-wahl]');
  var wahlFeld = wurzel.querySelector('[data-km-wahl-feld]');
  var wahlChip = wurzel.querySelector('[data-km-wahl-chip]');
  var wahlText = wurzel.querySelector('[data-km-wahl-text]');
  var WAHL_REIHEN = [
    { k: 'anbieter', titel: 'Anbieter', text: 'anbieterLabel' },
    { k: 'profil', titel: 'Konto', text: 'kontoLabel' },
    { k: 'modell', titel: 'Modell', text: 'modellLabel', chips: true, immer: true },
    { k: 'stufe', titel: 'Stufe', text: 'stufeLabel' }
  ];
  var wahl = { wert: '', eintraege: [], vorgabe: null, ki: null, flach: true };
  var STUFEN_FOLGE = ['', 'minimal', 'low', 'medium', 'high', 'xhigh', 'max', 'ultra'];

  function wahlTeil(e, k) { return e && e[k] != null ? String(e[k]) : ''; }
  function wahlEintrag(wert) {
    for (var i = 0; i < wahl.eintraege.length; i++) if (wahl.eintraege[i].wert === wert) return wahl.eintraege[i];
    return null;
  }
  function wahlName(e) { return wahl.flach ? (e.label || e.modellLabel || e.wert) : (e.modellLabel || e.modell || e.label); }
  function wahlBeschriftung() {
    var e = wahl.wert ? wahlEintrag(wahl.wert) : null;
    if (e) return wahlName(e) + (!wahl.flach && e.stufeLabel ? ' · ' + e.stufeLabel : '');
    var v = wahl.vorgabe || {};
    var name = v.modellLabel || (wahl.ki && wahl.ki.modell) || '';
    var stufe = wahl.flach ? '' : (v.stufeLabel || (wahl.ki && wahl.ki.stufe) || '');
    return 'Vorgabe' + (name ? ' · ' + name : '') + (stufe ? ' · ' + stufe : '');
  }
  /* Wahl in einer Reihe: Reihen darueber bleiben, Reihen darunter behalten
     ihren Wert, wenn es ihn dort gibt, sonst gilt der erste. */
  function wahlNachReihe(reihe, wert) {
    var basis = wahlEintrag(wahl.wert) || wahl.eintraege[0];
    var passend = wahl.eintraege;
    var erreicht = false;
    for (var i = 0; i < WAHL_REIHEN.length; i++) {
      var k = WAHL_REIHEN[i].k;
      var soll = k === reihe ? wert : wahlTeil(basis, k);
      var hier = passend.filter(function (e) { return wahlTeil(e, k) === soll; });
      if (!hier.length) {
        if (!erreicht) return null;
        var erster = wahlTeil(passend[0], k);
        hier = passend.filter(function (e) { return wahlTeil(e, k) === erster; });
      }
      if (k === reihe) erreicht = true;
      passend = hier;
    }
    return passend.length ? passend[0].wert : null;
  }
  function wahlKnopf(reihe, wert, text, an, chip) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = chip ? 'km-modellwahl-chip' : 'km-modellwahl-segment';
    b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', an ? 'true' : 'false');
    b.setAttribute('data-reihe', reihe);
    b.setAttribute('data-wert', wert);
    b.textContent = text;
    return b;
  }
  function wahlReihe(id, titel, knoepfe, chips) {
    var zeile = document.createElement('div');
    zeile.className = 'km-modellwahl-reihe';
    var label = document.createElement('span');
    label.className = 'km-modellwahl-label';
    label.id = 'km-mw-' + id;
    label.textContent = titel;
    var gruppe = document.createElement('div');
    gruppe.className = chips ? 'km-modellwahl-chips' : 'km-modellwahl-segmente';
    gruppe.setAttribute('role', 'radiogroup');
    gruppe.setAttribute('aria-labelledby', label.id);
    var aktiv = null;
    knoepfe.forEach(function (b) { b.tabIndex = -1; if (!aktiv && b.getAttribute('aria-checked') === 'true') aktiv = b; gruppe.appendChild(b); });
    (aktiv || knoepfe[0]).tabIndex = 0;
    zeile.appendChild(label);
    zeile.appendChild(gruppe);
    return zeile;
  }
  function wahlZeichnen() {
    if (!wahlFeld) return;
    var e = wahlEintrag(wahl.wert);
    var reihen = [];
    if (wahl.flach) {
      reihen.push(wahlReihe('modell', 'Modell', wahl.eintraege.map(function (o) {
        return wahlKnopf('wert', o.wert, wahlName(o), e === o, true);
      }), true));
    } else {
      var basis = e || wahl.eintraege[0];
      var passend = wahl.eintraege;
      WAHL_REIHEN.forEach(function (r) {
        var werte = [], texte = {};
        passend.forEach(function (o) {
          var w = wahlTeil(o, r.k);
          if (werte.indexOf(w) < 0) { werte.push(w); texte[w] = o[r.text] || (r.k === 'stufe' ? 'Std' : w); }
        });
        if (r.k === 'stufe') werte.sort(function (a, b) { return STUFEN_FOLGE.indexOf(a) - STUFEN_FOLGE.indexOf(b); });
        if (werte.length > 1 || r.immer) {
          reihen.push(wahlReihe(r.k, r.titel, werte.map(function (w) {
            return wahlKnopf(r.k, w, texte[w], !!e && wahlTeil(e, r.k) === w, r.chips);
          }), r.chips));
        }
        var soll = wahlTeil(basis, r.k);
        passend = passend.filter(function (o) { return wahlTeil(o, r.k) === soll; });
      });
    }
    var fuss = document.createElement('div');
    fuss.className = 'km-modellwahl-fuss';
    var vorgabe = document.createElement('button');
    vorgabe.type = 'button';
    vorgabe.className = 'km-modellwahl-vorgabe';
    vorgabe.setAttribute('data-km-wahl-vorgabe', '');
    vorgabe.setAttribute('aria-pressed', wahl.wert ? 'false' : 'true');
    vorgabe.textContent = 'Vorgabe verwenden';
    fuss.appendChild(vorgabe);
    var v = wahl.vorgabe || {};
    var vName = v.modellLabel || (wahl.ki && wahl.ki.modell) || '';
    if (vName) {
      var vText = document.createElement('span');
      vText.className = 'km-modellwahl-vorgabe-text';
      vText.textContent = vName + (!wahl.flach && (v.stufeLabel || (wahl.ki && wahl.ki.stufe)) ? ' · ' + (v.stufeLabel || wahl.ki.stufe) : '');
      fuss.appendChild(vText);
    }
    reihen.push(fuss);
    wahlFeld.replaceChildren.apply(wahlFeld, reihen);
  }
  function wahlUebernehmen(wert) {
    wahl.wert = wert;
    gemerkt(SCHL + ':wahl', wert);
    var beschriftung = wahlBeschriftung();
    if (wahlText) wahlText.textContent = beschriftung;
    if (wahlChip) wahlChip.title = 'Modell für diese Frage: ' + beschriftung;
    if (wahlChip) wahlChip.classList.toggle('km-modell-chip--vorgabe', !wert);
    wahlBox.setAttribute('data-km-wahl-wert', wert);
    if (!wahlFeld.hidden) wahlZeichnen();
  }
  function wahlFokus(reihe, wert) {
    var knoepfe = wahlFeld.querySelectorAll('[role="radio"]');
    for (var i = 0; i < knoepfe.length; i++) {
      if (knoepfe[i].getAttribute('data-reihe') === reihe && knoepfe[i].getAttribute('data-wert') === wert) { knoepfe[i].focus(); return; }
    }
  }
  /* Hoehe des Feldes nach dem Platz, den das Fenster noch hat: seine
     Hoechsthoehe abzueglich allem ausser dem Verlauf und einem Rand fuer die
     Knopfgruppe oben. Ohne diese Rechnung rollte das Feld schon, waehrend
     das Fenster noch wachsen konnte. Gesetzt per CSSOM (CSP: kein style=). */
  function wahlHoehe() {
    if (!panel || !verlaufEl || !wahlFeld) return;
    var max = parseFloat(getComputedStyle(panel).maxHeight);
    if (!isFinite(max)) max = panel.getBoundingClientRect().height;
    var feld = wahlFeld.hidden ? 0 : wahlFeld.getBoundingClientRect().height + 4;
    var rest = panel.getBoundingClientRect().height - verlaufEl.getBoundingClientRect().height - feld;
    wahlFeld.style.maxHeight = Math.max(140, Math.min(560, Math.floor(max - rest - 44))) + 'px';
  }
  function wahlOffen(auf, fokusZumChip) {
    if (!wahlFeld || !wahlChip) return;
    if (auf) { wahlZeichnen(); wahlHoehe(); }
    wahlFeld.hidden = !auf;
    wahlChip.setAttribute('aria-expanded', auf ? 'true' : 'false');
    wahlBox.classList.toggle('km-modell--offen', auf);
    if (auf) {
      var ziel = wahlFeld.querySelector('[role="radio"][tabindex="0"]');
      if (ziel) ziel.focus({ preventScroll: true });
    } else if (fokusZumChip) wahlChip.focus({ preventScroll: true });
  }
  function wahlAufbauen(j) {
    if (!wahlBox || !wahlFeld || !wahlChip || !j || !j.ki || !Array.isArray(j.optionen) || !j.optionen.length) return;
    var optionen = j.optionen.filter(function (o) { return o && typeof o.wert === 'string' && o.wert; });
    if (!optionen.length) return;
    var v = j.vorgabe && typeof j.vorgabe === 'object' ? j.vorgabe : null;
    wahl.ki = j.ki;
    wahl.vorgabe = v;
    wahl.flach = j.wahlArt !== 'alle' || !optionen.every(function (o) { return o.anbieter && o.profil && o.modell; });
    var eintraege = [];
    if (v && v.modell && (wahl.flach || (v.anbieter && v.profil))) {
      var ve = {};
      for (var feld in v) if (Object.prototype.hasOwnProperty.call(v, feld)) ve[feld] = v[feld];
      ve.wert = '';
      eintraege.push(ve);
    }
    // Die Vorgabe steht hinten: die Reihen folgen der Reihenfolge des Servers.
    wahl.eintraege = optionen.concat(eintraege);
    var vorher = gemerkt(SCHL + ':wahl');
    wahlUebernehmen(vorher && wahlEintrag(vorher) ? vorher : '');
    wahlBox.hidden = false;
  }
  if (wahlBox && wahlFeld && wahlChip) {
    wahlChip.addEventListener('click', function () { wahlOffen(wahlFeld.hidden); });
    wahlFeld.addEventListener('click', function (ev) {
      var knopf = ev.target.closest('button');
      if (!knopf || !wahlFeld.contains(knopf)) return;
      if (knopf.hasAttribute('data-km-wahl-vorgabe')) {
        wahlUebernehmen('');
        var vk = wahlFeld.querySelector('[data-km-wahl-vorgabe]');
        if (vk) vk.focus({ preventScroll: true });
        return;
      }
      var reihe = knopf.getAttribute('data-reihe'), wert = knopf.getAttribute('data-wert');
      var neu = reihe === 'wert' ? wert : wahlNachReihe(reihe, wert);
      if (neu === null || !wahlEintrag(neu)) return;
      wahlUebernehmen(neu);
      wahlFokus(reihe, wert);
    });
    /* Pfeiltasten wandern in der Reihe und waehlen dabei (Radiogruppe). */
    wahlFeld.addEventListener('keydown', function (ev) {
      var knopf = ev.target.closest && ev.target.closest('[role="radio"]');
      if (!knopf) return;
      var schritt = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[ev.key];
      var alle = [].slice.call(knopf.parentNode.querySelectorAll('[role="radio"]'));
      var i = alle.indexOf(knopf), ziel = null;
      if (schritt) ziel = alle[(i + schritt + alle.length) % alle.length];
      else if (ev.key === 'Home') ziel = alle[0];
      else if (ev.key === 'End') ziel = alle[alle.length - 1];
      if (!ziel) return;
      ev.preventDefault();
      ziel.click();
    });
    document.addEventListener('pointerdown', function (ev) {
      if (wahlFeld.hidden || wahlBox.contains(ev.target)) return;
      wahlOffen(false);
    }, true);
    wahlBox.addEventListener('focusout', function (ev) {
      if (!wahlFeld.hidden && ev.relatedTarget && !wahlBox.contains(ev.relatedTarget)) wahlOffen(false);
    });
    window.addEventListener('resize', function () { if (!wahlFeld.hidden) wahlHoehe(); });
    /* Esc schliesst zuerst das Feld, nicht das Gespraech darunter. */
    document.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Escape' || wahlFeld.hidden) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      wahlOffen(false, true);
    }, true);
  }
  function kiLaden() {
    if (kiGeladen || !kiBox || !verfuegbar || !aktion) return;
    kiGeladen = true;
    var kiUrl = new URL(aktion.replace(/\/+$/, '') + '/ki', window.location.origin);
    kiUrl.searchParams.set('kapitel', kapitel);
    fetch(kiUrl.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j && j.ki) { kiZeigen(j.ki); wahlAufbauen(j); } })
      .catch(function () { kiGeladen = false; });
  }
  function tokenBuchen(ki) {
    if (!ki || !ki.tokens) return;
    tokenSumme.ein += +ki.tokens.ein || 0;
    tokenSumme.aus += +ki.tokens.aus || 0;
    tokenSumme.cache += +ki.tokens.cache || 0;
    gemerkt(GSCHL + ':tokens', JSON.stringify(tokenSumme));
  }

  /* ---- Fensterzustand ueber Seitenwechsel (Betreiber-Anweisung 26.10.2026) ----
     Ein offenes Gespraechsfenster bleibt offen, bis der Nutzer es schliesst.
     Der Zustand liegt im localStorage je Konto (data-km-konto) unter
     FENSTER_SCHL; dieser Baustein fuehrt `offen`, kommunikator-position.js
     im selben Eintrag `angedockt`, `breite` und `lage`. Die Groesse des
     Fensters (klein/mittel/gross) steht NICHT darin: sie gehoert dem Konto am
     Server (ui_prefs, Optionsfenster); eine Browserkopie hatte sie am
     03.10.2026 schon einmal ueberstimmt. Der Verlauf bleibt, wo er war
     (sessionStorage je Projekt und Tab). */
  var FENSTER_SCHL = 'kauz360:kommunikator-fenster:' + (wurzel.getAttribute('data-km-konto') || 'gast');
  function fensterStand(teil) {
    var stand = {};
    try { stand = JSON.parse(localStorage.getItem(FENSTER_SCHL) || '{}') || {}; } catch (e) { stand = {}; }
    if (!teil) return stand;
    Object.keys(teil).forEach(function (k) { stand[k] = teil[k]; });
    try { localStorage.setItem(FENSTER_SCHL, JSON.stringify(stand)); } catch (e) { /* gesperrte Seitendaten */ }
    return stand;
  }

  /* `still`: Wiederherstellen beim Laden — kein Einflug, kein Gruss, kein
     Fokus auf der Eingabe (die Seite gehoert beim Laden dem Inhalt). */
  function oeffnen(still) {
    if (!panel) return;
    still = still === true;
    blaseZu();
    if (still) wurzel.classList.add('km--ohne-einflug');
    panel.hidden = false;
    wurzel.classList.add('km--offen');
    if (typeof wurzel.showPopover === 'function' && wurzel.hasAttribute('popover') && !wurzel.matches(':popover-open')) {
      wurzel.showPopover();
    }
    figur.setAttribute('aria-expanded', 'true');
    fensterStand({ offen: true });
    document.dispatchEvent(new CustomEvent('km:gespraech', { detail: { offen: true, still: still } }));
    /* War die Figur weg, kehrt sie jetzt zurueck — statt des Grusses und
       unabhaengig vom Einmal-Merker und vom Schalter „Beim Oeffnen winken". */
    if (!still) winkenMelden(kauzRueckkehr());
    kiLaden();
    eingabeHoehe();
    var ta = form && form.querySelector('textarea');
    if (!still && ta && !ta.disabled) ta.focus({ preventScroll: true });
  }
  function schliessen() {
    if (!panel) return;
    panel.hidden = true;
    wurzel.classList.remove('km--offen', 'km--ohne-einflug');
    infoZu();
    fensterStand({ offen: false });
    document.dispatchEvent(new CustomEvent('km:gespraech', { detail: { offen: false } }));
    figur.setAttribute('aria-expanded', 'false');
    figur.focus();
    /* Anlass „schliessen": nur, wenn die Figur nach dem Schliessen zu sehen ist. */
    var kauzEl = figur.querySelector('[data-km-kauz]');
    if (kauzEl && kauzEl.getClientRects().length) kauzAusloeser('schliessen');
  }
  figur.setAttribute('aria-expanded', 'false');
  if (location.hash.indexOf('#kommunikator=') === 0) {
    try {
      var uebergebeneFrage = decodeURIComponent(location.hash.slice(14)).slice(0, 4000);
      history.replaceState(history.state, '', location.pathname + location.search);
      requestAnimationFrame(function () {
        oeffnen();
        var eingabe = form && form.querySelector('textarea');
        if (eingabe) { eingabe.value = uebergebeneFrage; eingabeHoehe(); if (!eingabe.disabled) eingabe.focus(); }
      });
    } catch (_) {}
  }
  figur.addEventListener('click', function () { if (panel && panel.hidden) oeffnen(); else schliessen(); });
  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-km-frage]');
    if (!button || !document.contains(wurzel)) return;
    e.preventDefault();
    var frage = button.getAttribute('data-km-frage') || '';
    function frageOeffnen() {
      oeffnen();
      var ta = form && form.querySelector('textarea');
      if (ta) { ta.value = frage; eingabeHoehe(); if (!ta.disabled) ta.focus({ preventScroll: true }); }
    }
    var modal = button.closest('dialog[open]');
    var schliesser = modal && modal.querySelector('.kw-detail-drawer-zu');
    if (schliesser) {
      var uebergabe = new CustomEvent('km:detail-schliessen', { cancelable: true });
      modal.dispatchEvent(uebergabe);
      if (uebergabe.defaultPrevented) {
        requestAnimationFrame(frageOeffnen);
      } else {
        modal.addEventListener('close', frageOeffnen, { once: true });
        schliesser.click();
      }
    } else frageOeffnen();
  });
  [].slice.call(wurzel.querySelectorAll('[data-km-beispielfrage]')).forEach(function (button) {
    button.addEventListener('click', function () {
      var ta = form && form.querySelector('textarea');
      if (!ta || ta.disabled) return;
      ta.value = button.getAttribute('data-km-beispielfrage') || ''; eingabeHoehe();
      ta.focus();
    });
  });
  /* ALLE Schliessknoepfe, nicht der erste (12.09.2026). Seit Figur und
     Gespraechsfenster EIN Markup haben (app/views/assistent.js), stehen zwei
     davon im Kasten: einer an der schwebenden Figur, einer in der Werkzeuggruppe des Fensters. Je
     nach Darstellung ist der eine oder der andere ausgeblendet —
     `querySelector` traf den ersten und band den Horcher an den unsichtbaren. */
  [].slice.call(wurzel.querySelectorAll('[data-km-zu]')).forEach(function (knopf) {
    knopf.addEventListener('click', schliessen);
  });
  /* Esc gehoert dem obersten Fenster: steht das Optionsfenster offen, schliesst
     es dieses (kommunikator-optionen.js) und nicht das Gespraech darunter. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !panel || panel.hidden) return;
    if (wurzel.querySelector('[data-km-optionen]:not([hidden])')) return;
    schliessen();
  });

  var laeuft = false;
  /* PHASE DER ANTWORT (21.10.2026, Gegenpruefung Stufe 3). Der Client schickt
     eine eigene anfrageId mit und fragt GET <aktion>/fortschritt?id= alle
     1,5 s ab: antwort → pruefung → ueberarbeitung → fertig/fehler. Die
     Wartezeile nennt die Phase, der Kauz bleibt bei „denkt“. Ende bei
     fertig/fehler, mit der Antwort oder spaetestens nach 120 s. */
  var PHASE_TEXT = {
    antwort: 'Kauz Radar liest die Zahlen …',
    pruefung: 'Kauz Radar prüft die Antwort gegen die Zahlen …',
    ueberarbeitung: 'Kauz Radar überarbeitet die Antwort …',
    ersatz: 'Kauz Radar fragt das zweite Modell …',
    wartet: 'Kauz Radar wartet kurz, das Modell beantwortet gerade eine andere Frage …'
  };
  var PHASE_TAKT_MS = 1500, PHASE_GRENZE_MS = 120000;
  function phaseVerfolgen(anfrageId, zeile) {
    var beginn = Date.now(), timer = 0, aus = false;
    var url = new URL(aktion.replace(/\/+$/, '') + '/fortschritt', window.location.origin);
    url.searchParams.set('id', anfrageId);
    function weiter() { if (!aus && Date.now() - beginn < PHASE_GRENZE_MS) timer = setTimeout(abfragen, PHASE_TAKT_MS); }
    function abfragen() {
      if (aus) return;
      fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var stand = j && j.stand;
          if (aus || stand === 'fertig' || stand === 'fehler') return;
          if (PHASE_TEXT[stand] && zeile.textContent !== PHASE_TEXT[stand]) zeile.textContent = PHASE_TEXT[stand];
          weiter();
        })
        .catch(weiter);
    }
    weiter();
    return function () { aus = true; clearTimeout(timer); };
  }
  /* Nach einem Ausfall: Knopf „Noch einmal fragen“ schickt dieselbe Frage
     erneut; die gescheiterte Frage und ihre Fehlerzeile verschwinden. */
  function wiederholenAnbieten(warten, frageEl, frage) {
    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'knopf knopf--klein km-wiederholen';
    knopf.textContent = 'Noch einmal fragen';
    knopf.addEventListener('click', function () {
      if (laeuft || !form) return;
      var ta = form.querySelector('textarea');
      if (frageEl && frageEl.parentNode) frageEl.parentNode.removeChild(frageEl);
      if (warten && warten.parentNode) warten.parentNode.removeChild(warten);
      ta.value = frage;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
    warten.appendChild(knopf);
  }
  /* SCHWEBENDE FRAGE (28.10.2026, cmvskhbm9). Beim Absenden steht
     {anfrageId, frage, kapitel, ts} unter GSCHL:schwebend. Wechselt der
     Nutzer waehrend der Antwort die Seite, bricht der fetch ab; der Server
     rechnet weiter und legt das Ergebnis 15 Minuten ab (GET …/ergebnis).
     Die naechste Seite zeigt Frage und Wartezeile und holt es dort ab.
     Absenden und Wiederaufnahme enden beide in antwortVerarbeiten(). */
  var SCHWEBE_MS = 15 * 60 * 1000, ERGEBNIS_TAKT_MS = 2000;
  function schwebend(wert) {
    if (wert === undefined) {
      var s = null;
      try { s = JSON.parse(gemerkt(GSCHL + ':schwebend') || 'null'); } catch (e) { s = null; }
      return s && typeof s === 'object' && typeof s.anfrageId === 'string' && typeof s.frage === 'string' ? s : null;
    }
    try {
      if (wert) sessionStorage.setItem(GSCHL + ':schwebend', JSON.stringify(wert));
      else sessionStorage.removeItem(GSCHL + ':schwebend');
    } catch (e) { /* gesperrte Seitendaten: dann nur ohne Wiederaufnahme */ }
  }
  /* Frage und Wartezeile zeigen, Phase verfolgen, Kauz denkt. Beim Absenden
     erst die Bestaetigung (zustimmung), dann „antwort-laeuft" (Schleife)
     statt „denkt", wenn der Satz sie traegt, sonst „denkt"; bei der
     Wiederaufnahme ohne Bestaetigung. */
  function wartenBeginnen(s, mitZustimmung) {
    wurzel.classList.add('km--gespraech');
    var frageEl = nachricht('nutzer', '', s.frage);
    var warten = nachricht('assistent', '<p class="km-wartet">' + PHASE_TEXT.antwort + '</p>', '');
    laeuft = true;
    wurzel.classList.add('km--denkt');
    denkenMelden(true);
    var folge = [];
    if (gesteAn('denkt')) {
      var liest = kauzWahl('antwort-laeuft');
      if (liest) { folge.push(liest); if (!kauzSchleife(liest)) folge.push('denkt'); } else folge.push('denkt');
    }
    var nickt = mitZustimmung ? kauzWahl('zustimmung') : null;
    if (nickt) folge.unshift(nickt);
    if (folge.length) kauz(folge.shift(), folge); else kauz('leerlauf');
    return { s: s, frageEl: frageEl, warten: warten, fertig: false, phaseEnde: phaseVerfolgen(s.anfrageId, warten.querySelector('.km-wartet')) };
  }
  /* a = {ok, j} wie vom Server; null = Antwort verloren (Neustart, Ablauf). */
  function antwortVerarbeiten(lauf, a) {
    if (lauf.fertig) return;
    lauf.fertig = true;
    var offen = schwebend();
    if (offen && offen.anfrageId === lauf.s.anfrageId) schwebend(null);
    var warten = lauf.warten, frage = lauf.s.frage;
    var erfolg = false, ungeprueft = false;
    if (!a) {
      warten.innerHTML = '<p>Die Antwort ging verloren.</p>';
      wiederholenAnbieten(warten, lauf.frageEl, frage);
    } else {
      var html = a.j && a.j.html ? a.j.html : '<p>' + ((a.j && a.j.fehler) || 'Keine Antwort erhalten.') + '</p>';
      warten.innerHTML = html;
      if (a.ok && a.j && a.j.antwort) {
        verlauf.push({ rolle: 'nutzer', text: frage, kapitel: lauf.s.kapitel });
        verlauf.push({ rolle: 'assistent', text: a.j.antwort, html: html, kapitel: lauf.s.kapitel });
        verlauf = verlauf.slice(-VERLAUF_BEHALTEN);
        gemerkt(GSCHL + ':verlauf', JSON.stringify(verlauf));
      }
      if (a.ok && a.j && a.j.ki) { tokenBuchen(a.j.ki); kiZeigen(a.j.ki); }
      erfolg = !!(a.ok && a.j && a.j.antwort && a.j.geprueft !== false);
      ungeprueft = !!(a.ok && a.j && a.j.antwort && a.j.geprueft === false);
      if (!a.ok && a.j && a.j.wiederholen) wiederholenAnbieten(warten, lauf.frageEl, frage);
    }
    lauf.phaseEnde();
    laeuft = false;
    wurzel.classList.remove('km--denkt');
    denkenMelden(false);
    if (erfolg) {
      /* „freut" bleibt; danach nur in einem von drei Faellen eine Geste
         (NACH_ANTWORT_ANTEIL), darin mit 50 % eine fuer „erfolg", sonst
         eine fuer „nach-antwort". Beide brauchen die Ruhepause
         (kauzWahl → kauzRuhig). */
      var nachher = null;
      if (Math.random() < NACH_ANTWORT_ANTEIL) {
        var feier = Math.random() < 0.5 ? kauzWahl('erfolg') : null;
        nachher = feier || kauzWahl('nach-antwort');
      }
      kauz('freut', nachher);
    } else {
      /* Fehler (HTTP-Fehler, Netz, verloren) → Geste fuer „fehler", sonst
         „stutzt"; die ungeprueft gemeldete Antwort bleibt bei „stutzt". */
      kauz((!ungeprueft && kauzWahl('fehler')) || 'stutzt');
    }
    zeigenMelden();
    nicken();
    verlaufEl.scrollTop = verlaufEl.scrollHeight;
  }
  /* Ergebnis am Server abholen: 202 = rechnet noch, 404 = keins (mehr) da.
     Nach SCHWEBE_MS ab Absenden gilt die Antwort als verloren. */
  function ergebnisAbholen(lauf) {
    var url = new URL(aktion.replace(/\/+$/, '') + '/ergebnis', window.location.origin);
    url.searchParams.set('id', lauf.s.anfrageId);
    var netzFehler = 0;
    function netzWeg() {
      // 30 s ohne Verbindung zum Server: wie bisher Satz und Knopf.
      if (++netzFehler < 15) { weiter(); return; }
      antwortVerarbeiten(lauf, { ok: false, j: { fehler: 'Kauz Radar ist gerade nicht erreichbar.', wiederholen: true } });
    }
    function weiter() {
      if (lauf.fertig) return;
      if (Date.now() - (+lauf.s.ts || 0) > SCHWEBE_MS) { antwortVerarbeiten(lauf, null); return; }
      setTimeout(abfragen, ERGEBNIS_TAKT_MS);
    }
    function abfragen() {
      if (lauf.fertig) return;
      fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) {
          netzFehler = 0;
          if (r.status === 404) { antwortVerarbeiten(lauf, null); return null; }
          if (!r.ok || r.status === 202) { weiter(); return null; }
          return r.json().then(function (j) {
            if (j && j.stand === 'fertig') antwortVerarbeiten(lauf, { ok: j.status >= 200 && j.status < 300, j: j.ergebnis || {} });
            else weiter();
          });
        })
        .catch(netzWeg);
    }
    abfragen();
  }
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!verfuegbar || laeuft) return;
    var ta = form.querySelector('textarea');
    var frage = (ta.value || '').trim();
    if (!frage) return;
    var csrf = form.querySelector('input[name="_csrf"]');
    ta.value = ''; eingabeHoehe();
    var s = { anfrageId: 'km' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10), frage: frage, kapitel: kapitel, ts: Date.now() };
    schwebend(s);
    var lauf = wartenBeginnen(s, true);
    var wahlWert = wahlBox && !wahlBox.hidden ? wahl.wert : '';
    var ziel = new URL(aktion, window.location.origin);
    var aktuell = new URLSearchParams(window.location.search);
    ['monate', 'kitage'].forEach(function (name) {
      if (aktuell.has(name)) ziel.searchParams.set(name, aktuell.get(name));
    });
    var bisher = verlauf.slice(-8).map(function (w) { return { rolle: w.rolle, text: w.text }; });
    fetch(ziel.toString(), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'x-csrf-token': csrf ? csrf.value : '' },
      body: JSON.stringify(wahlWert ? { kapitel: kapitel, frage: frage, verlauf: bisher, wahl: wahlWert, anfrageId: s.anfrageId }
        : { kapitel: kapitel, frage: frage, verlauf: bisher, anfrageId: s.anfrageId })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (a) { antwortVerarbeiten(lauf, a); })
      /* Abgebrochen (Seitenwechsel) oder keine lesbare Antwort: der Server
         kann trotzdem rechnen — dort nachsehen statt aufzugeben. */
      .catch(function () { ergebnisAbholen(lauf); });
  });
  // Enter schickt ab, Umschalt+Enter macht eine neue Zeile.
  var ta0 = form && form.querySelector('textarea');
  if (ta0) ta0.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); }
  });

  /* EINGABE WAECHST MIT (26.10.2026). Einzeilig zu Beginn, mit dem Text bis
     zur Hoechsthoehe aus dem Stylesheet (drei Zeilen, .km-eingabe), danach
     rollt sie (km-eingabe--rollt). Die Hoehe kommt per CSSOM, nicht als
     style-Attribut im Markup. Die Spracheingabe meldet ihren Text als
     input-Ereignis (kommunikator-stimme.js feldSetzen). */
  function eingabeHoehe() {
    var ta = form && form.querySelector('textarea');
    if (!ta || !ta.getClientRects().length) return;
    ta.style.height = 'auto';
    var cs = window.getComputedStyle(ta);
    var zahl = function (v) { var n = parseFloat(v); return isFinite(n) ? n : 0; };
    var soll = cs.boxSizing === 'border-box'
      ? ta.scrollHeight + zahl(cs.borderTopWidth) + zahl(cs.borderBottomWidth)
      : ta.scrollHeight - zahl(cs.paddingTop) - zahl(cs.paddingBottom);
    var hoechst = zahl(cs.maxHeight);
    var rollt = hoechst > 0 && soll > hoechst + 0.5;
    ta.style.height = Math.ceil(rollt ? hoechst : soll) + 'px';
    ta.classList.toggle('km-eingabe--rollt', rollt);
  }
  if (ta0) ta0.addEventListener('input', eingabeHoehe);
  document.addEventListener('km:dialoggroesse', function () { requestAnimationFrame(eingabeHoehe); });

  /* ⓘ RECHTS OBEN (26.10.2026): Anbieter, Modell, Stufe, Token und fuer den
     Superadmin der Zugang stehen nicht mehr unter der Eingabe, sondern in
     einer Aufklappflaeche hinter dem ⓘ. Klick daneben oder Esc schliesst sie;
     Esc schliesst erst die Flaeche, dann das Gespraech. */
  var infoKnopf = wurzel.querySelector('[data-km-info-auf]');
  var infoBox = wurzel.querySelector('[data-km-info]');
  function infoZu() {
    if (!infoBox || infoBox.hidden) return;
    infoBox.hidden = true;
    if (infoKnopf) infoKnopf.setAttribute('aria-expanded', 'false');
  }
  if (infoKnopf && infoBox) {
    infoKnopf.addEventListener('click', function () {
      if (!infoBox.hidden) { infoZu(); return; }
      kiLaden();
      kiZeigen(null);
      infoBox.hidden = false;
      infoKnopf.setAttribute('aria-expanded', 'true');
    });
    document.addEventListener('pointerdown', function (e) {
      if (infoBox.hidden || infoBox.contains(e.target) || infoKnopf.contains(e.target)) return;
      infoZu();
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || infoBox.hidden) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      infoZu();
      infoKnopf.focus({ preventScroll: true });
    }, true);
  }

  /* Offen beim Laden: das Fenster war beim Verlassen der letzten Seite offen
     (FENSTER_SCHL). Kein Einflug, kein Gruss — siehe oeffnen(still). Eine
     uebergebene Frage (#kommunikator=) hat oben schon geoeffnet. */
  if (panel && panel.hidden && fensterStand().offen === true) oeffnen(true);

  /* Schwebt beim Laden eine Frage (Seitenwechsel waehrend der Antwort):
     Frage und Wartezeile zeigen und das Ergebnis am Server abholen. */
  (function schwebendeFrageAufnehmen() {
    var s = schwebend();
    if (!s) return;
    if (!verfuegbar || !aktion || !form) { schwebend(null); return; }
    var lauf = wartenBeginnen(s, false);
    if (Date.now() - (+s.ts || 0) > SCHWEBE_MS) antwortVerarbeiten(lauf, null);
    else ergebnisAbholen(lauf);
  })();
})();

/* ---------------------------------------- 20) Seiten-Analyse (Cockpit) ----
 * Kapitel 01 „Dashboard", Karte „Seiten-Analyse" (Audi-Reporting-Umbau
 * 06.09.2026, app/views/cockpit.js seitenAnalyseKarte()): Reiter (Sortier-
 * schluessel), zwei Filter-Schalter und Auf-/Absteigend, „Mehr laden" — alles
 * clientseitig ueber data-Attribute an den Karten, kein eigener Server-
 * Endpunkt (dasselbe Muster wie der Keyword-Drawer, Baustein 15).
 *
 * OHNE JAVASCRIPT STEHEN ALLE KARTEN SORTIERT NACH KLICKS (progressive
 * enhancement): der Server rendert genau diese Reihenfolge bereits, nur die
 * ersten `data-ck-schritt` ohne `hidden`. Dieser Baustein uebernimmt danach
 * Sortierung, Filter und Kappung vollstaendig im Browser — die Karten werden
 * NEU ANGEORDNET (nicht nur ausgeblendet), damit „Mehr laden" immer die
 * naechsten, nach der aktuellen Wahl richtigen Karten zeigt.
 *
 * UNBEKANNTE WERTE IMMER ANS ENDE, unabhaengig von der Richtung: eine Karte
 * ohne Ø-Position (kein Treffer in den Top-Suchergebnissen) ist weder die
 * „hoechste" noch die „niedrigste" Position — sie hat schlicht keine.
 */
(function () {
  var gitter = document.querySelector('[data-ck-seiten]');
  if (!gitter) return;
  var karte = gitter.closest('.sr-karte');
  var reiter = karte ? karte.querySelector('[data-ck-reiter]') : null;
  var mehrKnopf = karte ? karte.querySelector('[data-ck-mehr]') : null;
  var schritt = parseInt(gitter.getAttribute('data-ck-schritt'), 10) || 6;

  var zustand = { sortiert: 'klicks', absteigend: true, nurKlicks: false, nurKi: false, sichtbar: schritt };

  function wertVon(el, schluessel) {
    var roh = el.getAttribute('data-' + schluessel);
    if (roh === '' || roh === null) return null;
    var n = parseFloat(roh);
    return isNaN(n) ? null : n;
  }

  function passtFilter(el) {
    if (zustand.nurKlicks && (wertVon(el, 'klicks') || 0) <= 0) return false;
    if (zustand.nurKi && (wertVon(el, 'zitate') || 0) <= 0) return false;
    return true;
  }

  function anwenden() {
    var alle = [].slice.call(gitter.querySelectorAll('.ck-seite'));
    alle.sort(function (a, b) {
      var va = wertVon(a, zustand.sortiert);
      var vb = wertVon(b, zustand.sortiert);
      if (va === null && vb === null) return 0;
      if (va === null) return 1;   // unbekannt immer ans Ende
      if (vb === null) return -1;
      // „Absteigend" heisst ueberall „das Beste zuerst": bei der Position ist
      // das die KLEINSTE Zahl (Platz 1 vor Platz 30) — die Richtung dreht
      // sich fuer diesen einen Schluessel, damit der Schalter fuer den Leser
      // in jedem Reiter dasselbe bedeutet.
      var bestesZuerst = zustand.sortiert === 'position' ? !zustand.absteigend : zustand.absteigend;
      return bestesZuerst ? (vb - va) : (va - vb);
    });
    // Neu anordnen: appendChild auf ein bereits im DOM stehendes Element
    // VERSCHIEBT es (kein Klon, keine verlorenen Listener/Bilder).
    alle.forEach(function (el) { gitter.appendChild(el); });

    var passend = alle.filter(passtFilter);
    var gezeigt = 0;
    alle.forEach(function (el) {
      var zeigen = passtFilter(el) && gezeigt < zustand.sichtbar;
      el.hidden = !zeigen;
      if (zeigen) gezeigt++;
    });

    if (mehrKnopf) {
      var rest = passend.length - gezeigt;
      if (rest <= 0) {
        mehrKnopf.hidden = true;
      } else {
        mehrKnopf.hidden = false;
        var naechste = Math.min(schritt, rest);
        mehrKnopf.textContent = 'Weitere ' + naechste + ' anzeigen (' + gezeigt + ' von ' + passend.length + ')';
      }
    }
  }

  if (reiter) {
    reiter.addEventListener('click', function (e) {
      var knopf = e.target.closest ? e.target.closest('[data-ck-sort]') : null;
      if (!knopf) return;
      [].slice.call(reiter.querySelectorAll('[data-ck-sort]')).forEach(function (b) {
        b.setAttribute('aria-selected', b === knopf ? 'true' : 'false');
      });
      zustand.sortiert = knopf.getAttribute('data-ck-sort');
      zustand.sichtbar = schritt;
      anwenden();
    });
  }

  if (karte) {
    var richtungKnopf = karte.querySelector('[data-ck-richtung]');
    if (richtungKnopf) {
      richtungKnopf.addEventListener('click', function () {
        zustand.absteigend = !zustand.absteigend;
        richtungKnopf.setAttribute('aria-pressed', zustand.absteigend ? 'false' : 'true');
        richtungKnopf.textContent = zustand.absteigend ? 'Absteigend' : 'Aufsteigend';
        zustand.sichtbar = schritt;
        anwenden();
      });
    }
    [].slice.call(karte.querySelectorAll('[data-ck-filter]')).forEach(function (schalter) {
      schalter.addEventListener('click', function () {
        var an = schalter.getAttribute('aria-pressed') !== 'true';
        schalter.setAttribute('aria-pressed', an ? 'true' : 'false');
        var art = schalter.getAttribute('data-ck-filter');
        if (art === 'klicks') zustand.nurKlicks = an;
        if (art === 'ki') zustand.nurKi = an;
        zustand.sichtbar = schritt;
        anwenden();
      });
    });
  }

  if (mehrKnopf) {
    mehrKnopf.addEventListener('click', function () {
      zustand.sichtbar += schritt;
      anwenden();
    });
  }

  // Startzustand: der Server hat bereits „nach Klicks, erste `schritt`
  // sichtbar" gerendert — anwenden() stellt hier nur den Mehr-Knopf-Text
  // richtig, ohne die Karten zu verschieben (spart einen Layout-Sprung beim
  // ersten Sichtbarwerden).
  if (mehrKnopf) {
    var gesamt = parseInt(gitter.getAttribute('data-ck-gesamt'), 10) || gitter.querySelectorAll('.ck-seite').length;
    var rest0 = gesamt - schritt;
    if (rest0 > 0) mehrKnopf.textContent = 'Weitere ' + Math.min(schritt, rest0) + ' anzeigen (' + schritt + ' von ' + gesamt + ')';
  }
})();

/* ------------------------------------------------------- 21) Kopier-Knopf --
 * Erster Aufrufer: Seite „KI & MCP" (app/views/ki-mcp.js) — Server-URL und
 * der einmalig gezeigte Klartext-Token. Generischer Baustein wie ueberall
 * sonst hier (data-Attribut statt Seiten-Code): ein Knopf mit
 * `data-kopieren="<id>"` kopiert den Text des Elements mit dieser `id`
 * (meist ein `<code>`). Zwei Wege, weil die Clipboard-API nur unter HTTPS/
 * localhost UND nur nach einer Nutzeraktion erlaubt ist (hier gegeben, Klick)
 * — `execCommand`-Rueckfall fuer sehr alte Browser ohne `navigator.clipboard`.
 */
(function () {
  [].slice.call(document.querySelectorAll('[data-kopieren]')).forEach(function (knopf) {
    var zielId = knopf.getAttribute('data-kopieren');
    var ziel = zielId && document.getElementById(zielId);
    if (!ziel) return;
    var text0 = knopf.textContent;
    knopf.addEventListener('click', function () {
      var text = ziel.textContent || '';
      var fertig = function () {
        knopf.textContent = 'Kopiert';
        setTimeout(function () { knopf.textContent = text0; }, 1500);
      };
      if (window.navigator && window.navigator.clipboard && window.navigator.clipboard.writeText) {
        window.navigator.clipboard.writeText(text).then(fertig, function () {});
      } else {
        var bereich = document.createElement('textarea');
        bereich.value = text;
        bereich.style.position = 'fixed';
        bereich.style.opacity = '0';
        document.body.appendChild(bereich);
        bereich.select();
        try { document.execCommand('copy'); fertig(); } catch (e) {}
        document.body.removeChild(bereich);
      }
    });
  });
})();


/* ------------------------------------------------------- 22) Flussbild
 * Verwaltung → Abläufe: Quelle → Lauf → Speicher → Kapitel als ein SVG
 * (app/lib/flussbild.js). Beim Überfahren, Antippen oder Fokussieren eines
 * Knotens leuchtet der GANZE Weg auf, an dem er hängt, und alles andere tritt
 * zurück. Ohne JavaScript ist das Bild vollständig lesbar — es bleibt dann
 * einfach durchgehend hell, so wie es der Server geschickt hat.
 *
 * ZWEI ARTEN, EINEN WEG ZU WÄHLEN, und sie widersprechen sich nicht: die Maus
 * hebt hervor, solange sie darauf steht; Klick, Enter oder Leertaste HALTEN
 * die Wahl fest, bis sie erneut gewählt oder Escape gedrückt wird. Ohne das
 * Festhalten wäre das Bild auf einem Tablet und mit der Tastatur unbedienbar
 * (das Vorbild in Cortex hängt allein am Maus-Hover).
 */
(function () {
  /* ZWEI BILDER, EIN ZUSTAND. Zeitband und Flussbild sind zwei SVGs, aber
     dieselbe Aussage aus zwei Blickwinkeln: oben WANN ein Lauf lief, unten
     WOHIN seine Daten gehen. Ein Klick auf den Balken „05:00 Search-Console-
     Sync" muss deshalb den Weg im Bild darunter mitleuchten lassen.

     Die Klammer ist `[data-fl-gruppe]` um beide Karten (app/views/ablaeufe.js).
     Fehlt sie, bleibt jedes SVG seine eigene Gruppe — das ist der Fall auf
     jeder anderen Seite und genau richtig so. */
  var gruppen = [].slice.call(document.querySelectorAll('[data-fl-gruppe]'))
    .filter(function (g) { return g.querySelector('svg.fl-svg'); });
  [].slice.call(document.querySelectorAll('svg.fl-svg')).forEach(function (svg) {
    if (!svg.closest('[data-fl-gruppe]')) gruppen.push(svg);
  });
  if (!gruppen.length) return;

  gruppen.forEach(function (wurzel) {
    var svgs = wurzel.matches && wurzel.matches('svg.fl-svg')
      ? [wurzel]
      : [].slice.call(wurzel.querySelectorAll('svg.fl-svg'));
    var kanten = [].slice.call(wurzel.querySelectorAll('.fl-kante'));
    /* Die Balken des Zeitbands sind Knoten wie die Kaesten des Flussbilds:
       sie tragen dieselbe `data-fl-id` und werden darum vom selben Code
       hervorgehoben. */
    var knoten = [].slice.call(wurzel.querySelectorAll('.fl-knoten, .zb-balken'));
    var fest = null;

    function dimmen(an) {
      svgs.forEach(function (s) { s.classList.toggle('fl-dunkel', an); });
    }

    function zeigen(id) {
      if (!id) {
        dimmen(false);
        kanten.concat(knoten).forEach(function (el) { el.classList.remove('fl-hell'); });
        return;
      }
      var beteiligt = Object.create(null);
      beteiligt[id] = true;
      kanten.forEach(function (k) {
        var liste = (k.getAttribute('data-fl-knoten') || '').split(' ');
        var trifft = liste.indexOf(id) >= 0;
        k.classList.toggle('fl-hell', trifft);
        // Der ganze Weg, nicht nur die eine Kante: gehört die Kante dazu,
        // gehören auch ihre beiden Enden dazu.
        if (trifft) liste.forEach(function (n) { beteiligt[n] = true; });
      });
      knoten.forEach(function (n) {
        n.classList.toggle('fl-hell', !!beteiligt[n.getAttribute('data-fl-id')]);
      });
      dimmen(true);
    }

    knoten.forEach(function (n) {
      var id = n.getAttribute('data-fl-id');
      n.addEventListener('mouseenter', function () { if (!fest) zeigen(id); });
      n.addEventListener('mouseleave', function () { if (!fest) zeigen(null); });
      n.addEventListener('focus', function () { if (!fest) zeigen(id); });
      n.addEventListener('blur', function () { if (!fest) zeigen(null); });
      n.addEventListener('click', function () {
        fest = (fest === id) ? null : id;
        zeigen(fest);
      });
      n.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        fest = (fest === id) ? null : id;
        zeigen(fest);
      });
    });

    /* Ein Klick auf die freie Fläche des Bildes gibt einen festgehaltenen Weg
       wieder frei. Ohne das bliebe er hängen, bis jemand denselben Knoten
       genau trifft — auf einem Tablet die häufigste Sackgasse: man tippt
       daneben und wundert sich, dass alles gedimmt bleibt. Der Knoten-Handler
       oben läuft zuerst und hat dann schon umgeschaltet; deshalb wird hier
       nur reagiert, wenn der Klick KEINEN Knoten getroffen hat. */
    svgs.forEach(function (svg) {
      svg.addEventListener('click', function (e) {
        if (!fest) return;
        if (e.target.closest && e.target.closest('.fl-knoten, .zb-balken')) return;
        fest = null;
        zeigen(null);
      });

      svg.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !fest) return;
        fest = null;
        zeigen(null);
      });
    });
  });
})();


/* ------------------------------------------ 23) Auftritt der Oberfläche ----
 * Betreiber-Auftrag 12.09.2026. Die Seite baut sich auf, statt einfach
 * dazustehen: die Kacheln treten von links oben nach rechts unten ein, jede
 * mit einer anderen Dauer, ein Lichtstreifen läuft einmal über sie, der Rand
 * glüht kurz in der Akzentfarbe, Δ-Pillen und Badges ploppen nach, die
 * BETA-Chips blinken zweimal und Kennzahlen zählen hoch. Wer den Zeitraum
 * wechselt, sieht die Seite in umgekehrter Richtung abgehen, bevor die
 * nächste kommt.
 *
 * DIE BEWEGUNG STEHT IM STYLESHEET, nicht hier (app.css, Block „Auftritt der
 * Oberfläche"). Dieser Baustein tut genau drei Dinge:
 *   1. er verteilt die 24 Stufen nach der Position der Kachel,
 *   2. er zählt die Zahlen hoch,
 *   3. er räumt hinterher alles wieder weg.
 *
 * WARUM DER ANFANGSZUSTAND NICHT VON HIER KOMMT. Das Bündel hängt als
 * `defer` im Kopf — es läuft nach dem Parsen, aber nicht garantiert vor dem
 * ersten Bild. Setzte dieser Code die Kacheln auf unsichtbar, könnte die
 * Seite für einen Wimpernschlag fertig dastehen und danach zurückspringen.
 * Deshalb steht der Grundzustand im Stylesheet und gilt ab dem Parsen; hier
 * werden nur Verzögerung und Dauer nachgeschärft. Das ist auch der Grund,
 * warum die Stufe ausschliesslich über eine KLASSE gesetzt wird und nie über
 * element.style: die Inhaltssicherheitsregel (style-src 'nonce') verwürfe ein
 * style-Attribut stumm, und der Auftritt liefe überall in der Vorgabestufe.
 *
 * KAM DAS SKRIPT ZU SPÄT, wird gar nicht mehr eingegriffen (SPAETESTENS).
 * Eine Verzögerung nachträglich zu vergrössern würde eine schon gelaufene
 * Animation zurückdrehen — sichtbar als Zurückspringen. Dann bleibt es bei
 * der Vorgabestufe, die ohnehin sauber endet.
 */
(function () {
  /* Was auftritt: alles, was einen eigenen Rahmen hat. Dieselbe Liste steht
     im Stylesheet — wer hier etwas ergänzt, ergänzt sie dort mit, sonst
     bekommt das Element eine Stufe, aber keine Bewegung. */
  var ZIELE = '.sr-karte,.sr-kpi,.sr-thema,.card,.anb-karte,.limit-kachel,.projekt-karte,'
    + '.ck-w,.ck-karte,.ck-mosaik-kpi,.ck-seite';
  /* Zahlen, die hochzählen. Absichtlich kurz: es sind die grossen Werte der
     Übersicht, nicht jede Ziffer der Seite. */
  var ZAHLEN = '.ck-w-wert,.ck-donut-wert,.ck-mosaik-wert';
  var STUFEN = 24;
  /* WANN DIE KLASSEN FALLEN DÜRFEN, rechnet der Server (app/lib/
     darstellung.js auftrittMasse): letzte Stufe plus die längste Kacheldauer
     beziehungsweise plus den Deckel des Zeilenaufbaus, je nachdem, was länger
     läuft — plus eine Bildreserve. Eine feste Zahl ginge mit jeder anderen
     Geschwindigkeit daneben: zu klein schneidet sie die letzte Kachel ab, zu
     gross lässt sie Transform und Lichtstreifen länger stehen als nötig. */
  /* OB ES ZU SPAET IST, WIRD GESEHEN, NICHT GESCHAETZT. Der Grundzustand im
   * Stylesheet hält die Kacheln unsichtbar und blendet sie danach ohne
   * Staffelung ein — für den Fall, dass nie ein Skript läuft. Trifft dieser
   * Baustein erst ein, wenn diese Blende schon begonnen hat, darf er die
   * Kurve nicht mehr neu starten: die Seite zeigte sich sonst, verschwände
   * wieder und käme ein zweites Mal.
   * Eine feste Frist hat dafür nicht getaugt (480 ms, 12.09.2026): auf einem
   * kalten Aufruf traf das Bündel regelmäßig später ein, und die Choreografie
   * fiel ohne Not aus. Gefragt wird deshalb die Kachel selbst. */
  var SCHON_SICHTBAR = 0.02;
  var ZAEHL_MS = 500;
  var ABGANG_MS = 350;

  var wurzel = document.documentElement;

  /* ══ DIE EINSTELLUNG DES MANDANTEN ════════════════════════════════════════
   * Betreiber-Auftrag 12.09.2026, Verwaltung → Darstellung → Auftritt. Alle
   * Zahlen stehen als JSON am <html> (data-auftritt, gesetzt in
   * app/views/layout.js, gerechnet in app/lib/darstellung.js auftrittMasse) —
   * dieselbe Quelle, aus der auch die Custom Properties des Stylesheets
   * kommen. Zwei Rechnungen für dieselbe Choreografie liefen früher oder
   * später auseinander: die Kachel flöge nach der einen, das Chart wartete
   * nach der anderen.
   *
   * FEHLT DAS ATTRIBUT, gelten die Werte, die bis zum 12.09.2026 fest im
   * Stylesheet standen. Das ist kein Notbehelf, sondern der Normalfall für
   * Seiten ohne Mandanten (Anmeldung, Fehlerseite) — und dort soll sich
   * nichts anders verhalten als vorher.
   */
  var VORGABE = {
    art: 'einschweben', richtung: 'lo-ru',
    stufen: 24, vor: 40, takt: 38, basis: 420, schritt: 20,
    kachelEnde: 1576, ende: 1814,
    chart: 600, zeileTakt: 18, zeileDauer: 220, zeileStufen: 32, zeileDeckel: 600
  };
  function einstellungLesen() {
    var roh = {};
    try { roh = JSON.parse(wurzel.getAttribute('data-auftritt') || '{}') || {}; }
    catch (e) { roh = {}; }
    var a = {};
    for (var k in VORGABE) {
      if (!Object.prototype.hasOwnProperty.call(VORGABE, k)) continue;
      /* Feld für Feld geprüft, nicht als Paket übernommen: ein halb
         gefülltes Attribut (alte Seite im Cache, abgeschnittenes HTML) darf
         die Choreografie nicht auf undefined-Millisekunden stellen. */
      a[k] = typeof roh[k] === typeof VORGABE[k] && roh[k] !== null ? roh[k] : VORGABE[k];
    }
    return a;
  }
  var EINST = einstellungLesen();

  /**
   * DIESELBE RECHNUNG WIE AUF DEM SERVER (app/lib/darstellung.js
   * auftrittMasse). Sie steht hier ein zweites Mal, weil die Vorschau in
   * Verwaltung → Darstellung Werte zeigen muss, die noch NICHT gespeichert
   * sind — der Server kennt sie in dem Moment nicht.
   *
   * DASS BEIDE DASSELBE RECHNEN, WIRD GEMESSEN und nicht geglaubt:
   * scripts/proben/auftritt-animation.js hält das Ergebnis dieser Funktion
   * gegen das data-auftritt, das der Server für dieselben Regler geschickt
   * hat. Weichen sie ab, ist die Sonde rot.
   */
  function masse(w) {
    var art = String((w && w.art) || 'einschweben');
    var richtung = String((w && w.richtung) || 'lo-ru');
    var intensitaet = Math.min(100, Math.max(0, Math.round(Number((w && w.intensitaet)) || 0)));
    var tempo = Math.min(100, Math.max(0, Math.round(Number((w && w.tempo)) || 0)));
    var kraft = intensitaet / 50;
    var faktor = 1.6 - tempo * 0.012;
    var rund = function (n, s) { return Number(n.toFixed(s)); };
    var zeileTakt = Math.min(25, Math.max(12, Math.round(18 * faktor)));
    var vor = Math.round(40 * faktor);
    var takt = Math.round(38 * faktor);
    var basis = Math.round(420 * faktor);
    var schritt = Math.round(20 * faktor);
    /* Das Maximum ueber alle Stufen, nicht die letzte Stufe — Begruendung in
       app/lib/darstellung.js (laengsteKachel). */
    var laengste = 0;
    for (var st = 0; st < 24; st += 1) {
      var t = st * takt + basis + ((st * 7) % 12) * schritt;
      if (t > laengste) laengste = t;
    }
    return {
      art: art, richtung: richtung, intensitaet: intensitaet, tempo: tempo,
      stufen: 24, vor: vor, takt: takt, basis: basis, schritt: schritt,
      kachelEnde: vor + laengste + 80,
      ende: Math.max(vor + laengste + 80,
        vor + 23 * takt + 600 + Math.max(90, Math.round(220 * faktor)) + 80),
      weg: rund(18 * kraft, 1), skala: rund(1 - 0.035 * kraft, 3), ueber: rund(1 + 0.008 * kraft, 3),
      schein: rund(Math.min(1, kraft), 2), glut: rund(Math.min(2, kraft), 2),
      chart: Math.max(120, Math.round(600 * faktor)),
      zeileTakt: zeileTakt, zeileDauer: Math.max(90, Math.round(220 * faktor)),
      zeileStufen: Math.min(32, Math.max(4, Math.floor(600 / zeileTakt))),
      zeileDeckel: 600
    };
  }

  function ruhig() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function stumm() { return wurzel.classList.contains('sr-auftritt-stumm'); }

  /* ---------------------------------------------------------- Einsammeln */

  /**
   * Die Kacheln der Seite, ohne Kacheln IN Kacheln: was in einer Karte liegt,
   * tritt mit ihr auf und nicht gegen sie (so steht es auch im Stylesheet).
   * Unsichtbares fällt weg — ein Element ohne Rechtecke hat kein Bild, das
   * sich bewegen könnte (display:none, [hidden], eingeklappter Bereich).
   */
  function sammeln() {
    return [].slice.call(document.querySelectorAll(ZIELE)).filter(function (el) {
      if (!el.getClientRects().length) return false;
      var eltern = el.parentElement;
      return !(eltern && eltern.closest && eltern.closest(ZIELE));
    });
  }

  /**
   * Wo eine Kachel in der Reihenfolge steht — die RICHTUNG entscheidet.
   *
   * WARUM DER WAAGERECHTE ANTEIL GEDÄMPFT IST (0,6 und nicht 1). Eine Seite
   * ist breiter als hoch; mit gleichem Gewicht liefe die Welle fast senkrecht
   * von oben nach unten. Der gedämpfte Anteil macht daraus die Diagonale, die
   * man sehen soll.
   */
  function ordnungswert(k, mitte) {
    if (EINST.richtung === 'ro-lu') return k.top - 0.6 * k.left;
    if (EINST.richtung === 'unten-oben') return -(k.top + 0.6 * k.left);
    if (EINST.richtung === 'mitte') {
      var dx = k.left + k.width / 2 - mitte.x;
      var dy = k.top + k.height / 2 - mitte.y;
      return Math.sqrt(dx * dx + dy * dy);
    }
    return k.top + 0.6 * k.left;
  }

  /* DIE WÜRFEL FALLEN EINMAL JE KACHEL, nicht einmal je Aufruf. raenge()
     läuft beim Auftritt UND beim Abgang; würfelte es beide Male neu, ginge
     die Seite in einer anderen Reihenfolge ab, als sie gekommen ist. */
  var zufallStufe = new WeakMap();

  /**
   * Rang nach Position, umgerechnet auf die Stufen der Choreografie.
   *
   * WAS BEIM LADEN UNTER DER FALTE LIEGT, bekommt die letzte Stufe und
   * niemanden, der auf es wartet: es hat ohnehin kein Publikum, und die
   * sichtbaren Kacheln behalten so die feine Staffelung für sich.
   */
  function raenge(liste) {
    var unten = window.innerHeight || 0;
    var mitte = { x: (window.innerWidth || 0) / 2, y: unten / 2 };
    var sichtbar = [];
    var spaet = [];
    liste.forEach(function (el) {
      var k = el.getBoundingClientRect();
      var eintrag = { el: el, wert: ordnungswert(k, mitte) };
      if (k.top >= unten) spaet.push(eintrag); else sichtbar.push(eintrag);
    });
    sichtbar.sort(function (a, b) { return a.wert - b.wert; });
    var letzte = EINST.stufen - 1;
    var teiler = Math.max(1, sichtbar.length - 1);
    sichtbar.forEach(function (e, i) {
      if (EINST.richtung === 'zufall') {
        var g = zufallStufe.get(e.el);
        if (g === undefined) { g = Math.floor(Math.random() * letzte); zufallStufe.set(e.el, g); }
        e.stufe = g;
        return;
      }
      // Die sichtbaren Kacheln teilen sich die Stufen 0…22; die letzte bleibt
      // dem reserviert, was beim Laden unter der Falte steht.
      e.stufe = sichtbar.length === 1 ? 0 : Math.round(i * (letzte - 1) / teiler);
    });
    spaet.forEach(function (e) { e.stufe = letzte; });
    return sichtbar.concat(spaet);
  }

  /* --------------------------------------------------------- Hochzählen */

  /**
   * Nur eine reine Zahl in deutscher Schreibweise zählt hoch: Tausenderpunkt,
   * optional eine Komma-Nachkommastelle, optional ein Prozentzeichen. Alles
   * andere — „–", „Pos. 4,2", ein Datum, eine Spanne — bleibt unangetastet.
   * Die Gruppierung wird NUR nachgebildet, wenn sie im Ausgangstext stand:
   * aus „1234" darf beim Zählen kein „1.234" werden.
   */
  function zerlegen(text) {
    var t = String(text).trim();
    var m = /^(\d{1,3}(?:\.\d{3})+|\d+)(?:,(\d+))?(\s?%)?$/.exec(t);
    if (!m) return null;
    var ganz = m[1];
    var wert = parseFloat(ganz.replace(/\./g, '') + (m[2] ? '.' + m[2] : ''));
    if (!isFinite(wert) || wert <= 0) return null;
    return {
      wert: wert,
      nachkomma: m[2] ? m[2].length : 0,
      gruppiert: ganz.indexOf('.') !== -1,
      suffix: m[3] || ''
    };
  }

  function schreiben(el, form, wert) {
    var fest = wert.toFixed(form.nachkomma);
    var teile = fest.split('.');
    var ganz = form.gruppiert ? teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') : teile[0];
    el.textContent = ganz + (form.nachkomma ? ',' + teile[1] : '') + form.suffix;
  }

  /**
   * Von 0 auf den Wert, und am Ende steht wieder GENAU der Text des Servers.
   * Das ist kein Schönheitsdetail: Abnahmebilder, Vorlesehilfen und Sonden
   * lesen diesen Knoten, und eine nachgebaute Zahl weicht in der Schreibweise
   * früher oder später ab.
   */
  function hochzaehlen(el, verzoegerung) {
    var urtext = el.textContent;
    var form = zerlegen(urtext);
    if (!form) return;
    window.setTimeout(function () {
      var start = 0;
      function schritt(jetzt) {
        if (!start) start = jetzt;
        var t = Math.min(1, (jetzt - start) / ZAEHL_MS);
        var weich = 1 - Math.pow(1 - t, 3);
        if (t >= 1) { el.textContent = urtext; return; }
        schreiben(el, form, form.wert * weich);
        window.requestAnimationFrame(schritt);
      }
      window.requestAnimationFrame(schritt);
    }, verzoegerung);
  }

  /* ------------------------------------------------------------ Auftritt */

  /** Genau EINE Stufenklasse je Element — zwei brächten zwei Verzögerungen,
   *  und welche gewinnt, entschiede die Reihenfolge im Stylesheet statt der
   *  Absicht hier. (Der Fall tritt auf, wenn jemand den Zeitraum wechselt,
   *  während der Auftritt noch läuft.) */
  function stufeSetzen(el, stufe) {
    for (var i = 0; i < STUFEN; i += 1) el.classList.remove('sr-auftritt-r' + i);
    el.classList.add('sr-auftritt-r' + stufe);
  }

  function auftreten(erzwingen) {
    var liste = sammeln();
    if (!liste.length) return;
    /* Zeigt sich schon etwas? Dann ist die Blende des Grundzustands gelaufen
       und es bleibt dabei (siehe SCHON_SICHTBAR). Gefragt werden mehrere
       Kacheln: eine einzelne könnte in einem zugeklappten Aufklapper liegen
       und dauerhaft auf null stehen, ohne dass das etwas über die Seite sagt. */
    var deckung = 0;
    for (var p = 0; p < liste.length && p < 5; p += 1) {
      var d = parseFloat(window.getComputedStyle(liste[p]).opacity);
      if (isFinite(d) && d > deckung) deckung = d;
    }
    /* Beim Vorführen wird diese Frage übersprungen: dort steht die Seite
       absichtlich schon da, und genau sie soll noch einmal auftreten. */
    if (!erzwingen && deckung > SCHON_SICHTBAR) return;
    var geordnet = raenge(liste);
    /* Erst lesen, dann schreiben: die Lage aller Kacheln steht oben schon
       fest, die Positionsart kommt hier in einem Rutsch dazu. Wer beides
       abwechselt, zwingt den Browser zu einem Umbruch je Kachel. */
    var relativ = geordnet.map(function (e) {
      return window.getComputedStyle(e.el).position === 'static';
    });

    /* DER STARTZEITPUNKT GEHÖRT AN DIE WURZEL. Diagramme laden ihr Bündel
       nach und treffen erst mitten im Kachelflug ein. Ohne diese Marke wüsste
       ein Chart nur, wie lange der Flug DAUERT, nicht wie viel davon schon
       vorbei ist — es wartete die volle Strecke ein zweites Mal ab und die
       Karte stünde eine halbe Sekunde leer da (12.09.2026: Reihen setzten
       1,35 s nach dem Seitenanfang ein statt 0,69 s).
       Ein Datenattribut, kein style-Attribut: die CSP verwirft Stil-Attribute
       stumm. */
    wurzel.setAttribute('data-sr-auf-start', String(Math.round(performance.now())));
    wurzel.classList.add('sr-auftritt-lauf');
    geordnet.forEach(function (e, i) {
      // Der Lichtstreifen sitzt im ::after und braucht einen Bezugspunkt.
      // Nur wo keiner da ist — eine klebende oder absolut gesetzte Kachel
      // verlöre sonst ihren Platz.
      if (relativ[i]) e.el.classList.add('sr-auftritt--rel');
      /* `sr-auftritt` tauscht den Animationsnamen und lässt die Kurve damit
         HIER beginnen — nicht beim Parsen. Ohne diesen Wechsel liefe die
         Kachel schon auf der Vorgabestufe und eine größere Verzögerung würde
         sie sichtbar zurückdrehen (Betreiber-Befund 12.09.2026). */
      e.el.classList.add('sr-auftritt');
      stufeSetzen(e.el, e.stufe);
      var verz = EINST.vor + e.stufe * EINST.takt;
      [].slice.call(e.el.querySelectorAll(ZAHLEN)).forEach(function (z) {
        hochzaehlen(z, verz);
      });
      /* DIE TABELLE IN DER KACHEL WARTET AUF IHRE KACHEL. Liefe ihr
         Zeilenaufbau sofort los, spielte er unter einer noch durchsichtigen
         Karte und wäre schlicht nicht zu sehen.
         WARUM ALS ZEITGEBER UND NICHT ALS SUMMAND IN CSS: eine Zeile, die
         --sr-auf-verz von ihrer Kachel erbt, verliert diesen Wert in dem
         Moment, in dem die Stufenklasse fällt — die Verzögerung spränge dann
         zurück und die restlichen Zeilen blitzten auf einen Schlag auf. */
      window.setTimeout(function () { zeilenAuftritt(e.el); }, verz);
    });

    window.setTimeout(function () {
      geordnet.forEach(function (e) {
        e.el.classList.remove('sr-auftritt', 'sr-auftritt--rel', 'sr-auftritt-r' + e.stufe);
      });
      wurzel.removeAttribute('data-sr-auf-start');
      wurzel.classList.remove('sr-auftritt-lauf');
      wurzel.classList.add('sr-auftritt-fertig');
    }, EINST.kachelEnde);
    /* ZWEITE MARKE FÜR DEN WIRKLICHEN SCHLUSS. `sr-auftritt-fertig` fällt,
       wenn die KACHELN stehen — die Tabellen in der letzten Kachel bauen ihre
       Zeilen danach noch auf. Wer messen will, ob sich hinterher noch etwas
       rührt, braucht den Moment, ab dem nichts mehr läuft; das ist dieser.
       (scripts/proben/auftritt-animation.js, Zucken-Riegel.)
       DER NAME DARF NICHT MIT „sr-auftritt-r" BEGINNEN: der Stufenselektor
       [class*="sr-auftritt-r"] in app/views/app.css fängt sonst das <html>
       mit und legt ihm dauerhaft --sr-auf-verz, --sr-auf-dauer und
       --sr-ab-verz auf. „-ruhe" war genau dieser Fehler (12.09.2026). */
    window.setTimeout(function () {
      wurzel.classList.add('sr-auftritt-ende');
    }, EINST.ende);
  }

  /* -------------------------------------------------------------- Abgang */

  /**
   * Umgekehrte Richtung: rechts unten geht zuerst. Die Stufenklasse trägt
   * dafür eine zweite Verzögerung (--sr-ab-verz), die im Stylesheet bereits
   * gespiegelt ist — hier wird also genauso gezählt wie beim Eintreffen.
   *
   * DAS NETZ IST FEST VERDRAHTET: nach spätestens 350 ms wird navigiert, auch
   * wenn keine einzige Animation gelaufen ist. Eine Übergangsbewegung, die
   * einen Klick verschluckt, ist schlimmer als gar keine.
   */
  function abgehen(weiter) {
    var erledigt = false;
    function los() {
      if (erledigt) return;
      erledigt = true;
      weiter();
    }
    try {
      raenge(sammeln()).forEach(function (e) {
        e.el.classList.remove('sr-auftritt', 'sr-auftritt--rel');
        stufeSetzen(e.el, e.stufe);
        e.el.classList.add('sr-abgang');
      });
    } catch (err) { los(); return; }
    window.setTimeout(los, ABGANG_MS);
  }

  function zeitraumBinden() {
    [].slice.call(document.querySelectorAll('.ck-zeitform')).forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (e.defaultPrevented || ruhig() || stumm()) return;
        e.preventDefault();
        // form.submit() löst kein zweites submit-Ereignis aus — keine Schleife.
        abgehen(function () { form.submit(); });
      });
    });

    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || ruhig() || stumm()) return;
      // Nie bei Strg/Cmd/Shift/Alt oder mittlerer Taste: der Nutzer will dann
      // einen neuen Tab, keine Choreografie auf der alten Seite.
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('.ck-leiste .sr-zeitraum-seg') : null;
      if (!a || a.tagName !== 'A') return;
      var ziel = a.getAttribute('href');
      if (!ziel) return;
      if (a.target && a.target !== '_self') return;
      e.preventDefault();
      abgehen(function () { window.location.assign(a.href); });
    });
  }


  /* ══ TABELLEN BAUEN SICH ZEILENWEISE AUF ══════════════════════════════════
   * Betreiber-Auftrag 12.09.2026: „wie eine schnelle Maschine". Die Zeilen
   * erscheinen nacheinander mit sehr kurzem Versatz; nach dem Deckel
   * (EINST.zeileDeckel, 600 ms) steht die ganze Tabelle, egal wie lang sie
   * ist — ab der letzten Stufe erscheint alles gemeinsam.
   *
   * NICHTS WIRD AUFGEHALTEN. Die Zeilen stehen vom ersten Bild an im
   * Dokument, tragen ihre Höhe und sind anklickbar; nachlaufend ist allein
   * die Deckkraft (app/views/app.css, Block „Tabellen bauen sich zeilenweise
   * auf"). Wer Zeilen stattdessen einzeln einhängt, baut eine Wartezeit.
   *
   * DIE STUFE KOMMT ALS KLASSE, nie als style-Attribut: die
   * Inhaltssicherheitsregel (style-src 'nonce') verwürfe es stumm — derselbe
   * Grund wie bei den Kacheln.
   *
   * DIE KLASSEN FALLEN WIEDER WEG, sobald die letzte Zeile steht. Eine Zeile
   * mit `animation: … both` bliebe sonst für immer an ihrer Endlage
   * festgehalten, und der nächste Aufbau (Seitenwechsel, Filter, Sortierung)
   * startete nicht neu.
   */
  var ZEILEN_STUFEN_MAX = 32;
  /* Was Zeilen enthält: die gewöhnlichen Tabellenrümpfe und — nach der
     Übernahme — der Zeilenbehälter von Tabulator (app/views/tabellen-
     tabulator.js). Beide liefern ihre Zeilen als direkte Kinder. */
  var ZEILEN_RUMPF = '.tbl-wrap table > tbody, .sr-tabelle-wrap table > tbody, .tabulator-table';

  function zeilenKlassenWeg(el) {
    el.classList.remove('sr-zeile-auf');
    for (var i = 0; i < ZEILEN_STUFEN_MAX; i += 1) el.classList.remove('sr-zeile-s' + i);
  }

  /** Einen Rumpf staffeln. Liefert die Zahl der bewegten Zeilen. */
  function zeilenStaffeln(rumpf) {
    /* WAS NICHT ZU SEHEN IST, TRITT NICHT AUF. Nach der Übernahme durch
       Tabulator bleibt die ursprüngliche Tabelle als versteckter Rückfall
       stehen (app/views/tabellen-tabulator.js setzt wrap.hidden). Ihre Zeilen
       zu staffeln kostet Arbeit für ein Bild, das niemand sieht — und die
       Klassen blieben in einem Baum liegen, der später wieder auftauchen
       kann. */
    if (!rumpf.getClientRects || !rumpf.getClientRects().length) return 0;
    var zeilen = [].slice.call(rumpf.children).filter(function (el) {
      return el.nodeType === 1
        && (el.tagName === 'TR' || el.classList.contains('tabulator-row'))
        && !el.hidden
        && !el.classList.contains('tbl-gefiltert');
    });
    // Unter zwei Zeilen gibt es keine Staffelung, nur ein Blinken.
    if (zeilen.length < 2) return 0;
    var stufen = Math.max(1, Math.min(EINST.zeileStufen, ZEILEN_STUFEN_MAX, zeilen.length));
    zeilen.forEach(function (tr, i) {
      zeilenKlassenWeg(tr);
      tr.classList.add('sr-zeile-auf', 'sr-zeile-s' + Math.min(stufen - 1, i));
    });
    /* Erst aufräumen, wenn auch die letzte Stufe durch ist: Deckel plus eine
       Zeilendauer plus eine Bildreserve. Die Frist zählt ab HIER, nicht ab dem
       Seitenanfang — der Aufruf kommt je Kachel zu ihrer eigenen Zeit. */
    window.setTimeout(function () {
      zeilen.forEach(zeilenKlassenWeg);
    }, EINST.zeileDeckel + EINST.zeileDauer + 80);
    return zeilen.length;
  }

  /**
   * Alle Tabellen unter `bereich` (oder der ganzen Seite) neu aufbauen.
   * `nurFrei` lässt die aus, die in einer auftretenden Kachel liegen — die
   * bekommen ihren eigenen Zeitgeber, sobald ihre Kachel fliegt.
   */
  function zeilenAuftritt(bereich, nurFrei) {
    if (ruhig() || stumm()) return 0;
    var wo = bereich && bereich.querySelectorAll ? bereich : document;
    var summe = 0;
    [].slice.call(wo.querySelectorAll(ZEILEN_RUMPF)).forEach(function (rumpf) {
      if (nurFrei && rumpf.closest && rumpf.closest('.sr-auftritt')) return;
      summe += zeilenStaffeln(rumpf);
    });
    return summe;
  }

  /** Den Rumpf zu einem beliebigen Element darin finden. */
  function rumpfVon(el) {
    if (!el || !el.closest) return null;
    return el.closest(ZEILEN_RUMPF) || (el.closest('.tbl-wrap, .sr-tabelle-wrap, .tabulator')
      ? el.closest('.tbl-wrap, .sr-tabelle-wrap, .tabulator').querySelector(ZEILEN_RUMPF) : null);
  }

  var zeilenTimer = null;
  /** Zusammenfassen, was in einem Rutsch kommt (Tastendruck für Tastendruck
   *  beim Filtern wäre ein Flackern, kein Aufbau). */
  function zeilenGleich(bereich, verzug) {
    if (zeilenTimer) window.clearTimeout(zeilenTimer);
    zeilenTimer = window.setTimeout(function () {
      zeilenTimer = null;
      zeilenAuftritt(bereich);
    }, verzug || 0);
  }

  function zeilenBinden() {
    /* Nachgeladene Seiten der langen Listen (app/views/tabellen-seiten.js). */
    document.addEventListener('sr-table-rows', function (e) {
      zeilenGleich(rumpfVon(e.target) || e.target, 0);
    });
    /* Nach der Übernahme durch Tabulator steht der Zeilenbehälter erst jetzt. */
    document.addEventListener('sr-tabulator-fertig', function () {
      zeilenGleich(document, 30);
    });
    /* Seitenwechsel und Sortierung in Tabulator: die Bibliothek baut ihre
       Zeilen neu, meldet das aber nicht über ein Ereignis, an das man von
       aussen kommt. Der Klick ist der verlässliche Auslöser. */
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest
        ? e.target.closest('.tabulator-page, .tabulator-col-sorter, .tabulator-col[role="columnheader"]') : null;
      if (!t) return;
      var behaelter = t.closest('.tabulator');
      zeilenGleich(behaelter || document, 40);
    });
    /* Filtern in der Werkzeugzeile — gedämpft, sonst liefe je Tastendruck
       ein Aufbau. */
    document.addEventListener('input', function (e) {
      var f = e.target;
      if (!f || !f.matches) return;
      if (!f.matches('.tbl-suche, [data-sr-tabfilter], .tabulator-header-filter input')) return;
      zeilenGleich(rumpfVon(f) || document, 180);
    });
  }

  /* ══ VORFÜHREN (Verwaltung → Darstellung → Auftritt) ══════════════════════
   * Betreiber-Auftrag 12.09.2026: „Vorschau live in der Seite selbst". Die
   * Darstellungsseite ist keine Attrappe — sie besteht aus denselben Karten,
   * Kacheln und Tabellen wie jede andere Seite. Der Knopf spielt die
   * Choreografie deshalb auf dem echten Inhalt ab und nicht auf einem
   * nachgebauten Kästchen: was man sieht, ist das Ergebnis.
   *
   * DIE WERTE KOMMEN AUS DEM FORMULAR, nicht aus der Datenbank. Vorgeführt
   * wird, was gerade eingestellt IST — auch ungespeichert. Deshalb rechnet
   * masse() oben dieselbe Umrechnung wie der Server.
   *
   * GESCHRIEBEN WIRD ÜBER DAS CSSOM (wurzel.style.setProperty), nicht über
   * ein style-Attribut im Markup: die Inhaltssicherheitsregel verwürfe das
   * Attribut stumm. Denselben Weg geht der Verlaufsregler daneben
   * (app/views/verwaltung-client.js).
   */
  function eigenschaftenSetzen(m) {
    var s = wurzel.style;
    s.setProperty('--sr-auf-vor', m.vor + 'ms');
    s.setProperty('--sr-auf-takt', m.takt + 'ms');
    s.setProperty('--sr-auf-basis', m.basis + 'ms');
    s.setProperty('--sr-auf-schritt', m.schritt + 'ms');
    s.setProperty('--sr-auf-weg', m.weg + 'px');
    s.setProperty('--sr-auf-skala', String(m.skala));
    s.setProperty('--sr-auf-ueber', String(m.ueber));
    s.setProperty('--sr-auf-schein', String(m.schein));
    s.setProperty('--sr-auf-glut', String(m.glut));
    s.setProperty('--sr-auf-zeile-takt', m.zeileTakt + 'ms');
    s.setProperty('--sr-auf-zeile-dauer', m.zeileDauer + 'ms');
    wurzel.setAttribute('data-auf-art', m.art);
  }

  /** Jede Spur der letzten Runde tilgen — sonst trägt eine Kachel zwei
   *  Stufenklassen und die Reihenfolge im Stylesheet entschiede statt der
   *  Absicht hier. */
  function abraeumen() {
    [].slice.call(document.querySelectorAll('.sr-auftritt,[class*="sr-auftritt-r"],.sr-abgang'))
      .forEach(function (el) {
        el.classList.remove('sr-auftritt', 'sr-auftritt--rel', 'sr-abgang');
        for (var i = 0; i < STUFEN; i += 1) el.classList.remove('sr-auftritt-r' + i);
      });
    [].slice.call(document.querySelectorAll('.sr-zeile-auf')).forEach(zeilenKlassenWeg);
    wurzel.classList.remove('sr-auftritt-lauf', 'sr-auftritt-fertig', 'sr-auftritt-ende');
    wurzel.removeAttribute('data-sr-auf-start');
  }

  function feldWert(name) {
    var alle = [].slice.call(document.querySelectorAll('[data-auf-feld="' + name + '"]'));
    for (var i = 0; i < alle.length; i += 1) {
      var el = alle[i];
      if (el.type === 'radio' || el.type === 'checkbox') { if (el.checked) return el.value; continue; }
      return el.value;
    }
    return null;
  }

  function formWerte() {
    return {
      art: feldWert('art') || EINST.art,
      richtung: feldWert('richtung') || EINST.richtung,
      intensitaet: feldWert('intensitaet'),
      tempo: feldWert('tempo')
    };
  }

  /** Werte übernehmen, ohne die Choreografie neu zu starten — beim Ziehen am
   *  Regler soll die Seite nicht bei jedem Pixel von vorn anfangen. */
  function werteUebernehmen(w) {
    EINST = masse(w);
    eigenschaftenSetzen(EINST);
    [].slice.call(document.querySelectorAll('[data-auf-wert]')).forEach(function (aus) {
      var name = aus.getAttribute('data-auf-wert');
      if (Object.prototype.hasOwnProperty.call(EINST, name)) aus.textContent = String(EINST[name]);
    });
  }

  function vorfuehren(w) {
    werteUebernehmen(w || formWerte());
    abraeumen();
    /* Zwei Bilder Pause: die Klassen müssen erst aus dem Rechenmodell des
       Browsers verschwunden sein, sonst läuft dieselbe Animation weiter,
       statt neu zu beginnen. */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        auftreten(true);
        zeilenAuftritt(document);
      });
    });
  }

  function vorschauBinden() {
    var knopf = document.querySelector('[data-auf-vorfuehren]');
    if (!knopf) return;
    knopf.addEventListener('click', function () { vorfuehren(formWerte()); });
    var horchen = function (e) {
      if (!e.target || !e.target.matches || !e.target.matches('[data-auf-feld]')) return;
      werteUebernehmen(formWerte());
    };
    document.addEventListener('input', horchen);
    document.addEventListener('change', horchen);
    werteUebernehmen(formWerte());
  }

  /* --------------------------------------------------------------- Start */

  zeitraumBinden();
  zeilenBinden();
  vorschauBinden();
  /* Nach aussen gereicht, damit Sonden dieselbe Rechnung abfragen können,
     die die Seite benutzt — eine Sonde, die die Formel nachbaut, prüft am
     Ende sich selbst. */
  window.srAuftritt = {
    masse: masse, einstellung: function () { return EINST; },
    vorfuehren: vorfuehren, zeilen: zeilenAuftritt
  };
  if (ruhig() || stumm()) return;
  auftreten();
  /* Was in keiner auftretenden Kachel liegt, baut sich sofort auf; der Rest
     hängt am Zeitgeber seiner Kachel (siehe auftreten()). */
  zeilenAuftritt(document, true);
})();

/* --------------------------- 23) Express-Briefing: Karten einklappen -------
 * Kapitel 01 „Dashboard", Reihe „Express Briefing" (Betreiber-Auftrag
 * 12.09.2026): beide Karten der Reihe bekommen im Kopf einen Klapp-Knopf.
 * Eingeklappt bleibt nur ein schmaler Streifen mit Titel und Meta stehen;
 * sind beide zu, ist die ganze Reihe ein Streifen mit zwei Titeln
 * nebeneinander.
 *
 * WARUM DER KNOPF HIER ENTSTEHT UND NICHT AUF DEM SERVER: die eine Karte
 * baut app/views/cockpit.js, die andere app/views/projekt.js — derselbe
 * Knopf an zwei Stellen waere zwei Fassungen, die auseinanderlaufen. Und
 * ohne JavaScript gibt es nichts zu klappen: dann stehen beide Karten offen,
 * und das ist die richtige Voreinstellung.
 *
 * NICHT ui.srKarte(einklappbar:true) MIT <details>: das schaltet sich still
 * ab, sobald die Kopfzeile etwas Bedienbares traegt (ein Knopf in einem
 * <summary> ist verschachtelte Interaktion). Beide Karten tragen ein
 * ⓘ-Popover im Kopf — <details> waere hier nie zum Zug gekommen.
 *
 * HOEHE OHNE GERATENE ZAHL: der Koerper liegt in einem Raster mit EINER
 * Zeile, die zwischen 1fr und 0fr wandert (cockpit.css .ck-klapp-schacht).
 * Am Ende der Bewegung bekommt der Inhalt `hidden` — er ist dann auch fuer
 * Tastatur und Screenreader weg, nicht nur unsichtbar.
 *
 * ZUSTAND JE KARTE in localStorage (`sr.ck.klapp.<karten-id>`), angewandt
 * BEVOR das erste Bild steht: app.js laeuft als defer-Script, also nach dem
 * Parsen und vor dem Zeichnen. Ein Zugriff auf localStorage kann werfen
 * (Privatfenster, gesperrte Seitendaten) — jeder Zugriff liegt deshalb in
 * try/catch, und ohne gespeicherten Zustand steht die Karte offen.
 */
(function () {
  var reihe = document.querySelector('[data-ck-briefing]');
  if (!reihe) return;

  var SCHLUESSEL = 'sr.ck.klapp.';
  var PFEIL = '<svg class="ck-klapp-pfeil" viewBox="0 0 12 12" fill="none" stroke="currentColor"'
    + ' stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<path d="M2.5 4.5 6 8l3.5-3.5"></path></svg>';

  function gemerkt(id) {
    try { return localStorage.getItem(SCHLUESSEL + id); } catch (e) { return null; }
  }
  function merken(id, wert) {
    try { localStorage.setItem(SCHLUESSEL + id, wert); } catch (e) { /* gesperrte Seitendaten */ }
  }

  /** Dauer der Hoehenbewegung in Millisekunden — 0 bei abgeschalteter Bewegung. */
  function dauerVon(el) {
    var t = getComputedStyle(el).transitionDuration || '0s';
    var erste = t.split(',')[0].trim();
    var zahl = parseFloat(erste) || 0;
    return erste.indexOf('ms') >= 0 ? zahl : zahl * 1000;
  }

  var karten = [];
  for (var i = 0; i < reihe.children.length; i++) {
    var el = reihe.children[i];
    if (el.classList && el.classList.contains('sr-karte')) karten.push(el);
  }
  if (!karten.length) return;

  karten.forEach(function (karte, nr) {
    var kopf = null;
    for (var k = 0; k < karte.children.length; k++) {
      if (karte.children[k].classList && karte.children[k].classList.contains('sr-karte-kopf')) {
        kopf = karte.children[k];
        break;
      }
    }
    if (!kopf) return;
    if (!karte.id) karte.id = 'ck-briefing-karte-' + (nr + 1);

    /* Alles hinter dem Kopf (Koerper und ggf. Fuss) wandert in den Schacht —
       nicht nur .sr-karte-koerper: ein Fuss, der beim Zuklappen stehen
       bliebe, waere ein zweiter Streifen ohne Inhalt darueber. */
    var schacht = document.createElement('div');
    schacht.className = 'ck-klapp-schacht';
    var inhalt = document.createElement('div');
    inhalt.className = 'ck-klapp-inhalt';
    schacht.appendChild(inhalt);
    var rest = [];
    var nach = kopf.nextSibling;
    while (nach) { rest.push(nach); nach = nach.nextSibling; }
    if (!rest.length) return;
    rest.forEach(function (n) { inhalt.appendChild(n); });
    karte.appendChild(schacht);
    schacht.id = karte.id + '-koerper';

    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'ck-klapp';
    knopf.setAttribute('aria-controls', schacht.id);
    knopf.innerHTML = PFEIL;
    kopf.appendChild(knopf);

    var titelEl = kopf.querySelector('.sr-karte-titel');
    var name = titelEl ? titelEl.textContent.trim() : 'Karte';
    var nachlauf = null;

    function beschriften(auf) {
      knopf.setAttribute('aria-expanded', auf ? 'true' : 'false');
      knopf.setAttribute('aria-label', (auf ? 'Einklappen: ' : 'Ausklappen: ') + name);
      knopf.title = auf ? 'Einklappen' : 'Ausklappen';
    }

    function setzen(auf, sofort) {
      beschriften(auf);
      if (nachlauf) { clearTimeout(nachlauf); nachlauf = null; }
      if (auf) {
        inhalt.hidden = false;
        if (sofort) { karte.removeAttribute('data-ck-zu'); return; }
        schacht.classList.add('ck-klapp-schacht--bewegt');
        /* ZWEI Frames: der erste laesst den Browser den 0fr-Zustand mit dem
           wieder sichtbaren Inhalt aufbauen, erst der zweite setzt 1fr —
           in einem Rutsch gaebe es keine Bewegung, sondern einen Sprung. */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { karte.removeAttribute('data-ck-zu'); });
        });
        nachlauf = setTimeout(function () {
          schacht.classList.remove('ck-klapp-schacht--bewegt');
        }, dauerVon(schacht) + 60);
        return;
      }
      karte.setAttribute('data-ck-zu', '1');
      if (sofort) { inhalt.hidden = true; return; }
      schacht.classList.add('ck-klapp-schacht--bewegt');
      nachlauf = setTimeout(function () {
        schacht.classList.remove('ck-klapp-schacht--bewegt');
        if (karte.getAttribute('data-ck-zu') === '1') inhalt.hidden = true;
      }, dauerVon(schacht) + 60);
    }

    knopf.addEventListener('click', function () {
      var offen = knopf.getAttribute('aria-expanded') === 'true';
      setzen(!offen, false);
      merken(karte.id, offen ? '1' : '0');
    });

    setzen(gemerkt(karte.id) !== '1', true);
  });
})();


/* KI-Vertiefung: bestehende Direktlinks öffnen ihre Auswertungen. */
(function () {
  'use strict';
  function zielOeffnen(hash) {
    var id;
    try { id = decodeURIComponent((hash || '').replace(/^#/, '')); } catch (_) { return; }
    var ziel = id && document.getElementById(id);
    var details = ziel && ziel.closest('details[data-ki-auswertungen]');
    if (!details) return;
    details.open = true;
    window.requestAnimationFrame(function () { ziel.scrollIntoView({ block: 'start' }); });
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href*="#"]');
    if (!link) return;
    var url;
    try { url = new URL(link.href, location.href); } catch (_) { return; }
    if (url.origin === location.origin && url.pathname === location.pathname && url.search === location.search) zielOeffnen(url.hash);
  });
  window.addEventListener('hashchange', function () { zielOeffnen(location.hash); });
  zielOeffnen(location.hash);
})();

/* ---------------------------------------- Einsatz-Matrix (22.10.2026) ----
 * Verwaltung → Intelligenz → Einsatz (app/views/ki-einsatz.js). Jede Zelle
 * speichert beim Umstellen sofort: POST /verwaltung/intelligenz/einsatz/zelle
 * mit {projekt, art, daten}, CSRF im Kopf. Die Zelle zeigt „gespeichert“ oder
 * den Fehler; bei einem Fehler springt sie auf den vorigen Wert zurück. Der
 * Gegenprüfer gilt für den Mandanten: nach dem Speichern übernehmen alle
 * Zeilen desselben Mandanten die Wahl.
 */
(function () {
  var rahmen = document.querySelector('[data-ke-matrix]');
  if (!rahmen) return;
  var url = rahmen.getAttribute('data-ke-url');
  var csrfFeld = rahmen.querySelector('input[name="_csrf"]');
  function wert(el) { return el.type === 'checkbox' ? el.checked : el.value; }
  function merken(zelle) {
    zelle.querySelectorAll('[data-ke-feld]').forEach(function (el) { el.setAttribute('data-ke-alt', String(wert(el))); });
  }
  function zuruecksetzen(zelle) {
    zelle.querySelectorAll('[data-ke-feld]').forEach(function (el) {
      var alt = el.getAttribute('data-ke-alt');
      if (el.type === 'checkbox') el.checked = alt === 'true'; else el.value = alt;
    });
  }
  function stufenFuellen(zelle) {
    var modell = zelle.querySelector('[data-ke-feld="modell"]');
    var stufe = zelle.querySelector('[data-ke-feld="stufe"]');
    if (!modell || !stufe) return;
    var opt = modell.options[modell.selectedIndex];
    var liste = [];
    try { liste = JSON.parse((opt && opt.getAttribute('data-stufen')) || '[]'); } catch (e) { liste = []; }
    var vorher = stufe.value;
    while (stufe.options.length > 1) stufe.remove(1);
    var TEXT = { minimal: 'minimal', low: 'niedrig', medium: 'mittel', high: 'hoch', xhigh: 'sehr hoch', max: 'maximal', ultra: 'ultra' };
    liste.forEach(function (s) { var o = document.createElement('option'); o.value = s; o.textContent = TEXT[s] || s; stufe.appendChild(o); });
    stufe.value = liste.indexOf(vorher) >= 0 ? vorher : '';
    stufe.disabled = !modell.value;
    // Leere Stufe nennt, was dann gilt: Vorgabe des Modells oder die des Mandanten.
    stufe.options[0].textContent = modell.value ? 'Vorgabe des Modells' : (stufe.getAttribute('data-ke-vorgabe') || 'Standard');
  }
  function daten(zelle, art) {
    var feld = function (n) { var el = zelle.querySelector('[data-ke-feld="' + n + '"]'); return el ? el : null; };
    if (art === 'kauz' || art === 'pruefer') {
      var teile = (feld('modell').value || '').split('|');
      return { profil: teile[0] || '', modell: teile[1] || '', stufe: feld('stufe') ? feld('stufe').value : '' };
    }
    if (art === 'sonde') return { zugang: zelle.getAttribute('data-ke-zugang'), an: feld('an').checked };
    if (art === 'aio') return { an: feld('an').checked };
    if (art === 'sentiment') return { zugang: feld('zugang').value, stufe: feld('stufe') ? feld('stufe').value : '' };
    return {};
  }
  function melden(zelle, text, fehler) {
    var s = zelle.querySelector('.ke-status');
    if (!s) return;
    s.textContent = text;
    s.classList.toggle('ke-status--fehler', !!fehler);
    if (!fehler) setTimeout(function () { if (s.textContent === text) s.textContent = ''; }, 2500);
  }
  rahmen.querySelectorAll('[data-ke-zelle]').forEach(merken);
  /* Auf dem Reiter Einsatz gilt nur der Mandantenfilter der Matrix; die
     Mandantenwahl im Seitenkopf betrifft die übrigen Reiter und ist dort aus. */
  var sektion = document.getElementById('einsatz');
  var kopfWahl = document.querySelector('.sr-kopf-mandant');
  function kopfAbgleichen() { if (kopfWahl && sektion) kopfWahl.hidden = sektion.getClientRects().length > 0 && !sektion.hidden; }
  if (sektion && kopfWahl && typeof MutationObserver === 'function') {
    new MutationObserver(kopfAbgleichen).observe(sektion, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    window.addEventListener('hashchange', kopfAbgleichen);
    document.addEventListener('click', function () { window.setTimeout(kopfAbgleichen, 0); });
    kopfAbgleichen();
  }
  rahmen.addEventListener('change', function (ev) {
    var el = ev.target;
    if (!el || !el.hasAttribute('data-ke-feld')) return;
    var zelle = el.closest('[data-ke-zelle]');
    if (!zelle) return;
    var art = zelle.getAttribute('data-ke-art');
    if ((art === 'kauz' || art === 'pruefer') && el.getAttribute('data-ke-feld') === 'modell') stufenFuellen(zelle);
    if (art === 'sentiment') {
      var st = zelle.querySelector('[data-ke-feld="stufe"]');
      var z = zelle.querySelector('[data-ke-feld="zugang"]');
      if (st && z) { st.disabled = z.value.indexOf('abo:') !== 0; if (st.disabled) st.value = ''; }
    }
    var felder = zelle.querySelectorAll('[data-ke-feld]');
    felder.forEach(function (f) { f.disabled = true; });
    melden(zelle, 'speichert …', false);
    fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'x-csrf-token': csrfFeld ? csrfFeld.value : '' },
      body: JSON.stringify({ projekt: zelle.getAttribute('data-ke-projekt'), art: art, daten: daten(zelle, art) })
    }).then(function (r) { return r.json().catch(function () { return { ok: false, fehler: 'Antwort nicht lesbar (HTTP ' + r.status + ').' }; }); })
      .then(function (j) {
        if (j && j.ok) {
          merken(zelle);
          melden(zelle, j.hinweis || 'gespeichert', false);
          if (art === 'pruefer') {
            var mandant = zelle.getAttribute('data-ke-mandant');
            rahmen.querySelectorAll('[data-ke-zelle][data-ke-art="pruefer"][data-ke-mandant="' + mandant + '"]').forEach(function (andere) {
              if (andere === zelle) return;
              andere.querySelector('[data-ke-feld="modell"]').value = zelle.querySelector('[data-ke-feld="modell"]').value;
              stufenFuellen(andere);
              andere.querySelector('[data-ke-feld="stufe"]').value = zelle.querySelector('[data-ke-feld="stufe"]').value;
              merken(andere);
            });
          }
        } else {
          zuruecksetzen(zelle);
          melden(zelle, (j && j.fehler) || 'Nicht gespeichert.', true);
        }
      })
      .catch(function () { zuruecksetzen(zelle); melden(zelle, 'Kauz360 nicht erreichbar.', true); })
      .then(function () {
        felder.forEach(function (f) { f.disabled = false; });
        // Gesperrte Ausgangszustände wiederherstellen (Stufe ohne Modell, nicht freigegebener Zugang).
        stufenFuellen(zelle);
        if (art === 'sentiment') {
          var st2 = zelle.querySelector('[data-ke-feld="stufe"]'); var z2 = zelle.querySelector('[data-ke-feld="zugang"]');
          if (st2 && z2) st2.disabled = z2.value.indexOf('abo:') !== 0;
        }
      });
  });
})();

})();

/* ---- passkey.js ---- */
(function(){
/* SEO-Radar — Passkey im Browser (WebAuthn, Betreiber-Entscheid 01.09.2026).
 *
 * Das Gegenstueck zu app/lib/webauthn.js. Die Aufgabe ist klein und genau
 * umrissen: der Server spricht JSON mit base64url-Strings, `navigator.credentials`
 * spricht ArrayBuffer. Dieses Modul uebersetzt in beide Richtungen und sonst
 * nichts — es faellt keine Entscheidung, die nicht auch der Server nochmal
 * prueft.
 *
 * KEINE FREMDE BIBLIOTHEK. Anders als auf der Serverseite (dort: CBOR, COSE,
 * X.509) ist hier nichts zu verstehen, was der Browser nicht schon koennte.
 * Die neueren Bordmittel `PublicKeyCredential.parseCreationOptionsFromJSON()`
 * und `credential.toJSON()` wuerden die Uebersetzung abnehmen, sind aber erst
 * ab Chrome 119 / Safari 17.4 da. Von Hand umgerechnet laeuft es ueberall,
 * wo WebAuthn ueberhaupt laeuft.
 *
 * PROGRESSIVE ENHANCEMENT wie im Rest der App: der Passkey-Knopf auf der
 * Anmeldeseite steht `hidden` im HTML und wird hier eingeblendet — und zwar
 * nur, wenn der Browser WebAuthn wirklich mitbringt. Ein Knopf, der nichts
 * tun kann, ist schlechter als kein Knopf.
 *
 * CSRF wie bei jedem POST der App: Token aus einem vorhandenen `_csrf`-Feld,
 * als Kopfzeile `x-csrf-token` (auth.csrfOk() akzeptiert beide Wege).
 */
(function () {
  'use strict';

  // Ohne WebAuthn passiert hier gar nichts — weder Knopf noch Formularhaken.
  if (!window.PublicKeyCredential || !navigator.credentials) return;

  /* ------------------------------------------------------ base64url <-> Bytes */

  function pkB64urlZuBytes(s) {
    var roh = atob(String(s).replace(/-/g, '+').replace(/_/g, '/'));
    var bytes = new Uint8Array(roh.length);
    for (var i = 0; i < roh.length; i++) bytes[i] = roh.charCodeAt(i);
    return bytes;
  }

  function pkBytesZuB64url(buf) {
    var bytes = new Uint8Array(buf);
    var s = '';
    for (var i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  /* ----------------------------------------------------------------- Transport */

  function pkCsrf() {
    var feld = document.querySelector('input[name="_csrf"]');
    return feld ? feld.value : '';
  }

  /**
   * POST mit JSON-Rumpf. Liefert `{ok, daten}` — der Fehlerfall kommt als
   * `daten.fehler`, und wenn der Server statt JSON eine Fehlerseite schickt
   * (403 der CSRF-Schranke), bleibt es bei einer verstaendlichen Meldung
   * statt einem Parser-Fehler in der Konsole.
   */
  function pkSenden(pfad, rumpf) {
    return fetch(pfad, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'x-csrf-token': pkCsrf() },
      body: JSON.stringify(rumpf || {})
    }).then(function (r) {
      return r.text().then(function (text) {
        var daten = {};
        try { daten = JSON.parse(text); } catch (e) {
          daten = { fehler: 'Die Seite war zu lange offen. Bitte neu laden und erneut versuchen.' };
        }
        return { ok: r.ok, daten: daten };
      });
    });
  }

  /* --------------------------------------------------- Optionen und Antworten */

  /** Was der Server als base64url schickt, braucht der Browser als Bytes. */
  function pkOptionenAufbereiten(o) {
    o.challenge = pkB64urlZuBytes(o.challenge);
    if (o.user && o.user.id) o.user.id = pkB64urlZuBytes(o.user.id);
    ['excludeCredentials', 'allowCredentials'].forEach(function (feld) {
      if (!Array.isArray(o[feld])) return;
      o[feld] = o[feld].map(function (c) {
        c.id = pkB64urlZuBytes(c.id);
        return c;
      });
    });
    return o;
  }

  /**
   * Und zurueck. `cred.id` ist bereits base64url — der Browser vergibt sie so,
   * und genau dieser String steht in webauthn_zugangsdaten.credential_id.
   */
  function pkAntwortVerpacken(cred, anmeldung) {
    var r = cred.response;
    var antwort = {
      id: cred.id,
      rawId: pkBytesZuB64url(cred.rawId),
      type: cred.type,
      clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
      response: { clientDataJSON: pkBytesZuB64url(r.clientDataJSON) }
    };
    if (cred.authenticatorAttachment) antwort.authenticatorAttachment = cred.authenticatorAttachment;

    if (anmeldung) {
      antwort.response.authenticatorData = pkBytesZuB64url(r.authenticatorData);
      antwort.response.signature = pkBytesZuB64url(r.signature);
      // userHandle darf fehlen, aber nicht null sein: die Pruefung auf der
      // Serverseite unterscheidet „nicht mitgeliefert" von „leer".
      if (r.userHandle) antwort.response.userHandle = pkBytesZuB64url(r.userHandle);
    } else {
      antwort.response.attestationObject = pkBytesZuB64url(r.attestationObject);
      antwort.response.transports = r.getTransports ? r.getTransports() : [];
    }
    return antwort;
  }

  /**
   * Abbruch durch den Anwender ist KEIN Fehler. Wer im Systemdialog auf
   * „Abbrechen" tippt, hat eine Entscheidung getroffen — dafuer eine rote
   * Meldung zu zeigen, waere Bevormundung. Alles andere wird benannt.
   */
  function pkFehlertext(err) {
    var name = err && err.name;
    if (name === 'NotAllowedError' || name === 'AbortError') return null;
    if (name === 'InvalidStateError') return 'Auf diesem Gerät ist für dieses Konto bereits ein Passkey hinterlegt.';
    if (name === 'SecurityError') return 'Der Passkey ist an die Adresse dieser Seite gebunden und wurde hier nicht angeboten.';
    return 'Passkey nicht möglich: ' + String((err && err.message) || err);
  }

  /* ------------------------------------------- 1) Passkey anlegen (Kontoseite) */

  (function () {
    var form = document.querySelector('[data-passkey-form]');
    if (!form) return;
    var knopf = form.querySelector('[data-passkey-anlegen]');
    var passkeyKnopf = form.querySelector('[data-passkey-stepup]');
    var meldung = form.querySelector('[data-passkey-meldung]');
    var namensfeld = form.querySelector('input[name="name"]');
    var passwortFeld = form.querySelector('input[name="passwort"]');

    function sagen(text, fehler) {
      if (!meldung) return;
      meldung.textContent = text || '';
      meldung.hidden = !text;
      meldung.classList.toggle('app-fuss--fehler', !!fehler);
    }

    function sperren(an) {
      if (knopf) knopf.disabled = an;
      if (passkeyKnopf) passkeyKnopf.disabled = an;
      if (an) sagen('Die Identität wird bestätigt …', false);
    }

    function nameLesen() {
      var name = namensfeld ? namensfeld.value.trim() : '';
      if (!name) sagen('Bitte einen Namen für dieses Gerät angeben.', true);
      return name;
    }

    function registrieren(name) {
      sagen('Der Browser fragt jetzt nach dem neuen Gerät …', false);
      return pkSenden('/konto/passkey/start', {}).then(function (start) {
        if (!start.ok) throw new Error(start.daten.fehler || 'Vorgang nicht möglich.');
        return navigator.credentials.create({ publicKey: pkOptionenAufbereiten(start.daten) });
      }).then(function (cred) {
        return pkSenden('/konto/passkey/anlegen', { name: name, antwort: pkAntwortVerpacken(cred, false) });
      }).then(function (fertig) {
        if (!fertig.ok) throw new Error(fertig.daten.fehler || 'Passkey nicht angenommen.');
        // Neu laden statt die Tabelle nachzupflegen: die Zeile bringt Angaben
        // mit, die nur der Server kennt (Geraetetyp, gesichert ja/nein).
        window.location.reload();
      });
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var name = nameLesen();
      var passwort = passwortFeld ? passwortFeld.value : '';
      if (!name) return;
      if (!passwortFeld) { sagen('Bitte mit einem vorhandenen Passkey bestätigen.', true); return; }
      if (!passwort) { sagen('Bitte das aktuelle Passwort eingeben.', true); return; }
      sperren(true);
      pkSenden('/konto/passkey/stepup/passwort', { passwort: passwort }).then(function (r) {
        if (!r.ok) throw new Error(r.daten.fehler || 'Bestätigung nicht möglich.');
        if (passwortFeld) passwortFeld.value = '';
        return registrieren(name);
      }).catch(function (err) {
        sperren(false);
        var text = pkFehlertext(err);
        sagen(text || 'Abgebrochen.', !!text);
      });
    });

    if (passkeyKnopf) passkeyKnopf.addEventListener('click', function () {
      var name = nameLesen();
      if (!name) return;
      sperren(true);
      pkSenden('/konto/passkey/stepup/passkey/start', {}).then(function (start) {
        if (!start.ok) throw new Error(start.daten.fehler || 'Bestätigung nicht möglich.');
        return navigator.credentials.get({ publicKey: pkOptionenAufbereiten(start.daten) });
      }).then(function (cred) {
        return pkSenden('/konto/passkey/stepup/passkey/pruefen', {
          antwort: pkAntwortVerpacken(cred, true)
        });
      }).then(function (r) {
        if (!r.ok) throw new Error(r.daten.fehler || 'Bestätigung nicht möglich.');
        return registrieren(name);
      }).catch(function (err) {
        sperren(false);
        var text = pkFehlertext(err);
        sagen(text || 'Abgebrochen.', !!text);
      });
    });
  })();

  /* -------------------------------------- 2) Mit Passkey anmelden (Anmeldeseite) */

  (function () {
    var knopf = document.querySelector('[data-passkey-login]');
    if (!knopf) return;
    var block = document.querySelector('[data-passkey-block]') || knopf;
    var meldung = document.querySelector('[data-passkey-login-meldung]');
    var weiterFeld = document.querySelector('.anmelde-form input[name="weiter"]');
    // „Angemeldet bleiben" steht ueber dem Trenner und gilt fuer BEIDE Wege
    // (Auftrag 04.09.2026). Ein Haken, der nur fuer das Passwortfeld zaehlt,
    // waere ein Haken, der auf halbem Weg vergessen wird.
    var bleibenFeld = document.querySelector('[data-anmelde-bleiben]');

    // Erst hier sichtbar: ohne WebAuthn bleibt der Knopf weg (siehe Modulkopf).
    block.hidden = false;

    function sagen(text) {
      if (!meldung) return;
      meldung.textContent = text || '';
      meldung.hidden = !text;
    }

    knopf.addEventListener('click', function (ev) {
      ev.preventDefault();
      knopf.disabled = true;
      sagen('');

      pkSenden('/login/passkey/start', {}).then(function (start) {
        if (!start.ok) throw new Error(start.daten.fehler || 'Anmeldung nicht möglich.');
        return navigator.credentials.get({ publicKey: pkOptionenAufbereiten(start.daten) });
      }).then(function (cred) {
        return pkSenden('/login/passkey/pruefen', {
          antwort: pkAntwortVerpacken(cred, true),
          weiter: weiterFeld ? weiterFeld.value : '',
          dauerhaft: !!(bleibenFeld && bleibenFeld.checked)
        });
      }).then(function (fertig) {
        if (!fertig.ok) throw new Error(fertig.daten.fehler || 'Anmeldung nicht möglich.');
        window.location.assign(fertig.daten.weiter || '/');
      }).catch(function (err) {
        knopf.disabled = false;
        sagen(pkFehlertext(err) || '');
      });
    });
  })();

})();

})();

/* ---- anmeldung-buehne.js ---- */
(function(){
/* Anmeldebuehne (app/views/anmeldung-buehne.css): der Satz zu „Angemeldet
 * bleiben" klappt in der schmalen Fassung hinter einen ⓘ-Knopf.
 *
 * PROGRESSIVE ENHANCEMENT: der Knopf steht `hidden` im HTML. Ohne Skript
 * bleibt der Satz offen in der Karte stehen — lesbar, nur weniger ruhig.
 * Mit Skript setzt dieses Modul am Formular die Klasse anmelde-info-bereit;
 * das Einklappen selbst regelt das Stylesheet nur unterhalb von 900 px, die
 * breite Leiste behaelt ihren Schwebetext. Fuer Screenreader haengt der Satz
 * unabhaengig davon per aria-describedby am Haken.
 */
'use strict';
var knopf = document.querySelector('[data-anmelde-info]');
var form = knopf && knopf.closest('.anmelde-form');
if (knopf && form) {
  form.classList.add('anmelde-info-bereit');
  knopf.hidden = false;
  knopf.addEventListener('click', function () {
    var offen = form.classList.toggle('anmelde-info-offen');
    knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
  });
}

/* Echte Links bleiben ohne Dialog-Unterstuetzung als Vollfassungen nutzbar.
 * showModal sperrt den Hintergrund; die Tab-Grenzen und Rueckfokus sind
 * zusaetzlich explizit, auch wenn im Dialog ein Link angesprungen wurde. */
(function () {
  if (!document.body.matches('.body--buehne, .login-v2, .login-v3')) return;
  document.querySelectorAll('[data-recht-modal]').forEach(function (link) {
    var dialog = document.getElementById('buehne-recht-' + link.dataset.rechtModal);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var ausloeser = null;
    link.addEventListener('click', function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      ausloeser = link;
      dialog.showModal();
      dialog.querySelector('[data-recht-schliessen]').focus({ preventScroll: true });
    });
    dialog.querySelector('[data-recht-schliessen]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); dialog.close(); });
    dialog.addEventListener('close', function () {
      if (ausloeser && ausloeser.isConnected) ausloeser.focus({ preventScroll: true });
    });
    var aussenStart = false;
    function ausserhalb(e) {
      var r = dialog.getBoundingClientRect();
      return e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
    }
    dialog.addEventListener('pointerdown', function (e) { aussenStart = e.target === dialog && ausserhalb(e); });
    dialog.addEventListener('click', function (e) {
      if (aussenStart && e.target === dialog && ausserhalb(e)) dialog.close();
      aussenStart = false;
    });
    dialog.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var ziele = Array.from(dialog.querySelectorAll('a[href],button:not([disabled]),[tabindex="0"]'))
        .filter(function (el) { return el.getClientRects().length > 0; });
      var erstes = ziele[0], letztes = ziele[ziele.length - 1];
      if (e.shiftKey && document.activeElement === erstes) { e.preventDefault(); letztes.focus(); }
      else if (!e.shiftKey && document.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
    });
  });
})();

/* Mesh-Vertrag: zwei Oberlider mit jeweils 101 gelieferten Frames.
 * Erst nach dem Dekodieren aller Ebenen wird die SVG-Auflage sichtbar.
 * Das statische Motiv darunter bleibt bei Ladefehlern nutzbar. SVG-
 * Geometrie und display-Attribute benoetigen keine style-Attribute. */
(function () {
  var svg = document.querySelector('svg[data-buehne-augen]');
  if (!svg) return;
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');
  var touch = window.matchMedia('(hover: none), (pointer: coarse)');
  var festeBrauen = !!svg.querySelector('[data-v4-brauen]');
  var augen;
  try {
    augen = Array.from(svg.querySelectorAll('[data-eye]')).map(function (el) {
      var id = 'image-' + el.dataset.eye;
      var oberlid = svg.querySelector('#' + id + '-upper-active');
      return { el: svg.querySelector('#' + id + '-motion'), oberlid: oberlid,
        oeffnung: svg.querySelector('#' + id + '-opening-path'),
        unterlid: svg.querySelector('#' + id + '-lower-clip-frame'),
        clip: 'url(#' + id + '-opening-clip)',
        quelle: oberlid.getAttribute('data-src').replace(/000\.webp$/, ''),
        offen: JSON.parse(el.dataset.openEdge), unten: JSON.parse(el.dataset.bottomEdge),
        cx: Number(el.dataset.cx), cy: Number(el.dataset.cy),
        maxX: Number(el.dataset.maxX), maxY: Number(el.dataset.maxY), x: 0, y: 0 };
    });
    if (augen.length !== 2 || augen.some(function (a) {
      return !a.el || !a.oeffnung || !a.unterlid || !a.offen.length || a.offen.length !== a.unten.length
        || ![a.cx, a.cy, a.maxX, a.maxY].every(Number.isFinite)
        || a.maxX <= 0 || a.maxY <= 0;
    })) return;
  } catch (_) { return; }
  var bereit = false, aktiv = false, frame = 0, timer = 0, blinkStart = null, vorher = 0;
  var ziel = null, fokus = null, keyframe = -1, ganzGeschlossen = false;
  var bilder = []; // Dekodierte Frames fuer wiederholte Zyklen halten.
  function bildUrl(a, n) { return a.quelle + String(n).padStart(3, '0') + '.webp'; }
  function deckung(n) {
    if (n === keyframe) return;
    keyframe = n;
    // Vor dem Vorladen darf auch eine Zustandsaenderung keine Bilder holen.
    if (!bereit) return;
    augen.forEach(function (a) {
      var anteil = n / 100;
      var kante = a.offen.map(function (p, i) { return [p[0], p[1] + (a.unten[i][1] - p[1]) * anteil]; });
      var polygon = kante.concat(a.unten.slice().reverse());
      a.oeffnung.setAttribute('d', 'M ' + polygon.map(function (p) { return p.join(','); }).join(' L ') + ' Z');
      a.oberlid.setAttribute('href', bildUrl(a, n));
      a.oberlid.setAttribute('data-progress', String(n));
      a.unterlid.setAttribute('display', n === 100 ? 'none' : 'inline');
      if (n === 0) a.unterlid.removeAttribute('clip-path');
      else a.unterlid.setAttribute('clip-path', a.clip);
    });
    svg.setAttribute('data-keyframe', String(n));
  }
  function ruhestellung() {
    augen.forEach(function (a) { a.x = a.y = 0; a.el.setAttribute('transform', 'translate(0 0)'); });
    deckung(0);
  }
  function anfordern() { if (aktiv && !frame) frame = requestAnimationFrame(zeichnen); }
  function zeichnen(zeit) {
    frame = 0;
    if (!aktiv) return;
    var dt = vorher ? Math.min(zeit - vorher, 64) : 16;
    vorher = zeit;
    var punkt = ziel;
    if (touch.matches && fokus && fokus.isConnected) {
      var feld = fokus.getBoundingClientRect();
      punkt = { x: feld.left + feld.width / 2, y: feld.top + feld.height / 2 };
    }
    var matrix = svg.getScreenCTM(), master = null;
    if (punkt && matrix) {
      var p = svg.createSVGPoint(); p.x = punkt.x; p.y = punkt.y;
      master = p.matrixTransform(matrix.inverse());
    }
    var weiter = false;
    augen.forEach(function (a) {
      var dx = master ? (master.x - a.cx) / 260 : 0;
      var dy = master ? (master.y - a.cy) / 260 : 0;
      var laenge = Math.max(1, Math.hypot(dx, dy));
      var x = dx / laenge * a.maxX, y = dy / laenge * a.maxY;
      var anteil = 1 - Math.exp(-dt / 95);
      a.x += (x - a.x) * anteil; a.y += (y - a.y) * anteil;
      if (Math.abs(x - a.x) + Math.abs(y - a.y) > 0.02) weiter = true;
      a.el.setAttribute('transform', 'translate(' + a.x.toFixed(3) + ' ' + a.y.toFixed(3) + ')');
    });
    if (blinkStart !== null) {
      var t = zeit - blinkStart;
      // 0..100..0: dieselbe 8-ms-Folge wie im freigegebenen Rundaugen-Master.
      var schluss = t < 800 ? t / 800 : Math.max(0, (1600 - t) / 800);
      // V4 passiert den verdeckten oberen Lidweg zuegiger. So bleibt
      // die sichtbare Bewegung trotz fester Braue lesbar; Zyklusdauer,
      // erster Start und Takt bleiben 1600/5000/16000 ms wie bei V1.
      // V1 behaelt seinen linearen Meshverlauf.
      var sichtbarerWeg = festeBrauen ? 1 - Math.pow(1 - schluss, 2) : schluss;
      var stufe = Math.round(Math.min(1, sichtbarerWeg) * 100);
      // Auch bei niedriger Bildrate muss die geschlossene Endlage vorkommen.
      if (t >= 800 && !ganzGeschlossen) stufe = 100;
      if (stufe === 100) ganzGeschlossen = true;
      deckung(stufe);
      if (t >= 1600) { blinkStart = null; deckung(0); } else weiter = true;
    }
    if (weiter) anfordern(); else vorher = 0;
  }
  function naechstesBlinken(ms) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (!aktiv) return;
      blinkStart = performance.now(); ganzGeschlossen = false;
      anfordern(); naechstesBlinken(16000);
    }, ms);
  }
  function zustand() {
    aktiv = bereit && !ruhig.matches && !document.hidden;
    clearTimeout(timer); cancelAnimationFrame(frame); frame = 0; vorher = 0; blinkStart = null;
    ruhestellung();
    if (aktiv) { anfordern(); naechstesBlinken(5000); }
  }
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType === 'touch' || touch.matches) return;
    ziel = { x: e.clientX, y: e.clientY }; anfordern();
  }, { passive: true });
  document.addEventListener('mouseleave', function () { ziel = null; anfordern(); });
  document.addEventListener('focusin', function (e) {
    if (!e.target.matches('input:not([type="hidden"]),button,a')) return;
    fokus = e.target; if (touch.matches) anfordern();
  });
  window.addEventListener('resize', anfordern);
  window.addEventListener('scroll', anfordern, { passive: true });
  ruhig.addEventListener('change', zustand);
  document.addEventListener('visibilitychange', zustand);
  window.addEventListener('pagehide', function () { aktiv = false; clearTimeout(timer); cancelAnimationFrame(frame); frame = 0; });
  window.addEventListener('pageshow', function (e) { if (e.persisted) zustand(); });
  function laden(url) {
    return new Promise(function (resolve, reject) {
      var bild = new Image();
      bilder.push(bild);
      bild.onload = function () {
        if (bild.naturalWidth !== 1024 || bild.naturalHeight !== 1024) { reject(new Error('Augenformat')); return; }
        (bild.decode ? bild.decode() : Promise.resolve()).then(resolve, reject);
      };
      bild.onerror = function () { reject(new Error('Augenebene')); };
      bild.src = url;
    });
  }
  var ebenen = Array.from(svg.querySelectorAll('image'));
  var urls = new Set(ebenen.map(function (el) { return el.getAttribute('data-src'); }));
  augen.forEach(function (a) { for (var n = 0; n <= 100; n++) urls.add(bildUrl(a, n)); });
  function vorladen() {
    var liste = Array.from(urls), index = 0, fehlgeschlagen = false;
    function naechste() {
      if (fehlgeschlagen || index === liste.length) return Promise.resolve();
      return laden(liste[index++]).then(naechste);
    }
    // Vier parallele Dekodierungen lassen der Anmeldemaske Rechenzeit.
    Promise.all([naechste(), naechste(), naechste(), naechste()]).then(function () {
      ebenen.forEach(function (el) { el.setAttribute('href', el.getAttribute('data-src')); });
      requestAnimationFrame(function () {
        bereit = true; keyframe = -1; fokus = document.activeElement;
        svg.setAttribute('data-preloaded-frame-count', '202');
        svg.setAttribute('data-mesh-ready', 'true');
        zustand();
      });
    }).catch(function () {
      fehlgeschlagen = true;
      svg.setAttribute('data-mesh-ready', 'error');
      bereit = false; zustand();
    });
  }
  function nachBuehnenaufbau() {
    // Das Motiv beginnt nach dem ersten Layout, damit das Formular Vorrang hat.
    // Lazy-Bilder gehoeren nicht zu window.load: deshalb separat auf die
    // Dekodierung warten, bevor die 202 Lidframes Bandbreite beanspruchen.
    var motiv = document.querySelector('.buehne-motiv-bild');
    var sichtbar = motiv && motiv.decode ? motiv.decode() : Promise.resolve();
    sichtbar.then(function () {
      requestAnimationFrame(function () { requestAnimationFrame(vorladen); });
    }).catch(function () { svg.setAttribute('data-mesh-ready', 'error'); });
  }
  if (document.readyState === 'complete') nachBuehnenaufbau();
  else window.addEventListener('load', nachBuehnenaufbau, { once: true });
})();

})();
